webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(9);
	
	var _frontUtilsCheckDeviceJs = __webpack_require__(10);
	
	var _frontUtilsCheckDeviceJs2 = _interopRequireDefault(_frontUtilsCheckDeviceJs);
	
	var _frontRouterJs = __webpack_require__(12);
	
	var _frontRouterJs2 = _interopRequireDefault(_frontRouterJs);
	
	__webpack_require__(102);
	
	__webpack_require__(36);
	
	var _frontComponentsParallaxParallaxJs = __webpack_require__(103);
	
	var _frontComponentsParallaxParallaxJs2 = _interopRequireDefault(_frontComponentsParallaxParallaxJs);
	
	var _frontComponentsBtnSideBtnSideJs = __webpack_require__(61);
	
	var _frontComponentsBtnSideBtnSideJs2 = _interopRequireDefault(_frontComponentsBtnSideBtnSideJs);
	
	var _frontComponentsBtnCloseBtnCloseJs = __webpack_require__(56);
	
	var _frontComponentsBtnCloseBtnCloseJs2 = _interopRequireDefault(_frontComponentsBtnCloseBtnCloseJs);
	
	var _frontComponentsBtnLoadBtnLoadJs = __webpack_require__(106);
	
	var _frontComponentsBtnLoadBtnLoadJs2 = _interopRequireDefault(_frontComponentsBtnLoadBtnLoadJs);
	
	var _frontComponentsFrameFrameJs = __webpack_require__(23);
	
	var _frontComponentsFrameFrameJs2 = _interopRequireDefault(_frontComponentsFrameFrameJs);
	
	var _frontComponentsHeaderLinkHeaderLinkJs = __webpack_require__(108);
	
	var _frontComponentsHeaderLinkHeaderLinkJs2 = _interopRequireDefault(_frontComponentsHeaderLinkHeaderLinkJs);
	
	var _frontComponentsIntroTextIntroTextJs = __webpack_require__(70);
	
	var _frontComponentsIntroTextIntroTextJs2 = _interopRequireDefault(_frontComponentsIntroTextIntroTextJs);
	
	var _frontComponentsPersonPersonJs = __webpack_require__(92);
	
	var _frontComponentsPersonPersonJs2 = _interopRequireDefault(_frontComponentsPersonPersonJs);
	
	var _frontComponentsLogoItemLogoItemJs = __webpack_require__(110);
	
	var _frontComponentsLogoItemLogoItemJs2 = _interopRequireDefault(_frontComponentsLogoItemLogoItemJs);
	
	var _frontComponentsLogoLogoJs = __webpack_require__(112);
	
	var _frontComponentsLogoLogoJs2 = _interopRequireDefault(_frontComponentsLogoLogoJs);
	
	var _frontComponentsNavNavJs = __webpack_require__(114);
	
	var _frontComponentsNavNavJs2 = _interopRequireDefault(_frontComponentsNavNavJs);
	
	var _frontComponentsApplicationPopupApplicationPopupJs = __webpack_require__(116);
	
	var _frontComponentsApplicationPopupApplicationPopupJs2 = _interopRequireDefault(_frontComponentsApplicationPopupApplicationPopupJs);
	
	var _frontComponentsLangsLangsJs = __webpack_require__(119);
	
	var _frontComponentsLangsLangsJs2 = _interopRequireDefault(_frontComponentsLangsLangsJs);
	
	var _frontComponentsCookieCookieJs = __webpack_require__(122);
	
	var _frontComponentsCookieCookieJs2 = _interopRequireDefault(_frontComponentsCookieCookieJs);
	
	window.app.isRetina = false;
	_frontUtilsCheckDeviceJs2['default'].initialize();
	
	window.app.router = new _frontRouterJs2['default']();
	
	window.app.vent = _underscoreUnderscore2['default'].extend({}, _backboneBackbone2['default'].Events);
	
	window.app.els = {
	    $window: $(window),
	    $body: $('body'),
	    $htmlBody: $('html,body'),
	    $content: $('.Content')
	};
	
	window.app.views = {
	    nav: new _frontComponentsNavNavJs2['default'](),
	    applicationPopup: new _frontComponentsApplicationPopupApplicationPopupJs2['default'](),
	    langs: new _frontComponentsLangsLangsJs2['default'](),
	    logo: new _frontComponentsLogoLogoJs2['default'](),
	    cookie: new _frontComponentsCookieCookieJs2['default']()
	};
	
	app.vent.on('page.loaded', window.app.loader.deactivate.bind(window.app.loader));
	
	window.app.router.start();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */,
/* 7 */
5,
/* 8 */
5,
/* 9 */
5,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var FastClick = __webpack_require__(11);
	
	var CheckDevice = {
	    initialize: function initialize() {
	        var isHighDensity = this.isHighDensity();
	
	        if (isHighDensity) {
	            window.app.isRetina = true;
	            var html = document.querySelector('html');
	            html.className = html.className + ' isRetina';
	        }
	    },
	
	    isHighDensity: function isHighDensity() {
	        return window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
	    }
	};
	
	exports['default'] = CheckDevice;
	module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
		'use strict';
	
		/**
		 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
		 *
		 * @codingstandard ftlabs-jsv2
		 * @copyright The Financial Times Limited [All Rights Reserved]
		 * @license MIT License (see LICENSE.txt)
		 */
	
		/*jslint browser:true, node:true*/
		/*global define, Event, Node*/
	
	
		/**
		 * Instantiate fast-clicking listeners on the specified layer.
		 *
		 * @constructor
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		function FastClick(layer, options) {
			var oldOnClick;
	
			options = options || {};
	
			/**
			 * Whether a click is currently being tracked.
			 *
			 * @type boolean
			 */
			this.trackingClick = false;
	
	
			/**
			 * Timestamp for when click tracking started.
			 *
			 * @type number
			 */
			this.trackingClickStart = 0;
	
	
			/**
			 * The element being tracked for a click.
			 *
			 * @type EventTarget
			 */
			this.targetElement = null;
	
	
			/**
			 * X-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartX = 0;
	
	
			/**
			 * Y-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartY = 0;
	
	
			/**
			 * ID of the last touch, retrieved from Touch.identifier.
			 *
			 * @type number
			 */
			this.lastTouchIdentifier = 0;
	
	
			/**
			 * Touchmove boundary, beyond which a click will be cancelled.
			 *
			 * @type number
			 */
			this.touchBoundary = options.touchBoundary || 10;
	
	
			/**
			 * The FastClick layer.
			 *
			 * @type Element
			 */
			this.layer = layer;
	
			/**
			 * The minimum time between tap(touchstart and touchend) events
			 *
			 * @type number
			 */
			this.tapDelay = options.tapDelay || 200;
	
			/**
			 * The maximum time for a tap
			 *
			 * @type number
			 */
			this.tapTimeout = options.tapTimeout || 700;
	
			if (FastClick.notNeeded(layer)) {
				return;
			}
	
			// Some old versions of Android don't have Function.prototype.bind
			function bind(method, context) {
				return function() { return method.apply(context, arguments); };
			}
	
	
			var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
			var context = this;
			for (var i = 0, l = methods.length; i < l; i++) {
				context[methods[i]] = bind(context[methods[i]], context);
			}
	
			// Set up event handlers as required
			if (deviceIsAndroid) {
				layer.addEventListener('mouseover', this.onMouse, true);
				layer.addEventListener('mousedown', this.onMouse, true);
				layer.addEventListener('mouseup', this.onMouse, true);
			}
	
			layer.addEventListener('click', this.onClick, true);
			layer.addEventListener('touchstart', this.onTouchStart, false);
			layer.addEventListener('touchmove', this.onTouchMove, false);
			layer.addEventListener('touchend', this.onTouchEnd, false);
			layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
			// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
			// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
			// layer when they are cancelled.
			if (!Event.prototype.stopImmediatePropagation) {
				layer.removeEventListener = function(type, callback, capture) {
					var rmv = Node.prototype.removeEventListener;
					if (type === 'click') {
						rmv.call(layer, type, callback.hijacked || callback, capture);
					} else {
						rmv.call(layer, type, callback, capture);
					}
				};
	
				layer.addEventListener = function(type, callback, capture) {
					var adv = Node.prototype.addEventListener;
					if (type === 'click') {
						adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
							if (!event.propagationStopped) {
								callback(event);
							}
						}), capture);
					} else {
						adv.call(layer, type, callback, capture);
					}
				};
			}
	
			// If a handler is already declared in the element's onclick attribute, it will be fired before
			// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
			// adding it as listener.
			if (typeof layer.onclick === 'function') {
	
				// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
				// - the old one won't work if passed to addEventListener directly.
				oldOnClick = layer.onclick;
				layer.addEventListener('click', function(event) {
					oldOnClick(event);
				}, false);
				layer.onclick = null;
			}
		}
	
		/**
		* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
		*
		* @type boolean
		*/
		var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
	
		/**
		 * Android requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS 4 requires an exception for select elements.
		 *
		 * @type boolean
		 */
		var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);
	
	
		/**
		 * iOS 6.0-7.* requires the target element to be manually derived
		 *
		 * @type boolean
		 */
		var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);
	
		/**
		 * BlackBerry requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;
	
		/**
		 * Determine whether a given element requires a native click.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element needs a native click
		 */
		FastClick.prototype.needsClick = function(target) {
			switch (target.nodeName.toLowerCase()) {
	
			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}
	
				break;
			case 'input':
	
				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if ((deviceIsIOS && target.type === 'file') || target.disabled) {
					return true;
				}
	
				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
			}
	
			return (/\bneedsclick\b/).test(target.className);
		};
	
	
		/**
		 * Determine whether a given element requires a call to focus to simulate click into element.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
		 */
		FastClick.prototype.needsFocus = function(target) {
			switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
				case 'button':
				case 'checkbox':
				case 'file':
				case 'image':
				case 'radio':
				case 'submit':
					return false;
				}
	
				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/).test(target.className);
			}
		};
	
	
		/**
		 * Send a click event to the specified element.
		 *
		 * @param {EventTarget|Element} targetElement
		 * @param {Event} event
		 */
		FastClick.prototype.sendClick = function(targetElement, event) {
			var clickEvent, touch;
	
			// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
			if (document.activeElement && document.activeElement !== targetElement) {
				document.activeElement.blur();
			}
	
			touch = event.changedTouches[0];
	
			// Synthesise a click event, with an extra attribute so it can be tracked
			clickEvent = document.createEvent('MouseEvents');
			clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
			clickEvent.forwardedTouchEvent = true;
			targetElement.dispatchEvent(clickEvent);
		};
	
		FastClick.prototype.determineEventType = function(targetElement) {
	
			//Issue #159: Android Chrome Select Box does not open with a synthetic click event
			if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
				return 'mousedown';
			}
	
			return 'click';
		};
	
	
		/**
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.focus = function(targetElement) {
			var length;
	
			// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
			if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
				length = targetElement.value.length;
				targetElement.setSelectionRange(length, length);
			} else {
				targetElement.focus();
			}
		};
	
	
		/**
		 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
		 *
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.updateScrollParent = function(targetElement) {
			var scrollParent, parentElement;
	
			scrollParent = targetElement.fastClickScrollParent;
	
			// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
			// target element was moved to another parent.
			if (!scrollParent || !scrollParent.contains(targetElement)) {
				parentElement = targetElement;
				do {
					if (parentElement.scrollHeight > parentElement.offsetHeight) {
						scrollParent = parentElement;
						targetElement.fastClickScrollParent = parentElement;
						break;
					}
	
					parentElement = parentElement.parentElement;
				} while (parentElement);
			}
	
			// Always update the scroll top tracker if possible.
			if (scrollParent) {
				scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
			}
		};
	
	
		/**
		 * @param {EventTarget} targetElement
		 * @returns {Element|EventTarget}
		 */
		FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
	
			// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
			if (eventTarget.nodeType === Node.TEXT_NODE) {
				return eventTarget.parentNode;
			}
	
			return eventTarget;
		};
	
	
		/**
		 * On touch start, record the position and scroll offset.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchStart = function(event) {
			var targetElement, touch, selection;
	
			// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
			if (event.targetTouches.length > 1) {
				return true;
			}
	
			targetElement = this.getTargetElementFromEventTarget(event.target);
			touch = event.targetTouches[0];
	
			if (deviceIsIOS) {
	
				// Only trusted events will deselect text on iOS (issue #49)
				selection = window.getSelection();
				if (selection.rangeCount && !selection.isCollapsed) {
					return true;
				}
	
				if (!deviceIsIOS4) {
	
					// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
					// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
					// with the same identifier as the touch event that previously triggered the click that triggered the alert.
					// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
					// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
					// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
					// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
					// random integers, it's safe to to continue if the identifier is 0 here.
					if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
						event.preventDefault();
						return false;
					}
	
					this.lastTouchIdentifier = touch.identifier;
	
					// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
					// 1) the user does a fling scroll on the scrollable layer
					// 2) the user stops the fling scroll with another tap
					// then the event.target of the last 'touchend' event will be the element that was under the user's finger
					// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
					// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
					this.updateScrollParent(targetElement);
				}
			}
	
			this.trackingClick = true;
			this.trackingClickStart = event.timeStamp;
			this.targetElement = targetElement;
	
			this.touchStartX = touch.pageX;
			this.touchStartY = touch.pageY;
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				event.preventDefault();
			}
	
			return true;
		};
	
	
		/**
		 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.touchHasMoved = function(event) {
			var touch = event.changedTouches[0], boundary = this.touchBoundary;
	
			if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Update the last position.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchMove = function(event) {
			if (!this.trackingClick) {
				return true;
			}
	
			// If the touch has moved, cancel the click tracking
			if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
				this.trackingClick = false;
				this.targetElement = null;
			}
	
			return true;
		};
	
	
		/**
		 * Attempt to find the labelled control for the given label element.
		 *
		 * @param {EventTarget|HTMLLabelElement} labelElement
		 * @returns {Element|null}
		 */
		FastClick.prototype.findControl = function(labelElement) {
	
			// Fast path for newer browsers supporting the HTML5 control attribute
			if (labelElement.control !== undefined) {
				return labelElement.control;
			}
	
			// All browsers under test that support touch events also support the HTML5 htmlFor attribute
			if (labelElement.htmlFor) {
				return document.getElementById(labelElement.htmlFor);
			}
	
			// If no for attribute exists, attempt to retrieve the first labellable descendant element
			// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
			return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
		};
	
	
		/**
		 * On touch end, determine whether to send a click event at once.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchEnd = function(event) {
			var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
	
			if (!this.trackingClick) {
				return true;
			}
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				this.cancelNextClick = true;
				return true;
			}
	
			if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
				return true;
			}
	
			// Reset to prevent wrong click cancel on input (issue #156).
			this.cancelNextClick = false;
	
			this.lastClickTime = event.timeStamp;
	
			trackingClickStart = this.trackingClickStart;
			this.trackingClick = false;
			this.trackingClickStart = 0;
	
			// On some iOS devices, the targetElement supplied with the event is invalid if the layer
			// is performing a transition or scroll, and has to be re-detected manually. Note that
			// for this to function correctly, it must be called *after* the event target is checked!
			// See issue #57; also filed as rdar://13048589 .
			if (deviceIsIOSWithBadTarget) {
				touch = event.changedTouches[0];
	
				// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
				targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
				targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
			}
	
			targetTagName = targetElement.tagName.toLowerCase();
			if (targetTagName === 'label') {
				forElement = this.findControl(targetElement);
				if (forElement) {
					this.focus(targetElement);
					if (deviceIsAndroid) {
						return false;
					}
	
					targetElement = forElement;
				}
			} else if (this.needsFocus(targetElement)) {
	
				// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
				// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
				if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
					this.targetElement = null;
					return false;
				}
	
				this.focus(targetElement);
				this.sendClick(targetElement, event);
	
				// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
				// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
				if (!deviceIsIOS || targetTagName !== 'select') {
					this.targetElement = null;
					event.preventDefault();
				}
	
				return false;
			}
	
			if (deviceIsIOS && !deviceIsIOS4) {
	
				// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
				// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
				scrollParent = targetElement.fastClickScrollParent;
				if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
					return true;
				}
			}
	
			// Prevent the actual click from going though - unless the target node is marked as requiring
			// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
			if (!this.needsClick(targetElement)) {
				event.preventDefault();
				this.sendClick(targetElement, event);
			}
	
			return false;
		};
	
	
		/**
		 * On touch cancel, stop tracking the click.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.onTouchCancel = function() {
			this.trackingClick = false;
			this.targetElement = null;
		};
	
	
		/**
		 * Determine mouse events which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onMouse = function(event) {
	
			// If a target element was never set (because a touch event was never fired) allow the event
			if (!this.targetElement) {
				return true;
			}
	
			if (event.forwardedTouchEvent) {
				return true;
			}
	
			// Programmatically generated events targeting a specific element should be permitted
			if (!event.cancelable) {
				return true;
			}
	
			// Derive and check the target element to see whether the mouse event needs to be permitted;
			// unless explicitly enabled, prevent non-touch click events from triggering actions,
			// to prevent ghost/doubleclicks.
			if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
				// Prevent any user-added listeners declared on FastClick element from being fired.
				if (event.stopImmediatePropagation) {
					event.stopImmediatePropagation();
				} else {
	
					// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
					event.propagationStopped = true;
				}
	
				// Cancel the event
				event.stopPropagation();
				event.preventDefault();
	
				return false;
			}
	
			// If the mouse event is permitted, return true for the action to go through.
			return true;
		};
	
	
		/**
		 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
		 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
		 * an actual click which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onClick = function(event) {
			var permitted;
	
			// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
			if (this.trackingClick) {
				this.targetElement = null;
				this.trackingClick = false;
				return true;
			}
	
			// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
			if (event.target.type === 'submit' && event.detail === 0) {
				return true;
			}
	
			permitted = this.onMouse(event);
	
			// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
			if (!permitted) {
				this.targetElement = null;
			}
	
			// If clicks are permitted, return true for the action to go through.
			return permitted;
		};
	
	
		/**
		 * Remove all FastClick's event listeners.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.destroy = function() {
			var layer = this.layer;
	
			if (deviceIsAndroid) {
				layer.removeEventListener('mouseover', this.onMouse, true);
				layer.removeEventListener('mousedown', this.onMouse, true);
				layer.removeEventListener('mouseup', this.onMouse, true);
			}
	
			layer.removeEventListener('click', this.onClick, true);
			layer.removeEventListener('touchstart', this.onTouchStart, false);
			layer.removeEventListener('touchmove', this.onTouchMove, false);
			layer.removeEventListener('touchend', this.onTouchEnd, false);
			layer.removeEventListener('touchcancel', this.onTouchCancel, false);
		};
	
	
		/**
		 * Check whether FastClick is needed.
		 *
		 * @param {Element} layer The layer to listen on
		 */
		FastClick.notNeeded = function(layer) {
			var metaViewport;
			var chromeVersion;
			var blackberryVersion;
			var firefoxVersion;
	
			// Devices that don't support touch don't need FastClick
			if (typeof window.ontouchstart === 'undefined') {
				return true;
			}
	
			// Chrome version - zero for other browsers
			chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (chromeVersion) {
	
				if (deviceIsAndroid) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// Chrome 32 and above with width=device-width or less don't need FastClick
						if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
	
				// Chrome desktop doesn't need FastClick (issue #15)
				} else {
					return true;
				}
			}
	
			if (deviceIsBlackBerry10) {
				blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
	
				// BlackBerry 10.3+ does not require Fastclick library.
				// https://github.com/ftlabs/fastclick/issues/251
				if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// user-scalable=no eliminates click delay.
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// width=device-width (or less than device-width) eliminates click delay.
						if (document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
				}
			}
	
			// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
			if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			// Firefox version - zero for other browsers
			firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (firefoxVersion >= 27) {
				// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896
	
				metaViewport = document.querySelector('meta[name=viewport]');
				if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
					return true;
				}
			}
	
			// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
			// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
			if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Factory method for creating a FastClick object
		 *
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		FastClick.attach = function(layer, options) {
			return new FastClick(layer, options);
		};
	
	
		if (true) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return FastClick;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = FastClick.attach;
			module.exports.FastClick = FastClick;
		} else {
			window.FastClick = FastClick;
		}
	}());


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontPagesIndexPageIndexPageJs = __webpack_require__(13);
	
	var _frontPagesIndexPageIndexPageJs2 = _interopRequireDefault(_frontPagesIndexPageIndexPageJs);
	
	var _frontPagesProjectListPageProjectListPageJs = __webpack_require__(34);
	
	var _frontPagesProjectListPageProjectListPageJs2 = _interopRequireDefault(_frontPagesProjectListPageProjectListPageJs);
	
	var _frontPagesProjectPageProjectPageJs = __webpack_require__(53);
	
	var _frontPagesProjectPageProjectPageJs2 = _interopRequireDefault(_frontPagesProjectPageProjectPageJs);
	
	var _frontPagesContactsPageContactsPageJs = __webpack_require__(76);
	
	var _frontPagesContactsPageContactsPageJs2 = _interopRequireDefault(_frontPagesContactsPageContactsPageJs);
	
	var _frontPagesAboutPageAboutPageJs = __webpack_require__(83);
	
	var _frontPagesAboutPageAboutPageJs2 = _interopRequireDefault(_frontPagesAboutPageAboutPageJs);
	
	var LANGS = ['en'].join('|');
	
	module.exports = _backboneBackbone2['default'].Router.extend({
	    routes: {},
	
	    initialize: function initialize() {
	        this.route(new RegExp('^(' + LANGS + '/)?/?(\\?.+)?$'), 'index');
	        this.route(new RegExp('^(' + LANGS + '/)?work/(\\?.+)?$'), 'projectList');
	        this.route(new RegExp('^(' + LANGS + '/)?work/(\\d+)/(\\?.+)?$'), 'project');
	        this.route(new RegExp('^(' + LANGS + '/)?contacts/(\\?.+)?$'), 'contacts');
	        this.route(new RegExp('^(' + LANGS + '/)?about/(\\?.+)?$'), 'about');
	    },
	
	    start: function start() {
	        this.view = null;
	
	        var pushStateSupported = history && _underscoreUnderscore2['default'].isFunction(history.pushState);
	        _backboneBackbone2['default'].history.start({ pushState: pushStateSupported });
	    },
	
	    index: function index() {
	        this.activate(_frontPagesIndexPageIndexPageJs2['default']);
	    },
	
	    projectList: function projectList() {
	        this.activate(_frontPagesProjectListPageProjectListPageJs2['default']);
	    },
	
	    project: function project(lang, id) {
	        this.activate(_frontPagesProjectPageProjectPageJs2['default'], id);
	    },
	
	    contacts: function contacts() {
	        this.activate(_frontPagesContactsPageContactsPageJs2['default']);
	    },
	
	    about: function about() {
	        this.activate(_frontPagesAboutPageAboutPageJs2['default']);
	    },
	
	    activate: function activate(view) {
	        if (!this.view) {
	            this.view = new view({
	                arguments: Array.prototype.slice.call(arguments, 1)[0],
	                prerendered: true
	            });
	        } else {
	            if (this.view.type !== view.prototype.type) {
	                var promise = this.view.deactivate();
	
	                this.view = new view({
	                    promise: promise,
	                    arguments: Array.prototype.slice.call(arguments, 1)[0]
	                });
	            }
	        }
	
	        //this.view.activate()
	    }
	});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _imagesloadedImagesloadedPkgdMinJs = __webpack_require__(14);
	
	var _imagesloadedImagesloadedPkgdMinJs2 = _interopRequireDefault(_imagesloadedImagesloadedPkgdMinJs);
	
	var _frontComponentsPageViewPageViewJs = __webpack_require__(15);
	
	var _frontComponentsPageViewPageViewJs2 = _interopRequireDefault(_frontComponentsPageViewPageViewJs);
	
	var _frontComponentsSliderSliderJs = __webpack_require__(17);
	
	var _frontComponentsSliderSliderJs2 = _interopRequireDefault(_frontComponentsSliderSliderJs);
	
	__webpack_require__(31);
	
	var _IndexPageJinja = __webpack_require__(32);
	
	var _IndexPageJinja2 = _interopRequireDefault(_IndexPageJinja);
	
	var IndexPage = _frontComponentsPageViewPageViewJs2['default'].extend({
	    el: '.IndexPage',
	
	    type: 'Index',
	
	    template: _IndexPageJinja2['default'],
	
	    apiUrl: '/api/pages/index/',
	
	    playIn: function playIn() {
	        var _this = this;
	
	        this.slider.activateTitle().then(function () {
	            return _this.slider.activateImage();
	        }).then(function () {
	            app.views.nav.activate();
	            app.views.cookie.activate();
	            _this.slider.activateFrame();
	            app.views.logo.activate({ delay: 500 });
	            _this.slider.activateCounter();
	            return app.views.langs.activate({ delay: 500 });
	        }).then(function () {
	            _this.slider.activateArrows();
	
	            setTimeout(function () {
	                app.els.$body.removeClass('u-NoOverflow');
	                _this.slider.refresh();
	            }, 800);
	        });
	    },
	
	    playOut: function playOut() {
	        var _this2 = this;
	
	        app.views.langs.deactivate();
	        app.views.logo.deactivate();
	        this.slider.deactivateCounter();
	        this.slider.deactivateArrows();
	
	        return Promise.resolve(this.slider.deactivateImage()).then(function () {
	            _this2.slider.deactivateTitle();
	            return app.views.nav.deactivate();
	        });
	    },
	
	    prepare: function prepare() {
	        var _this3 = this;
	
	        this.$el[0].style.display = 'block';
	
	        this.slider = this.views.slider = new _frontComponentsSliderSliderJs2['default']({
	            el: this.$('.Slider')
	        });
	
	        $.Velocity.hook(this.slider.$firstTitle, 'opacity', '0');
	        $.Velocity.hook(this.slider.$firstImg, 'opacity', '0');
	        $.Velocity.hook(this.slider.$counter, 'opacity', '0');
	
	        this.slider.$arrows.addClass('isNotActive');
	        this.slider.$frame.addClass('isNotActive');
	
	        return this.preloadImages().then(function () {
	            return _this3.promise;
	        }).then(function () {
	            app.els.$window.scrollTop(0);
	            return app.loader.deactivate();
	        });
	    },
	
	    cleanUp: function cleanUp() {
	        app.els.$body.addClass('u-NoOverflow');
	        this.close();
	        return app.loader.activate();
	    }
	});
	
	exports['default'] = IndexPage;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _imagesloadedImagesloadedPkgdMinJs = __webpack_require__(14);
	
	var _imagesloadedImagesloadedPkgdMinJs2 = _interopRequireDefault(_imagesloadedImagesloadedPkgdMinJs);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	var PageView = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    initialize: function initialize(options) {
	        var _this = this;
	
	        this.views = {};
	
	        if (options.prerendered) {
	            this.promise = new Promise(function (resolve) {
	                resolve();
	            });
	            this.activate();
	        } else {
	            this.promise = options.promise;
	            this.loadData().then(function () {
	                _this.render();
	            }).then(function () {
	                _this.activate();
	            });
	        }
	    },
	
	    loadData: function loadData() {
	        var _this2 = this;
	
	        return Promise.resolve($.getJSON(this.apiUrl, { lang: app.data.lang }).then(function (data) {
	            _this2.data = data;
	        }).fail(function () {
	            console.log('Ошибка при загрузке данных.');
	        }));
	    },
	
	    render: function render() {
	        var $html = $(this.template.render(this.data));
	        app.els.$content.append($html);
	        this.setElement($html);
	
	        return this;
	    },
	
	    preloadImages: function preloadImages() {
	        var $preloads = this.$('.u-Preload');
	        var images = this.$('img').toArray();
	
	        _underscoreUnderscore2['default'].each($preloads, function (item) {
	            var $item = $(item);
	            var $img = $item.filter('img');
	
	            if (!$img.length) {
	                $img = $item.find('img');
	
	                var imageUrl = undefined;
	
	                if (app.isRetina && $img.attr('srcset')) {
	                    imageUrl = $img.attr('srcset').split(' ')[0];
	                } else {
	                    imageUrl = $img.attr('src');
	                }
	
	                $item.css('background-image', 'url(' + imageUrl + ')');
	            }
	
	            images.push($img[0]);
	        });
	
	        return new Promise(function (resolve) {
	            (0, _imagesloadedImagesloadedPkgdMinJs2['default'])(images, function () {
	                resolve();
	            });
	        });
	    },
	
	    _getBgImage: function _getBgImage($el) {
	        return $el.css('background-image').replace(/^url|[\(\)]/g, '');
	    },
	
	    activate: function activate() {
	        var _this3 = this;
	
	        return this.prepare().then(function () {
	            return _this3.playIn();
	        });
	    },
	
	    deactivate: function deactivate() {
	        var _this4 = this;
	
	        return this.playOut().then(function () {
	            return _this4.cleanUp();
	        });
	    }
	});
	
	exports['default'] = PageView;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var BaseView = _backboneBackbone2['default'].View.extend({
	    close: function close() {
	        if (this.views) {
	            _underscoreUnderscore2['default'].each(this.views, function (view) {
	                view.close();
	            });
	        }
	
	        this.undelegateEvents();
	        this.$el.removeData().unbind();
	        this.remove();
	        _backboneBackbone2['default'].View.prototype.remove.call(this);
	    }
	});
	
	exports['default'] = BaseView;
	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(18);
	
	__webpack_require__(19);
	
	__webpack_require__(20);
	
	__webpack_require__(21);
	
	var _frontUtilsUtilsJs = __webpack_require__(22);
	
	var _frontUtilsUtilsJs2 = _interopRequireDefault(_frontUtilsUtilsJs);
	
	var _frontComponentsFrameFrameJs = __webpack_require__(23);
	
	var _frontComponentsFrameFrameJs2 = _interopRequireDefault(_frontComponentsFrameFrameJs);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(29);
	
	var _SliderJinja = __webpack_require__(30);
	
	var _SliderJinja2 = _interopRequireDefault(_SliderJinja);
	
	var Slider = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    events: {
	        'click .Slider-btn--prev': 'slidePrev',
	        'click .Slider-btn--next': 'slideNext',
	        'translate.owl.carousel .owl-carousel': 'changeSlide',
	        'drag.owl.carousel .owl-carousel': 'dragStart',
	        'dragged.owl.carousel .owl-carousel': 'dragEnd'
	    },
	
	    initialize: function initialize(options) {
	        _underscoreUnderscore2['default'].bindAll(this, 'activateTitle', 'activateImage');
	
	        this.$slider = this.$('.Slider-contents');
	
	        var config = {
	            items: 1,
	            mouseDrag: false,
	            loop: true,
	            nav: false,
	            navSpeed: 1000,
	            smartSpeed: 1000
	        };
	
	        this.state = {
	            dragging: false
	        };
	
	        if (options.type === 'project') {
	            _underscoreUnderscore2['default'].extend(config, {
	                center: true,
	                stagePadding: 428,
	                margin: 48
	            });
	        }
	
	        this.$slider.owlCarousel(config);
	
	        this.$firstSlide = this.$('.owl-item.active').find('.Slider-slide');
	        this.$firstTitle = this.$firstSlide.find('.Slider-link');
	        this.$firstTitle.addClass('isNotActive');
	
	        this.$firstImg = this.$firstSlide.find('.Slider-img');
	        this.$frame = this.$firstSlide.find('.Frame');
	
	        if (this.$frame.length) {
	            this.modifyFrame();
	        }
	
	        this.$counter = this.$('.Slider-counter');
	        this.$currentCounter = this.$counter.find('.Slider-currentCounter');
	        this.currentIndex = 0;
	
	        this.$arrows = this.$('.Slider-btn');
	
	        this._arrowsShownBinded = this._arrowsShown.bind(this);
	
	        this.$el[0].style.visibility = 'visible';
	    },
	
	    /**
	     * Изменяет разметку компоненты Frame, для случая с анимацией
	     */
	    modifyFrame: function modifyFrame() {
	        var $newFrame = new _frontComponentsFrameFrameJs2['default']().render().$el;
	        this.$frame = $newFrame.replaceAll(this.$frame);
	    },
	
	    activateTitle: function activateTitle(options) {
	        var self = this;
	
	        if (this.$firstTitle.length) {
	            return $.Velocity.animate(this.$firstTitle[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({
	                duration: 1500,
	                complete: function complete() {
	                    self.$firstTitle.removeClass('isNotActive');
	                }
	            }, options));
	        } else {
	            return Promise.resolve(true);
	        }
	    },
	
	    deactivateTitle: function deactivateTitle(options) {
	        var $currentTitle = this.getCurrentSlide().find('.Slider-link');
	        return $.Velocity.animate($currentTitle[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({ duration: 1000 }, options));
	    },
	
	    activateImage: function activateImage(options) {
	        return $.Velocity.animate(this.$firstImg[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({ duration: 1500 }, options));
	    },
	
	    deactivateImage: function deactivateImage(options) {
	        var $currentImg = this.getCurrentSlide().find('.Slider-img');
	        return $.Velocity.animate($currentImg[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({ duration: 500 }, options));
	    },
	
	    activateArrows: function activateArrows() {
	        this.$arrows[0].addEventListener('transitionend', this._arrowsShownBinded);
	        this.$arrows[0].addEventListener('webkitTransitionEnd', this._arrowsShownBinded);
	
	        this.$arrows.removeClass('isNotActive');
	    },
	
	    deactivateArrows: function deactivateArrows() {
	        this.$arrows.addClass('isNotActive');
	    },
	
	    _arrowsShown: function _arrowsShown() {
	        this.$arrows.addClass('isActive');
	    },
	
	    activateCounter: function activateCounter(options) {
	        return $.Velocity.animate(this.$counter[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({ duration: 500 }, options));
	    },
	
	    deactivateCounter: function deactivateCounter(options) {
	        return $.Velocity.animate(this.$counter[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({ duration: 500 }, options));
	    },
	
	    activateFrame: function activateFrame() {
	        var _this = this;
	
	        setTimeout(function () {
	            _this.$frame.addClass('isActive');
	        }, 250);
	    },
	
	    changeCounter: function changeCounter(e) {
	        var newIndex = e.page.index + 1;
	        var indexFormatted = _frontUtilsUtilsJs2['default'].pad(newIndex, 2);
	        var $newValue = $('<span class="Slider-numberValue">' + indexFormatted + '</span>');
	
	        var $oldValue = this.$currentCounter.find('.Slider-numberValue');
	        $oldValue.velocity('finish', true);
	
	        if (newIndex > this.currentIndex) {
	            this.currentIndex = newIndex;
	
	            $.Velocity.hook($oldValue, 'translateY', 0);
	            $.Velocity.animate($oldValue, { translateY: '15px', opacity: 0 }, {
	                duration: 750,
	                complete: function complete() {
	                    $oldValue.remove();
	                }
	            });
	
	            $.Velocity.hook($newValue[0], 'opacity', 0);
	            $.Velocity.hook($newValue[0], 'translateY', '-15px');
	            $newValue = $newValue.appendTo(this.$currentCounter);
	
	            $.Velocity.animate($newValue[0], { translateY: 0, opacity: 1 }, { duration: 750 });
	        } else {
	            this.currentIndex = newIndex;
	
	            $.Velocity.hook($oldValue, 'translateY', 0);
	            $.Velocity.animate($oldValue, { translateY: '-15px', opacity: 0 }, {
	                duration: 750,
	                complete: function complete() {
	                    $oldValue.remove();
	                }
	            });
	
	            $.Velocity.hook($newValue[0], 'opacity', 0);
	            $.Velocity.hook($newValue[0], 'translateY', '15px');
	            $newValue = $newValue.appendTo(this.$currentCounter);
	
	            $.Velocity.animate($newValue[0], { translateY: 0, opacity: 1 }, { duration: 750 });
	        }
	    },
	
	    getCurrentSlide: function getCurrentSlide() {
	        var sliderPosition = this.$slider.offset();
	        var sliderCenterX = sliderPosition.left + this.$slider.width() / 2;
	        var sliderCenterY = sliderPosition.top + this.$slider.height() / 2;
	        return $(document.elementFromPoint(sliderCenterX, sliderCenterY)).closest('.owl-item');
	    },
	
	    changeSlide: function changeSlide(e) {
	        if (this.state.dragging) {
	            return;
	        }
	
	        var newFakeIndex = e.page.index + 1;
	        var newRealIndex = e.item.index;
	        var $nextSlide = this.$slider.find('.owl-item').eq(newRealIndex);
	        var $nextSlideTitle = $nextSlide.find('.Slider-linkContents');
	        var $currentSlide = this.getCurrentSlide();
	
	        // TODO: Refactor
	        if (this.currentIndex === 3 && newFakeIndex === 1) {
	            $.Velocity.hook($nextSlideTitle, 'opacity', '0');
	            $.Velocity.hook($nextSlideTitle, 'translateX', -(parseInt(app.els.$window.width()) / 2) + 'px');
	        } else if (this.currentIndex === 1 && newFakeIndex === 3) {
	            $.Velocity.hook($nextSlideTitle, 'opacity', '0');
	            $.Velocity.hook($nextSlideTitle, 'translateX', parseInt(app.els.$window.width()) / 2 + 'px');
	        } else if (newFakeIndex > this.currentIndex) {
	            $.Velocity.hook($nextSlideTitle, 'opacity', '0');
	            $.Velocity.hook($nextSlideTitle, 'translateX', -(parseInt(app.els.$window.width()) / 2) + 'px');
	        } else {
	            $.Velocity.hook($nextSlideTitle, 'opacity', '0');
	            $.Velocity.hook($nextSlideTitle, 'translateX', parseInt(app.els.$window.width()) / 2 + 'px');
	        }
	
	        var $title = $currentSlide.find('.Slider-linkContents');
	        $.Velocity($title, { opacity: 0 }, {
	            duration: 500,
	            complete: function complete() {
	                setTimeout(function () {
	                    $.Velocity.hook($title, 'opacity', '1');
	                }, 500);
	            }
	        });
	
	        $nextSlideTitle.velocity({
	            opacity: [1, 'easeInQuad'],
	            translateX: [0, 'easeOutQuart']
	        }, {
	            duration: 1000
	        });
	
	        this.changeCounter(e);
	    },
	
	    slidePrev: function slidePrev() {
	        this.$slider.trigger('prev.owl.carousel');
	    },
	
	    slideNext: function slideNext() {
	        this.$slider.trigger('next.owl.carousel');
	    },
	
	    refresh: function refresh() {
	        this.$slider.data('owlCarousel')._width = this.$slider.width();
	        this.$slider.data('owlCarousel').invalidate('width');
	        this.$slider.trigger('refresh.owl.carousel');
	    },
	
	    dragStart: function dragStart() {
	        this.state.dragging = true;
	    },
	
	    dragEnd: function dragEnd() {
	        this.state.dragging = false;
	    }
	});
	
	exports['default'] = Slider;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
5,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Utils = {
	    pad: function pad(n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    },
	
	    isElementInViewport: function isElementInViewport(el) {
	        //special bonus for those using jQuery
	        if (typeof jQuery === "function" && el instanceof jQuery) {
	            el = el[0];
	        }
	
	        var rect = el.getBoundingClientRect();
	
	        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	    }
	};
	
	exports['default'] = Utils;
	module.exports = exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(24);
	
	var _FrameJinja = __webpack_require__(25);
	
	var _FrameJinja2 = _interopRequireDefault(_FrameJinja);
	
	var Frame = _backboneBackbone2['default'].View.extend({
	    template: _FrameJinja2['default'],
	
	    render: function render() {
	        var $html = $(this.template.render());
	        this.setElement($html);
	
	        return this;
	    }
	});
	
	exports['default'] = Frame;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 24 */
5,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Frame.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	output += "<div class=\"Frame\">\n    <div class=\"Frame-side Frame-side--top\"></div>\n    <div class=\"Frame-side Frame-side--right\"></div>\n    <div class=\"Frame-side Frame-side--bottom\"></div>\n    <div class=\"Frame-side Frame-side--left\"></div>\n</div>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Frame.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	/*! Browser bundle of nunjucks 2.1.0 (slim, only works with precompiled templates) */
	var nunjucks =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var lib = __webpack_require__(2);
		var env = __webpack_require__(3);
		var Loader = __webpack_require__(11);
		var loaders = __webpack_require__(1);
		var precompile = __webpack_require__(1);
	
		module.exports = {};
		module.exports.Environment = env.Environment;
		module.exports.Template = env.Template;
	
		module.exports.Loader = Loader;
		module.exports.FileSystemLoader = loaders.FileSystemLoader;
		module.exports.PrecompiledLoader = loaders.PrecompiledLoader;
		module.exports.WebLoader = loaders.WebLoader;
	
		module.exports.compiler = __webpack_require__(1);
		module.exports.parser = __webpack_require__(1);
		module.exports.lexer = __webpack_require__(1);
		module.exports.runtime = __webpack_require__(5);
		module.exports.lib = lib;
	
		module.exports.installJinjaCompat = __webpack_require__(12);
	
		// A single instance of an environment, since this is so commonly used
	
		var e;
		module.exports.configure = function(templatesPath, opts) {
		    opts = opts || {};
		    if(lib.isObject(templatesPath)) {
		        opts = templatesPath;
		        templatesPath = null;
		    }
	
		    var TemplateLoader;
		    if(loaders.FileSystemLoader) {
		        TemplateLoader = new loaders.FileSystemLoader(templatesPath, {
		            watch: opts.watch,
		            noCache: opts.noCache
		        });
		    }
		    else if(loaders.WebLoader) {
		        TemplateLoader = new loaders.WebLoader(templatesPath, {
		            useCache: opts.web && opts.web.useCache,
		            async: opts.web && opts.web.async
		        });
		    }
	
		    e = new env.Environment(TemplateLoader, opts);
	
		    if(opts && opts.express) {
		        e.express(opts.express);
		    }
	
		    return e;
		};
	
		module.exports.compile = function(src, env, path, eagerCompile) {
		    if(!e) {
		        module.exports.configure();
		    }
		    return new module.exports.Template(src, env, path, eagerCompile);
		};
	
		module.exports.render = function(name, ctx, cb) {
		    if(!e) {
		        module.exports.configure();
		    }
	
		    return e.render(name, ctx, cb);
		};
	
		module.exports.renderString = function(src, ctx, cb) {
		    if(!e) {
		        module.exports.configure();
		    }
	
		    return e.renderString(src, ctx, cb);
		};
	
		if(precompile) {
		    module.exports.precompile = precompile.precompile;
		    module.exports.precompileString = precompile.precompileString;
		}
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var ArrayProto = Array.prototype;
		var ObjProto = Object.prototype;
	
		var escapeMap = {
		    '&': '&amp;',
		    '"': '&quot;',
		    '\'': '&#39;',
		    '<': '&lt;',
		    '>': '&gt;'
		};
	
		var escapeRegex = /[&"'<>]/g;
	
		var lookupEscape = function(ch) {
		    return escapeMap[ch];
		};
	
		var exports = module.exports = {};
	
		exports.prettifyError = function(path, withInternals, err) {
		    // jshint -W022
		    // http://jslinterrors.com/do-not-assign-to-the-exception-parameter
		    if (!err.Update) {
		        // not one of ours, cast it
		        err = new exports.TemplateError(err);
		    }
		    err.Update(path);
	
		    // Unless they marked the dev flag, show them a trace from here
		    if (!withInternals) {
		        var old = err;
		        err = new Error(old.message);
		        err.name = old.name;
		    }
	
		    return err;
		};
	
		exports.TemplateError = function(message, lineno, colno) {
		    var err = this;
	
		    if (message instanceof Error) { // for casting regular js errors
		        err = message;
		        message = message.name + ': ' + message.message;
	
		        try {
		            if(err.name = '') {}
		        }
		        catch(e) {
		            // If we can't set the name of the error object in this
		            // environment, don't use it
		            err = this;
		        }
		    } else {
		        if(Error.captureStackTrace) {
		            Error.captureStackTrace(err);
		        }
		    }
	
		    err.name = 'Template render error';
		    err.message = message;
		    err.lineno = lineno;
		    err.colno = colno;
		    err.firstUpdate = true;
	
		    err.Update = function(path) {
		        var message = '(' + (path || 'unknown path') + ')';
	
		        // only show lineno + colno next to path of template
		        // where error occurred
		        if (this.firstUpdate) {
		            if(this.lineno && this.colno) {
		                message += ' [Line ' + this.lineno + ', Column ' + this.colno + ']';
		            }
		            else if(this.lineno) {
		                message += ' [Line ' + this.lineno + ']';
		            }
		        }
	
		        message += '\n ';
		        if (this.firstUpdate) {
		            message += ' ';
		        }
	
		        this.message = message + (this.message || '');
		        this.firstUpdate = false;
		        return this;
		    };
	
		    return err;
		};
	
		exports.TemplateError.prototype = Error.prototype;
	
		exports.escape = function(val) {
		  return val.replace(escapeRegex, lookupEscape);
		};
	
		exports.isFunction = function(obj) {
		    return ObjProto.toString.call(obj) === '[object Function]';
		};
	
		exports.isArray = Array.isArray || function(obj) {
		    return ObjProto.toString.call(obj) === '[object Array]';
		};
	
		exports.isString = function(obj) {
		    return ObjProto.toString.call(obj) === '[object String]';
		};
	
		exports.isObject = function(obj) {
		    return ObjProto.toString.call(obj) === '[object Object]';
		};
	
		exports.groupBy = function(obj, val) {
		    var result = {};
		    var iterator = exports.isFunction(val) ? val : function(obj) { return obj[val]; };
		    for(var i=0; i<obj.length; i++) {
		        var value = obj[i];
		        var key = iterator(value, i);
		        (result[key] || (result[key] = [])).push(value);
		    }
		    return result;
		};
	
		exports.toArray = function(obj) {
		    return Array.prototype.slice.call(obj);
		};
	
		exports.without = function(array) {
		    var result = [];
		    if (!array) {
		        return result;
		    }
		    var index = -1,
		    length = array.length,
		    contains = exports.toArray(arguments).slice(1);
	
		    while(++index < length) {
		        if(exports.indexOf(contains, array[index]) === -1) {
		            result.push(array[index]);
		        }
		    }
		    return result;
		};
	
		exports.extend = function(obj, obj2) {
		    for(var k in obj2) {
		        obj[k] = obj2[k];
		    }
		    return obj;
		};
	
		exports.repeat = function(char_, n) {
		    var str = '';
		    for(var i=0; i<n; i++) {
		        str += char_;
		    }
		    return str;
		};
	
		exports.each = function(obj, func, context) {
		    if(obj == null) {
		        return;
		    }
	
		    if(ArrayProto.each && obj.each === ArrayProto.each) {
		        obj.forEach(func, context);
		    }
		    else if(obj.length === +obj.length) {
		        for(var i=0, l=obj.length; i<l; i++) {
		            func.call(context, obj[i], i, obj);
		        }
		    }
		};
	
		exports.map = function(obj, func) {
		    var results = [];
		    if(obj == null) {
		        return results;
		    }
	
		    if(ArrayProto.map && obj.map === ArrayProto.map) {
		        return obj.map(func);
		    }
	
		    for(var i=0; i<obj.length; i++) {
		        results[results.length] = func(obj[i], i);
		    }
	
		    if(obj.length === +obj.length) {
		        results.length = obj.length;
		    }
	
		    return results;
		};
	
		exports.asyncIter = function(arr, iter, cb) {
		    var i = -1;
	
		    function next() {
		        i++;
	
		        if(i < arr.length) {
		            iter(arr[i], i, next, cb);
		        }
		        else {
		            cb();
		        }
		    }
	
		    next();
		};
	
		exports.asyncFor = function(obj, iter, cb) {
		    var keys = exports.keys(obj);
		    var len = keys.length;
		    var i = -1;
	
		    function next() {
		        i++;
		        var k = keys[i];
	
		        if(i < len) {
		            iter(k, obj[k], i, len, next);
		        }
		        else {
		            cb();
		        }
		    }
	
		    next();
		};
	
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Polyfill
		exports.indexOf = Array.prototype.indexOf ?
		    function (arr, searchElement, fromIndex) {
		        return Array.prototype.indexOf.call(arr, searchElement, fromIndex);
		    } :
		    function (arr, searchElement, fromIndex) {
		        var length = this.length >>> 0; // Hack to convert object.length to a UInt32
	
		        fromIndex = +fromIndex || 0;
	
		        if(Math.abs(fromIndex) === Infinity) {
		            fromIndex = 0;
		        }
	
		        if(fromIndex < 0) {
		            fromIndex += length;
		            if (fromIndex < 0) {
		                fromIndex = 0;
		            }
		        }
	
		        for(;fromIndex < length; fromIndex++) {
		            if (arr[fromIndex] === searchElement) {
		                return fromIndex;
		            }
		        }
	
		        return -1;
		    };
	
		if(!Array.prototype.map) {
		    Array.prototype.map = function() {
		        throw new Error('map is unimplemented for this js engine');
		    };
		}
	
		exports.keys = function(obj) {
		    if(Object.prototype.keys) {
		        return obj.keys();
		    }
		    else {
		        var keys = [];
		        for(var k in obj) {
		            if(obj.hasOwnProperty(k)) {
		                keys.push(k);
		            }
		        }
		        return keys;
		    }
		};
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var path = __webpack_require__(1);
		var asap = __webpack_require__(7);
		var lib = __webpack_require__(2);
		var Obj = __webpack_require__(6);
		var compiler = __webpack_require__(1);
		var builtin_filters = __webpack_require__(4);
		var builtin_loaders = __webpack_require__(1);
		var runtime = __webpack_require__(5);
		var globals = __webpack_require__(9);
		var Frame = runtime.Frame;
		var Template;
	
		// Unconditionally load in this loader, even if no other ones are
		// included (possible in the slim browser build)
		builtin_loaders.PrecompiledLoader = __webpack_require__(10);
	
		// If the user is using the async API, *always* call it
		// asynchronously even if the template was synchronous.
		function callbackAsap(cb, err, res) {
		    asap(function() { cb(err, res); });
		}
	
		var Environment = Obj.extend({
		    init: function(loaders, opts) {
		        // The dev flag determines the trace that'll be shown on errors.
		        // If set to true, returns the full trace from the error point,
		        // otherwise will return trace starting from Template.render
		        // (the full trace from within nunjucks may confuse developers using
		        //  the library)
		        // defaults to false
		        opts = this.opts = opts || {};
		        this.opts.dev = !!opts.dev;
	
		        // The autoescape flag sets global autoescaping. If true,
		        // every string variable will be escaped by default.
		        // If false, strings can be manually escaped using the `escape` filter.
		        // defaults to true
		        this.opts.autoescape = opts.autoescape != null ? opts.autoescape : true;
	
		        // If true, this will make the system throw errors if trying
		        // to output a null or undefined value
		        this.opts.throwOnUndefined = !!opts.throwOnUndefined;
		        this.opts.trimBlocks = !!opts.trimBlocks;
		        this.opts.lstripBlocks = !!opts.lstripBlocks;
	
		        this.loaders = [];
	
		        if(!loaders) {
		            // The filesystem loader is only available server-side
		            if(builtin_loaders.FileSystemLoader) {
		                this.loaders = [new builtin_loaders.FileSystemLoader('views')];
		            }
		            else if(builtin_loaders.WebLoader) {
		                this.loaders = [new builtin_loaders.WebLoader('/views')];
		            }
		        }
		        else {
		            this.loaders = lib.isArray(loaders) ? loaders : [loaders];
		        }
	
		        // It's easy to use precompiled templates: just include them
		        // before you configure nunjucks and this will automatically
		        // pick it up and use it
		        if((true) && window.nunjucksPrecompiled) {
		            this.loaders.unshift(
		                new builtin_loaders.PrecompiledLoader(window.nunjucksPrecompiled)
		            );
		        }
	
		        this.initCache();
		        this.filters = {};
		        this.asyncFilters = [];
		        this.extensions = {};
		        this.extensionsList = [];
	
		        for(var name in builtin_filters) {
		            this.addFilter(name, builtin_filters[name]);
		        }
		    },
	
		    initCache: function() {
		        // Caching and cache busting
		        lib.each(this.loaders, function(loader) {
		            loader.cache = {};
	
		            if(typeof loader.on === 'function') {
		                loader.on('update', function(template) {
		                    loader.cache[template] = null;
		                });
		            }
		        });
		    },
	
		    addExtension: function(name, extension) {
		        extension._name = name;
		        this.extensions[name] = extension;
		        this.extensionsList.push(extension);
		    },
	
		    removeExtension: function(name) {
		        var extension = this.getExtension(name);
		        if (!extension) return;
	
		        this.extensionsList = lib.without(this.extensionsList, extension);
		        delete this.extensions[name];
		    },
	
		    getExtension: function(name) {
		        return this.extensions[name];
		    },
	
		    hasExtension: function(name) {
		        return !!this.extensions[name];
		    },
	
		    addGlobal: function(name, value) {
		        globals[name] = value;
		    },
	
		    getGlobal: function(name) {
		        if(!globals[name]) {
		            throw new Error('global not found: ' + name);
		        }
		        return globals[name];
		    },
	
		    addFilter: function(name, func, async) {
		        var wrapped = func;
	
		        if(async) {
		            this.asyncFilters.push(name);
		        }
		        this.filters[name] = wrapped;
		    },
	
		    getFilter: function(name) {
		        if(!this.filters[name]) {
		            throw new Error('filter not found: ' + name);
		        }
		        return this.filters[name];
		    },
	
		    resolveTemplate: function(loader, parentName, filename) {
		        var isRelative = (loader.isRelative && parentName)? loader.isRelative(filename) : false;
		        return (isRelative && loader.resolve)? loader.resolve(parentName, filename) : filename;
		    },
	
		    getTemplate: function(name, eagerCompile, parentName, cb) {
		        var that = this;
		        var tmpl = null;
		        if(name && name.raw) {
		            // this fixes autoescape for templates referenced in symbols
		            name = name.raw;
		        }
	
		        if(lib.isFunction(parentName)) {
		            cb = parentName;
		            parentName = null;
		            eagerCompile = eagerCompile || false;
		        }
	
		        if(lib.isFunction(eagerCompile)) {
		            cb = eagerCompile;
		            eagerCompile = false;
		        }
	
		        if(typeof name !== 'string') {
		            throw new Error('template names must be a string: ' + name);
		        }
	
		        for (var i = 0; i < this.loaders.length; i++) {
		            var _name = this.resolveTemplate(this.loaders[i], parentName, name);
		            tmpl = this.loaders[i].cache[_name];
		            if (tmpl) break;
		        }
	
		        if(tmpl) {
		            if(eagerCompile) {
		                tmpl.compile();
		            }
	
		            if(cb) {
		                cb(null, tmpl);
		            }
		            else {
		                return tmpl;
		            }
		        } else {
		            var syncResult;
		            var _this = this;
	
		            var createTemplate = function(err, info) {
		                if(!info && !err) {
		                    err = new Error('template not found: ' + name);
		                }
	
		                if (err) {
		                    if(cb) {
		                        cb(err);
		                    }
		                    else {
		                        throw err;
		                    }
		                }
		                else {
		                    var tmpl = new Template(info.src, _this,
		                                            info.path, eagerCompile);
	
		                    if(!info.noCache) {
		                        info.loader.cache[name] = tmpl;
		                    }
	
		                    if(cb) {
		                        cb(null, tmpl);
		                    }
		                    else {
		                        syncResult = tmpl;
		                    }
		                }
		            };
	
		            lib.asyncIter(this.loaders, function(loader, i, next, done) {
		                function handle(err, src) {
		                    if(err) {
		                        done(err);
		                    }
		                    else if(src) {
		                        src.loader = loader;
		                        done(null, src);
		                    }
		                    else {
		                        next();
		                    }
		                }
	
		                // Resolve name relative to parentName
		                name = that.resolveTemplate(loader, parentName, name);
	
		                if(loader.async) {
		                    loader.getSource(name, handle);
		                }
		                else {
		                    handle(null, loader.getSource(name));
		                }
		            }, createTemplate);
	
		            return syncResult;
		        }
		    },
	
		    express: function(app) {
		        var env = this;
	
		        function NunjucksView(name, opts) {
		            this.name          = name;
		            this.path          = name;
		            this.defaultEngine = opts.defaultEngine;
		            this.ext           = path.extname(name);
		            if (!this.ext && !this.defaultEngine) throw new Error('No default engine was specified and no extension was provided.');
		            if (!this.ext) this.name += (this.ext = ('.' !== this.defaultEngine[0] ? '.' : '') + this.defaultEngine);
		        }
	
		        NunjucksView.prototype.render = function(opts, cb) {
		          env.render(this.name, opts, cb);
		        };
	
		        app.set('view', NunjucksView);
		    },
	
		    render: function(name, ctx, cb) {
		        if(lib.isFunction(ctx)) {
		            cb = ctx;
		            ctx = null;
		        }
	
		        // We support a synchronous API to make it easier to migrate
		        // existing code to async. This works because if you don't do
		        // anything async work, the whole thing is actually run
		        // synchronously.
		        var syncResult = null;
	
		        this.getTemplate(name, function(err, tmpl) {
		            if(err && cb) {
		                callbackAsap(cb, err);
		            }
		            else if(err) {
		                throw err;
		            }
		            else {
		                syncResult = tmpl.render(ctx, cb);
		            }
		        });
	
		        return syncResult;
		    },
	
		    renderString: function(src, ctx, opts, cb) {
		        if(lib.isFunction(opts)) {
		            cb = opts;
		            opts = {};
		        }
		        opts = opts || {};
	
		        var tmpl = new Template(src, this, opts.path);
		        return tmpl.render(ctx, cb);
		    }
		});
	
		var Context = Obj.extend({
		    init: function(ctx, blocks) {
		        // Make a duplicate of ctx
		        this.ctx = {};
		        for(var k in ctx) {
		            if(ctx.hasOwnProperty(k)) {
		                this.ctx[k] = ctx[k];
		            }
		        }
	
		        this.blocks = {};
		        this.exported = [];
	
		        for(var name in blocks) {
		            this.addBlock(name, blocks[name]);
		        }
		    },
	
		    lookup: function(name) {
		        // This is one of the most called functions, so optimize for
		        // the typical case where the name isn't in the globals
		        if(name in globals && !(name in this.ctx)) {
		            return globals[name];
		        }
		        else {
		            return this.ctx[name];
		        }
		    },
	
		    setVariable: function(name, val) {
		        this.ctx[name] = val;
		    },
	
		    getVariables: function() {
		        return this.ctx;
		    },
	
		    addBlock: function(name, block) {
		        this.blocks[name] = this.blocks[name] || [];
		        this.blocks[name].push(block);
		    },
	
		    getBlock: function(name) {
		        if(!this.blocks[name]) {
		            throw new Error('unknown block "' + name + '"');
		        }
	
		        return this.blocks[name][0];
		    },
	
		    getSuper: function(env, name, block, frame, runtime, cb) {
		        var idx = lib.indexOf(this.blocks[name] || [], block);
		        var blk = this.blocks[name][idx + 1];
		        var context = this;
	
		        if(idx === -1 || !blk) {
		            throw new Error('no super block available for "' + name + '"');
		        }
	
		        blk(env, context, frame, runtime, cb);
		    },
	
		    addExport: function(name) {
		        this.exported.push(name);
		    },
	
		    getExported: function() {
		        var exported = {};
		        for(var i=0; i<this.exported.length; i++) {
		            var name = this.exported[i];
		            exported[name] = this.ctx[name];
		        }
		        return exported;
		    }
		});
	
		Template = Obj.extend({
		    init: function (src, env, path, eagerCompile) {
		        this.env = env || new Environment();
	
		        if(lib.isObject(src)) {
		            switch(src.type) {
		            case 'code': this.tmplProps = src.obj; break;
		            case 'string': this.tmplStr = src.obj; break;
		            }
		        }
		        else if(lib.isString(src)) {
		            this.tmplStr = src;
		        }
		        else {
		            throw new Error('src must be a string or an object describing ' +
		                            'the source');
		        }
	
		        this.path = path;
	
		        if(eagerCompile) {
		            var _this = this;
		            try {
		                _this._compile();
		            }
		            catch(err) {
		                throw lib.prettifyError(this.path, this.env.dev, err);
		            }
		        }
		        else {
		            this.compiled = false;
		        }
		    },
	
		    render: function(ctx, parentFrame, cb) {
		        if (typeof ctx === 'function') {
		            cb = ctx;
		            ctx = {};
		        }
		        else if (typeof parentFrame === 'function') {
		            cb = parentFrame;
		            parentFrame = null;
		        }
	
		        var forceAsync = true;
		        if(parentFrame) {
		            // If there is a frame, we are being called from internal
		            // code of another template, and the internal system
		            // depends on the sync/async nature of the parent template
		            // to be inherited, so force an async callback
		            forceAsync = false;
		        }
	
		        var _this = this;
		        // Catch compile errors for async rendering
		        try {
		            _this.compile();
		        } catch (_err) {
		            var err = lib.prettifyError(this.path, this.env.dev, _err);
		            if (cb) return callbackAsap(cb, err);
		            else throw err;
		        }
	
		        var context = new Context(ctx || {}, _this.blocks);
		        var frame = parentFrame ? parentFrame.push() : new Frame();
		        frame.topLevel = true;
		        var syncResult = null;
	
		        _this.rootRenderFunc(
		            _this.env,
		            context,
		            frame || new Frame(),
		            runtime,
		            function(err, res) {
		                if(err) {
		                    err = lib.prettifyError(_this.path, _this.env.dev, err);
		                }
	
		                if(cb) {
		                    if(forceAsync) {
		                        callbackAsap(cb, err, res);
		                    }
		                    else {
		                        cb(err, res);
		                    }
		                }
		                else {
		                    if(err) { throw err; }
		                    syncResult = res;
		                }
		            }
		        );
	
		        return syncResult;
		    },
	
	
		    getExported: function(ctx, parentFrame, cb) {
		        if (typeof ctx === 'function') {
		            cb = ctx;
		            ctx = {};
		        }
	
		        if (typeof parentFrame === 'function') {
		            cb = parentFrame;
		            parentFrame = null;
		        }
	
		        // Catch compile errors for async rendering
		        try {
		            this.compile();
		        } catch (e) {
		            if (cb) return cb(e);
		            else throw e;
		        }
	
		        var frame = parentFrame ? parentFrame.push() : new Frame();
		        frame.topLevel = true;
	
		        // Run the rootRenderFunc to populate the context with exported vars
		        var context = new Context(ctx || {}, this.blocks);
		        this.rootRenderFunc(this.env,
		                            context,
		                            frame,
		                            runtime,
		                            function() {
		                                cb(null, context.getExported());
		                            });
		    },
	
		    compile: function() {
		        if(!this.compiled) {
		            this._compile();
		        }
		    },
	
		    _compile: function() {
		        var props;
	
		        if(this.tmplProps) {
		            props = this.tmplProps;
		        }
		        else {
		            var source = compiler.compile(this.tmplStr,
		                                          this.env.asyncFilters,
		                                          this.env.extensionsList,
		                                          this.path,
		                                          this.env.opts);
	
		            /* jslint evil: true */
		            var func = new Function(source);
		            props = func();
		        }
	
		        this.blocks = this._getBlocks(props);
		        this.rootRenderFunc = props.root;
		        this.compiled = true;
		    },
	
		    _getBlocks: function(props) {
		        var blocks = {};
	
		        for(var k in props) {
		            if(k.slice(0, 2) === 'b_') {
		                blocks[k.slice(2)] = props[k];
		            }
		        }
	
		        return blocks;
		    }
		});
	
		module.exports = {
		    Environment: Environment,
		    Template: Template
		};
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var lib = __webpack_require__(2);
		var r = __webpack_require__(5);
	
		function normalize(value, defaultValue) {
		    if(value === null || value === undefined || value === false) {
		        return defaultValue;
		    }
		    return value;
		}
	
		var hasWarnedDefault = false;
	
		var filters = {
		    abs: function(n) {
		        return Math.abs(n);
		    },
	
		    batch: function(arr, linecount, fill_with) {
		        var i;
		        var res = [];
		        var tmp = [];
	
		        for(i = 0; i < arr.length; i++) {
		            if(i % linecount === 0 && tmp.length) {
		                res.push(tmp);
		                tmp = [];
		            }
	
		            tmp.push(arr[i]);
		        }
	
		        if(tmp.length) {
		            if(fill_with) {
		                for(i = tmp.length; i < linecount; i++) {
		                    tmp.push(fill_with);
		                }
		            }
	
		            res.push(tmp);
		        }
	
		        return res;
		    },
	
		    capitalize: function(str) {
		        str = normalize(str, '');
		        var ret = str.toLowerCase();
		        return r.copySafeness(str, ret.charAt(0).toUpperCase() + ret.slice(1));
		    },
	
		    center: function(str, width) {
		        str = normalize(str, '');
		        width = width || 80;
	
		        if(str.length >= width) {
		            return str;
		        }
	
		        var spaces = width - str.length;
		        var pre = lib.repeat(' ', spaces/2 - spaces % 2);
		        var post = lib.repeat(' ', spaces/2);
		        return r.copySafeness(str, pre + str + post);
		    },
	
		    'default': function(val, def, bool) {
		        if(bool !== true && bool !== false && !hasWarnedDefault) {
		            hasWarnedDefault = true;
		            console.log(
		                '[nunjucks] Warning: the "default" filter was used without ' +
		                'specifying the type of comparison. 2.0 changed the default ' +
		                'behavior from boolean (val ? val : def) to strictly undefined, ' +
		                'so you should make sure that doesn\'t break anything. ' +
		                'Be explicit about this to make this warning go away, or wait until 2.1. ' +
		                'See http://mozilla.github.io/nunjucks/templating.html#defaultvalue-default-boolean'
		            );
		        }
	
		        if(bool) {
		            return val ? val : def;
		        }
		        else {
		            return (val !== undefined) ? val : def;
		        }
		    },
	
		    dictsort: function(val, case_sensitive, by) {
		        if (!lib.isObject(val)) {
		            throw new lib.TemplateError('dictsort filter: val must be an object');
		        }
	
		        var array = [];
		        for (var k in val) {
		            // deliberately include properties from the object's prototype
		            array.push([k,val[k]]);
		        }
	
		        var si;
		        if (by === undefined || by === 'key') {
		            si = 0;
		        } else if (by === 'value') {
		            si = 1;
		        } else {
		            throw new lib.TemplateError(
		                'dictsort filter: You can only sort by either key or value');
		        }
	
		        array.sort(function(t1, t2) {
		            var a = t1[si];
		            var b = t2[si];
	
		            if (!case_sensitive) {
		                if (lib.isString(a)) {
		                    a = a.toUpperCase();
		                }
		                if (lib.isString(b)) {
		                    b = b.toUpperCase();
		                }
		            }
	
		            return a > b ? 1 : (a === b ? 0 : -1);
		        });
	
		        return array;
		    },
	
		    dump: function(obj) {
		        return JSON.stringify(obj);
		    },
	
		    escape: function(str) {
		        if(typeof str === 'string' ||
		           str instanceof r.SafeString) {
		            return lib.escape(str);
		        }
		        return str;
		    },
	
		    safe: function(str) {
		        return r.markSafe(str);
		    },
	
		    first: function(arr) {
		        return arr[0];
		    },
	
		    groupby: function(arr, attr) {
		        return lib.groupBy(arr, attr);
		    },
	
		    indent: function(str, width, indentfirst) {
		        str = normalize(str, '');
	
		        if (str === '') return '';
	
		        width = width || 4;
		        var res = '';
		        var lines = str.split('\n');
		        var sp = lib.repeat(' ', width);
	
		        for(var i=0; i<lines.length; i++) {
		            if(i === 0 && !indentfirst) {
		                res += lines[i] + '\n';
		            }
		            else {
		                res += sp + lines[i] + '\n';
		            }
		        }
	
		        return r.copySafeness(str, res);
		    },
	
		    join: function(arr, del, attr) {
		        del = del || '';
	
		        if(attr) {
		            arr = lib.map(arr, function(v) {
		                return v[attr];
		            });
		        }
	
		        return arr.join(del);
		    },
	
		    last: function(arr) {
		        return arr[arr.length-1];
		    },
	
		    length: function(val) {
		        var value = normalize(val, '');
	
		        return value !== undefined ? value.length : 0;
		    },
	
		    list: function(val) {
		        if(lib.isString(val)) {
		            return val.split('');
		        }
		        else if(lib.isObject(val)) {
		            var keys = [];
	
		            if(Object.keys) {
		                keys = Object.keys(val);
		            }
		            else {
		                for(var k in val) {
		                    keys.push(k);
		                }
		            }
	
		            return lib.map(keys, function(k) {
		                return { key: k,
		                         value: val[k] };
		            });
		        }
		        else if(lib.isArray(val)) {
		          return val;
		        }
		        else {
		            throw new lib.TemplateError('list filter: type not iterable');
		        }
		    },
	
		    lower: function(str) {
		        str = normalize(str, '');
		        return str.toLowerCase();
		    },
	
		    random: function(arr) {
		        return arr[Math.floor(Math.random() * arr.length)];
		    },
	
		    rejectattr: function(arr, attr) {
		      return arr.filter(function (item) {
		        return !item[attr];
		      });
		    },
	
		    selectattr: function(arr, attr) {
		      return arr.filter(function (item) {
		        return !!item[attr];
		      });
		    },
	
		    replace: function(str, old, new_, maxCount) {
		        var originalStr = str;
	
		        if (old instanceof RegExp) {
		            return str.replace(old, new_);
		        }
	
		        if(typeof maxCount === 'undefined'){
		            maxCount = -1;
		        }
	
		        var res = '';  // Output
	
		        // Cast Numbers in the search term to string
		        if(typeof old === 'number'){
		            old = old + '';
		        }
		        else if(typeof old !== 'string') {
		            // If it is something other than number or string,
		            // return the original string
		            return str;
		        }
	
		        // Cast numbers in the replacement to string
		        if(typeof str === 'number'){
		            str = str + '';
		        }
	
		        // If by now, we don't have a string, throw it back
		        if(typeof str !== 'string' && !(str instanceof r.SafeString)){
		            return str;
		        }
	
		        // ShortCircuits
		        if(old === ''){
		            // Mimic the python behaviour: empty string is replaced
		            // by replacement e.g. "abc"|replace("", ".") -> .a.b.c.
		            res = new_ + str.split('').join(new_) + new_;
		            return r.copySafeness(str, res);
		        }
	
		        var nextIndex = str.indexOf(old);
		        // if # of replacements to perform is 0, or the string to does
		        // not contain the old value, return the string
		        if(maxCount === 0 || nextIndex === -1){
		            return str;
		        }
	
		        var pos = 0;
		        var count = 0; // # of replacements made
	
		        while(nextIndex  > -1 && (maxCount === -1 || count < maxCount)){
		            // Grab the next chunk of src string and add it with the
		            // replacement, to the result
		            res += str.substring(pos, nextIndex) + new_;
		            // Increment our pointer in the src string
		            pos = nextIndex + old.length;
		            count++;
		            // See if there are any more replacements to be made
		            nextIndex = str.indexOf(old, pos);
		        }
	
		        // We've either reached the end, or done the max # of
		        // replacements, tack on any remaining string
		        if(pos < str.length) {
		            res += str.substring(pos);
		        }
	
		        return r.copySafeness(originalStr, res);
		    },
	
		    reverse: function(val) {
		        var arr;
		        if(lib.isString(val)) {
		            arr = filters.list(val);
		        }
		        else {
		            // Copy it
		            arr = lib.map(val, function(v) { return v; });
		        }
	
		        arr.reverse();
	
		        if(lib.isString(val)) {
		            return r.copySafeness(val, arr.join(''));
		        }
		        return arr;
		    },
	
		    round: function(val, precision, method) {
		        precision = precision || 0;
		        var factor = Math.pow(10, precision);
		        var rounder;
	
		        if(method === 'ceil') {
		            rounder = Math.ceil;
		        }
		        else if(method === 'floor') {
		            rounder = Math.floor;
		        }
		        else {
		            rounder = Math.round;
		        }
	
		        return rounder(val * factor) / factor;
		    },
	
		    slice: function(arr, slices, fillWith) {
		        var sliceLength = Math.floor(arr.length / slices);
		        var extra = arr.length % slices;
		        var offset = 0;
		        var res = [];
	
		        for(var i=0; i<slices; i++) {
		            var start = offset + i * sliceLength;
		            if(i < extra) {
		                offset++;
		            }
		            var end = offset + (i + 1) * sliceLength;
	
		            var slice = arr.slice(start, end);
		            if(fillWith && i >= extra) {
		                slice.push(fillWith);
		            }
		            res.push(slice);
		        }
	
		        return res;
		    },
	
		    sort: r.makeMacro(['value', 'reverse', 'case_sensitive', 'attribute'], [], function(arr, reverse, caseSens, attr) {
		         // Copy it
		        arr = lib.map(arr, function(v) { return v; });
	
		        arr.sort(function(a, b) {
		            var x, y;
	
		            if(attr) {
		                x = a[attr];
		                y = b[attr];
		            }
		            else {
		                x = a;
		                y = b;
		            }
	
		            if(!caseSens && lib.isString(x) && lib.isString(y)) {
		                x = x.toLowerCase();
		                y = y.toLowerCase();
		            }
	
		            if(x < y) {
		                return reverse ? 1 : -1;
		            }
		            else if(x > y) {
		                return reverse ? -1: 1;
		            }
		            else {
		                return 0;
		            }
		        });
	
		        return arr;
		    }),
	
		    string: function(obj) {
		        return r.copySafeness(obj, obj);
		    },
	
		    title: function(str) {
		        str = normalize(str, '');
		        var words = str.split(' ');
		        for(var i = 0; i < words.length; i++) {
		            words[i] = filters.capitalize(words[i]);
		        }
		        return r.copySafeness(str, words.join(' '));
		    },
	
		    trim: function(str) {
		        return r.copySafeness(str, str.replace(/^\s*|\s*$/g, ''));
		    },
	
		    truncate: function(input, length, killwords, end) {
		        var orig = input;
		        input = normalize(input, '');
		        length = length || 255;
	
		        if (input.length <= length)
		            return input;
	
		        if (killwords) {
		            input = input.substring(0, length);
		        } else {
		            var idx = input.lastIndexOf(' ', length);
		            if(idx === -1) {
		                idx = length;
		            }
	
		            input = input.substring(0, idx);
		        }
	
		        input += (end !== undefined && end !== null) ? end : '...';
		        return r.copySafeness(orig, input);
		    },
	
		    upper: function(str) {
		        str = normalize(str, '');
		        return str.toUpperCase();
		    },
	
		    urlencode: function(obj) {
		        var enc = encodeURIComponent;
		        if (lib.isString(obj)) {
		            return enc(obj);
		        } else {
		            var parts;
		            if (lib.isArray(obj)) {
		                parts = obj.map(function(item) {
		                    return enc(item[0]) + '=' + enc(item[1]);
		                });
		            } else {
		                parts = [];
		                for (var k in obj) {
		                    if (obj.hasOwnProperty(k)) {
		                        parts.push(enc(k) + '=' + enc(obj[k]));
		                    }
		                }
		            }
		            return parts.join('&');
		        }
		    },
	
		    urlize: function(str, length, nofollow) {
		        if (isNaN(length)) length = Infinity;
	
		        var noFollowAttr = (nofollow === true ? ' rel="nofollow"' : '');
	
		        // For the jinja regexp, see
		        // https://github.com/mitsuhiko/jinja2/blob/f15b814dcba6aa12bc74d1f7d0c881d55f7126be/jinja2/utils.py#L20-L23
		        var puncRE = /^(?:\(|<|&lt;)?(.*?)(?:\.|,|\)|\n|&gt;)?$/;
		        // from http://blog.gerv.net/2011/05/html5_email_address_regexp/
		        var emailRE = /^[\w.!#$%&'*+\-\/=?\^`{|}~]+@[a-z\d\-]+(\.[a-z\d\-]+)+$/i;
		        var httpHttpsRE = /^https?:\/\/.*$/;
		        var wwwRE = /^www\./;
		        var tldRE = /\.(?:org|net|com)(?:\:|\/|$)/;
	
		        var words = str.split(/\s+/).filter(function(word) {
		          // If the word has no length, bail. This can happen for str with
		          // trailing whitespace.
		          return word && word.length;
		        }).map(function(word) {
		          var matches = word.match(puncRE);
		          var possibleUrl = matches && matches[1] || word;
	
		          // url that starts with http or https
		          if (httpHttpsRE.test(possibleUrl))
		            return '<a href="' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';
	
		          // url that starts with www.
		          if (wwwRE.test(possibleUrl))
		            return '<a href="http://' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';
	
		          // an email address of the form username@domain.tld
		          if (emailRE.test(possibleUrl))
		            return '<a href="mailto:' + possibleUrl + '">' + possibleUrl + '</a>';
	
		          // url that ends in .com, .org or .net that is not an email address
		          if (tldRE.test(possibleUrl))
		            return '<a href="http://' + possibleUrl + '"' + noFollowAttr + '>' + possibleUrl.substr(0, length) + '</a>';
	
		          return word;
	
		        });
	
		        return words.join(' ');
		    },
	
		    wordcount: function(str) {
		        str = normalize(str, '');
		        var words = (str) ? str.match(/\w+/g) : null;
		        return (words) ? words.length : null;
		    },
	
		    'float': function(val, def) {
		        var res = parseFloat(val);
		        return isNaN(res) ? def : res;
		    },
	
		    'int': function(val, def) {
		        var res = parseInt(val, 10);
		        return isNaN(res) ? def : res;
		    }
		};
	
		// Aliases
		filters.d = filters['default'];
		filters.e = filters.escape;
	
		module.exports = filters;
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var lib = __webpack_require__(2);
		var Obj = __webpack_require__(6);
	
		// Frames keep track of scoping both at compile-time and run-time so
		// we know how to access variables. Block tags can introduce special
		// variables, for example.
		var Frame = Obj.extend({
		    init: function(parent) {
		        this.variables = {};
		        this.parent = parent;
		        this.topLevel = false;
		    },
	
		    set: function(name, val, resolveUp) {
		        // Allow variables with dots by automatically creating the
		        // nested structure
		        var parts = name.split('.');
		        var obj = this.variables;
		        var frame = this;
	
		        if(resolveUp) {
		            if((frame = this.resolve(parts[0]))) {
		                frame.set(name, val);
		                return;
		            }
		            frame = this;
		        }
	
		        for(var i=0; i<parts.length - 1; i++) {
		            var id = parts[i];
	
		            if(!obj[id]) {
		                obj[id] = {};
		            }
		            obj = obj[id];
		        }
	
		        obj[parts[parts.length - 1]] = val;
		    },
	
		    get: function(name) {
		        var val = this.variables[name];
		        if(val !== undefined && val !== null) {
		            return val;
		        }
		        return null;
		    },
	
		    lookup: function(name) {
		        var p = this.parent;
		        var val = this.variables[name];
		        if(val !== undefined && val !== null) {
		            return val;
		        }
		        return p && p.lookup(name);
		    },
	
		    resolve: function(name) {
		        var p = this.parent;
		        var val = this.variables[name];
		        if(val !== undefined && val !== null) {
		            return this;
		        }
		        return p && p.resolve(name);
		    },
	
		    push: function() {
		        return new Frame(this);
		    },
	
		    pop: function() {
		        return this.parent;
		    }
		});
	
		function makeMacro(argNames, kwargNames, func) {
		    return function() {
		        var argCount = numArgs(arguments);
		        var args;
		        var kwargs = getKeywordArgs(arguments);
		        var i;
	
		        if(argCount > argNames.length) {
		            args = Array.prototype.slice.call(arguments, 0, argNames.length);
	
		            // Positional arguments that should be passed in as
		            // keyword arguments (essentially default values)
		            var vals = Array.prototype.slice.call(arguments, args.length, argCount);
		            for(i = 0; i < vals.length; i++) {
		                if(i < kwargNames.length) {
		                    kwargs[kwargNames[i]] = vals[i];
		                }
		            }
	
		            args.push(kwargs);
		        }
		        else if(argCount < argNames.length) {
		            args = Array.prototype.slice.call(arguments, 0, argCount);
	
		            for(i = argCount; i < argNames.length; i++) {
		                var arg = argNames[i];
	
		                // Keyword arguments that should be passed as
		                // positional arguments, i.e. the caller explicitly
		                // used the name of a positional arg
		                args.push(kwargs[arg]);
		                delete kwargs[arg];
		            }
	
		            args.push(kwargs);
		        }
		        else {
		            args = arguments;
		        }
	
		        return func.apply(this, args);
		    };
		}
	
		function makeKeywordArgs(obj) {
		    obj.__keywords = true;
		    return obj;
		}
	
		function getKeywordArgs(args) {
		    var len = args.length;
		    if(len) {
		        var lastArg = args[len - 1];
		        if(lastArg && lastArg.hasOwnProperty('__keywords')) {
		            return lastArg;
		        }
		    }
		    return {};
		}
	
		function numArgs(args) {
		    var len = args.length;
		    if(len === 0) {
		        return 0;
		    }
	
		    var lastArg = args[len - 1];
		    if(lastArg && lastArg.hasOwnProperty('__keywords')) {
		        return len - 1;
		    }
		    else {
		        return len;
		    }
		}
	
		// A SafeString object indicates that the string should not be
		// autoescaped. This happens magically because autoescaping only
		// occurs on primitive string objects.
		function SafeString(val) {
		    if(typeof val !== 'string') {
		        return val;
		    }
	
		    this.val = val;
		    this.length = val.length;
		}
	
		SafeString.prototype = Object.create(String.prototype, {
		    length: { writable: true, configurable: true, value: 0 }
		});
		SafeString.prototype.valueOf = function() {
		    return this.val;
		};
		SafeString.prototype.toString = function() {
		    return this.val;
		};
	
		function copySafeness(dest, target) {
		    if(dest instanceof SafeString) {
		        return new SafeString(target);
		    }
		    return target.toString();
		}
	
		function markSafe(val) {
		    var type = typeof val;
	
		    if(type === 'string') {
		        return new SafeString(val);
		    }
		    else if(type !== 'function') {
		        return val;
		    }
		    else {
		        return function() {
		            var ret = val.apply(this, arguments);
	
		            if(typeof ret === 'string') {
		                return new SafeString(ret);
		            }
	
		            return ret;
		        };
		    }
		}
	
		function suppressValue(val, autoescape) {
		    val = (val !== undefined && val !== null) ? val : '';
	
		    if(autoescape && typeof val === 'string') {
		        val = lib.escape(val);
		    }
	
		    return val;
		}
	
		function ensureDefined(val, lineno, colno) {
		    if(val === null || val === undefined) {
		        throw new lib.TemplateError(
		            'attempted to output null or undefined value',
		            lineno + 1,
		            colno + 1
		        );
		    }
		    return val;
		}
	
		function memberLookup(obj, val) {
		    obj = obj || {};
	
		    if(typeof obj[val] === 'function') {
		        return function() {
		            return obj[val].apply(obj, arguments);
		        };
		    }
	
		    return obj[val];
		}
	
		function callWrap(obj, name, context, args) {
		    if(!obj) {
		        throw new Error('Unable to call `' + name + '`, which is undefined or falsey');
		    }
		    else if(typeof obj !== 'function') {
		        throw new Error('Unable to call `' + name + '`, which is not a function');
		    }
	
		    // jshint validthis: true
		    return obj.apply(context, args);
		}
	
		function contextOrFrameLookup(context, frame, name) {
		    var val = frame.lookup(name);
		    return (val !== undefined && val !== null) ?
		        val :
		        context.lookup(name);
		}
	
		function handleError(error, lineno, colno) {
		    if(error.lineno) {
		        return error;
		    }
		    else {
		        return new lib.TemplateError(error, lineno, colno);
		    }
		}
	
		function asyncEach(arr, dimen, iter, cb) {
		    if(lib.isArray(arr)) {
		        var len = arr.length;
	
		        lib.asyncIter(arr, function(item, i, next) {
		            switch(dimen) {
		            case 1: iter(item, i, len, next); break;
		            case 2: iter(item[0], item[1], i, len, next); break;
		            case 3: iter(item[0], item[1], item[2], i, len, next); break;
		            default:
		                item.push(i, next);
		                iter.apply(this, item);
		            }
		        }, cb);
		    }
		    else {
		        lib.asyncFor(arr, function(key, val, i, len, next) {
		            iter(key, val, i, len, next);
		        }, cb);
		    }
		}
	
		function asyncAll(arr, dimen, func, cb) {
		    var finished = 0;
		    var len, i;
		    var outputArr;
	
		    function done(i, output) {
		        finished++;
		        outputArr[i] = output;
	
		        if(finished === len) {
		            cb(null, outputArr.join(''));
		        }
		    }
	
		    if(lib.isArray(arr)) {
		        len = arr.length;
		        outputArr = new Array(len);
	
		        if(len === 0) {
		            cb(null, '');
		        }
		        else {
		            for(i = 0; i < arr.length; i++) {
		                var item = arr[i];
	
		                switch(dimen) {
		                case 1: func(item, i, len, done); break;
		                case 2: func(item[0], item[1], i, len, done); break;
		                case 3: func(item[0], item[1], item[2], i, len, done); break;
		                default:
		                    item.push(i, done);
		                    // jshint validthis: true
		                    func.apply(this, item);
		                }
		            }
		        }
		    }
		    else {
		        var keys = lib.keys(arr);
		        len = keys.length;
		        outputArr = new Array(len);
	
		        if(len === 0) {
		            cb(null, '');
		        }
		        else {
		            for(i = 0; i < keys.length; i++) {
		                var k = keys[i];
		                func(k, arr[k], i, len, done);
		            }
		        }
		    }
		}
	
		module.exports = {
		    Frame: Frame,
		    makeMacro: makeMacro,
		    makeKeywordArgs: makeKeywordArgs,
		    numArgs: numArgs,
		    suppressValue: suppressValue,
		    ensureDefined: ensureDefined,
		    memberLookup: memberLookup,
		    contextOrFrameLookup: contextOrFrameLookup,
		    callWrap: callWrap,
		    handleError: handleError,
		    isArray: lib.isArray,
		    keys: lib.keys,
		    SafeString: SafeString,
		    copySafeness: copySafeness,
		    markSafe: markSafe,
		    asyncEach: asyncEach,
		    asyncAll: asyncAll
		};
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		'use strict';
	
		// A simple class system, more documentation to come
	
		function extend(cls, name, props) {
		    // This does that same thing as Object.create, but with support for IE8
		    var F = function() {};
		    F.prototype = cls.prototype;
		    var prototype = new F();
	
		    // jshint undef: false
		    var fnTest = /xyz/.test(function(){ xyz; }) ? /\bparent\b/ : /.*/;
		    props = props || {};
	
		    for(var k in props) {
		        var src = props[k];
		        var parent = prototype[k];
	
		        if(typeof parent === 'function' &&
		           typeof src === 'function' &&
		           fnTest.test(src)) {
		            /*jshint -W083 */
		            prototype[k] = (function (src, parent) {
		                return function() {
		                    // Save the current parent method
		                    var tmp = this.parent;
	
		                    // Set parent to the previous method, call, and restore
		                    this.parent = parent;
		                    var res = src.apply(this, arguments);
		                    this.parent = tmp;
	
		                    return res;
		                };
		            })(src, parent);
		        }
		        else {
		            prototype[k] = src;
		        }
		    }
	
		    prototype.typename = name;
	
		    var new_cls = function() {
		        if(prototype.init) {
		            prototype.init.apply(this, arguments);
		        }
		    };
	
		    new_cls.prototype = prototype;
		    new_cls.prototype.constructor = new_cls;
	
		    new_cls.extend = function(name, props) {
		        if(typeof name === 'object') {
		            props = name;
		            name = 'anonymous';
		        }
		        return extend(new_cls, name, props);
		    };
	
		    return new_cls;
		}
	
		module.exports = extend(Object, 'Object', {});
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		// rawAsap provides everything we need except exception management.
		var rawAsap = __webpack_require__(8);
		// RawTasks are recycled to reduce GC churn.
		var freeTasks = [];
		// We queue errors to ensure they are thrown in right order (FIFO).
		// Array-as-queue is good enough here, since we are just dealing with exceptions.
		var pendingErrors = [];
		var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
		function throwFirstError() {
		    if (pendingErrors.length) {
		        throw pendingErrors.shift();
		    }
		}
	
		/**
		 * Calls a task as soon as possible after returning, in its own event, with priority
		 * over other events like animation, reflow, and repaint. An error thrown from an
		 * event will not interrupt, nor even substantially slow down the processing of
		 * other events, but will be rather postponed to a lower priority event.
		 * @param {{call}} task A callable object, typically a function that takes no
		 * arguments.
		 */
		module.exports = asap;
		function asap(task) {
		    var rawTask;
		    if (freeTasks.length) {
		        rawTask = freeTasks.pop();
		    } else {
		        rawTask = new RawTask();
		    }
		    rawTask.task = task;
		    rawAsap(rawTask);
		}
	
		// We wrap tasks with recyclable task objects.  A task object implements
		// `call`, just like a function.
		function RawTask() {
		    this.task = null;
		}
	
		// The sole purpose of wrapping the task is to catch the exception and recycle
		// the task object after its single use.
		RawTask.prototype.call = function () {
		    try {
		        this.task.call();
		    } catch (error) {
		        if (asap.onerror) {
		            // This hook exists purely for testing purposes.
		            // Its name will be periodically randomized to break any code that
		            // depends on its existence.
		            asap.onerror(error);
		        } else {
		            // In a web browser, exceptions are not fatal. However, to avoid
		            // slowing down the queue of pending tasks, we rethrow the error in a
		            // lower priority turn.
		            pendingErrors.push(error);
		            requestErrorThrow();
		        }
		    } finally {
		        this.task = null;
		        freeTasks[freeTasks.length] = this;
		    }
		};
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
		// Use the fastest means possible to execute a task in its own turn, with
		// priority over other events including IO, animation, reflow, and redraw
		// events in browsers.
		//
		// An exception thrown by a task will permanently interrupt the processing of
		// subsequent tasks. The higher level `asap` function ensures that if an
		// exception is thrown by a task, that the task queue will continue flushing as
		// soon as possible, but if you use `rawAsap` directly, you are responsible to
		// either ensure that no exceptions are thrown from your task, or to manually
		// call `rawAsap.requestFlush` if an exception is thrown.
		module.exports = rawAsap;
		function rawAsap(task) {
		    if (!queue.length) {
		        requestFlush();
		        flushing = true;
		    }
		    // Equivalent to push, but avoids a function call.
		    queue[queue.length] = task;
		}
	
		var queue = [];
		// Once a flush has been requested, no further calls to `requestFlush` are
		// necessary until the next `flush` completes.
		var flushing = false;
		// `requestFlush` is an implementation-specific method that attempts to kick
		// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
		// the event queue before yielding to the browser's own event loop.
		var requestFlush;
		// The position of the next task to execute in the task queue. This is
		// preserved between calls to `flush` so that it can be resumed if
		// a task throws an exception.
		var index = 0;
		// If a task schedules additional tasks recursively, the task queue can grow
		// unbounded. To prevent memory exhaustion, the task queue will periodically
		// truncate already-completed tasks.
		var capacity = 1024;
	
		// The flush function processes all tasks that have been scheduled with
		// `rawAsap` unless and until one of those tasks throws an exception.
		// If a task throws an exception, `flush` ensures that its state will remain
		// consistent and will resume where it left off when called again.
		// However, `flush` does not make any arrangements to be called again if an
		// exception is thrown.
		function flush() {
		    while (index < queue.length) {
		        var currentIndex = index;
		        // Advance the index before calling the task. This ensures that we will
		        // begin flushing on the next task the task throws an error.
		        index = index + 1;
		        queue[currentIndex].call();
		        // Prevent leaking memory for long chains of recursive calls to `asap`.
		        // If we call `asap` within tasks scheduled by `asap`, the queue will
		        // grow, but to avoid an O(n) walk for every task we execute, we don't
		        // shift tasks off the queue after they have been executed.
		        // Instead, we periodically shift 1024 tasks off the queue.
		        if (index > capacity) {
		            // Manually shift all values starting at the index back to the
		            // beginning of the queue.
		            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
		                queue[scan] = queue[scan + index];
		            }
		            queue.length -= index;
		            index = 0;
		        }
		    }
		    queue.length = 0;
		    index = 0;
		    flushing = false;
		}
	
		// `requestFlush` is implemented using a strategy based on data collected from
		// every available SauceLabs Selenium web driver worker at time of writing.
		// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
		// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
		// have WebKitMutationObserver but not un-prefixed MutationObserver.
		// Must use `global` instead of `window` to work in both frames and web
		// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
		var BrowserMutationObserver = global.MutationObserver || global.WebKitMutationObserver;
	
		// MutationObservers are desirable because they have high priority and work
		// reliably everywhere they are implemented.
		// They are implemented in all modern browsers.
		//
		// - Android 4-4.3
		// - Chrome 26-34
		// - Firefox 14-29
		// - Internet Explorer 11
		// - iPad Safari 6-7.1
		// - iPhone Safari 7-7.1
		// - Safari 6-7
		if (typeof BrowserMutationObserver === "function") {
		    requestFlush = makeRequestCallFromMutationObserver(flush);
	
		// MessageChannels are desirable because they give direct access to the HTML
		// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
		// 11-12, and in web workers in many engines.
		// Although message channels yield to any queued rendering and IO tasks, they
		// would be better than imposing the 4ms delay of timers.
		// However, they do not work reliably in Internet Explorer or Safari.
	
		// Internet Explorer 10 is the only browser that has setImmediate but does
		// not have MutationObservers.
		// Although setImmediate yields to the browser's renderer, it would be
		// preferrable to falling back to setTimeout since it does not have
		// the minimum 4ms penalty.
		// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
		// Desktop to a lesser extent) that renders both setImmediate and
		// MessageChannel useless for the purposes of ASAP.
		// https://github.com/kriskowal/q/issues/396
	
		// Timers are implemented universally.
		// We fall back to timers in workers in most engines, and in foreground
		// contexts in the following browsers.
		// However, note that even this simple case requires nuances to operate in a
		// broad spectrum of browsers.
		//
		// - Firefox 3-13
		// - Internet Explorer 6-9
		// - iPad Safari 4.3
		// - Lynx 2.8.7
		} else {
		    requestFlush = makeRequestCallFromTimer(flush);
		}
	
		// `requestFlush` requests that the high priority event queue be flushed as
		// soon as possible.
		// This is useful to prevent an error thrown in a task from stalling the event
		// queue if the exception handled by Node.js’s
		// `process.on("uncaughtException")` or by a domain.
		rawAsap.requestFlush = requestFlush;
	
		// To request a high priority event, we induce a mutation observer by toggling
		// the text of a text node between "1" and "-1".
		function makeRequestCallFromMutationObserver(callback) {
		    var toggle = 1;
		    var observer = new BrowserMutationObserver(callback);
		    var node = document.createTextNode("");
		    observer.observe(node, {characterData: true});
		    return function requestCall() {
		        toggle = -toggle;
		        node.data = toggle;
		    };
		}
	
		// The message channel technique was discovered by Malte Ubl and was the
		// original foundation for this library.
		// http://www.nonblocking.io/2011/06/windownexttick.html
	
		// Safari 6.0.5 (at least) intermittently fails to create message ports on a
		// page's first load. Thankfully, this version of Safari supports
		// MutationObservers, so we don't need to fall back in that case.
	
		// function makeRequestCallFromMessageChannel(callback) {
		//     var channel = new MessageChannel();
		//     channel.port1.onmessage = callback;
		//     return function requestCall() {
		//         channel.port2.postMessage(0);
		//     };
		// }
	
		// For reasons explained above, we are also unable to use `setImmediate`
		// under any circumstances.
		// Even if we were, there is another bug in Internet Explorer 10.
		// It is not sufficient to assign `setImmediate` to `requestFlush` because
		// `setImmediate` must be called *by name* and therefore must be wrapped in a
		// closure.
		// Never forget.
	
		// function makeRequestCallFromSetImmediate(callback) {
		//     return function requestCall() {
		//         setImmediate(callback);
		//     };
		// }
	
		// Safari 6.0 has a problem where timers will get lost while the user is
		// scrolling. This problem does not impact ASAP because Safari 6.0 supports
		// mutation observers, so that implementation is used instead.
		// However, if we ever elect to use timers in Safari, the prevalent work-around
		// is to add a scroll event listener that calls for a flush.
	
		// `setTimeout` does not call the passed callback if the delay is less than
		// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
		// even then.
	
		function makeRequestCallFromTimer(callback) {
		    return function requestCall() {
		        // We dispatch a timeout with a specified delay of 0 for engines that
		        // can reliably accommodate that request. This will usually be snapped
		        // to a 4 milisecond delay, but once we're flushing, there's no delay
		        // between events.
		        var timeoutHandle = setTimeout(handleTimer, 0);
		        // However, since this timer gets frequently dropped in Firefox
		        // workers, we enlist an interval handle that will try to fire
		        // an event 20 times per second until it succeeds.
		        var intervalHandle = setInterval(handleTimer, 50);
	
		        function handleTimer() {
		            // Whichever timer succeeds will cancel both timers and
		            // execute the callback.
		            clearTimeout(timeoutHandle);
		            clearInterval(intervalHandle);
		            callback();
		        }
		    };
		}
	
		// This is for `asap.js` only.
		// Its name will be periodically randomized to break any code that depends on
		// its existence.
		rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
		// ASAP was originally a nextTick shim included in Q. This was factored out
		// into this ASAP package. It was later adapted to RSVP which made further
		// amendments. These decisions, particularly to marginalize MessageChannel and
		// to capture the MutationObserver implementation in a closure, were integrated
		// back into ASAP proper.
		// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		'use strict';
	
		function cycler(items) {
		    var index = -1;
	
		    return {
		        current: null,
		        reset: function() {
		            index = -1;
		            this.current = null;
		        },
	
		        next: function() {
		            index++;
		            if(index >= items.length) {
		                index = 0;
		            }
	
		            this.current = items[index];
		            return this.current;
		        },
		    };
	
		}
	
		function joiner(sep) {
		    sep = sep || ',';
		    var first = true;
	
		    return function() {
		        var val = first ? '' : sep;
		        first = false;
		        return val;
		    };
		}
	
		var globals = {
		    range: function(start, stop, step) {
		        if(!stop) {
		            stop = start;
		            start = 0;
		            step = 1;
		        }
		        else if(!step) {
		            step = 1;
		        }
	
		        var arr = [];
		        for(var i=start; i<stop; i+=step) {
		            arr.push(i);
		        }
		        return arr;
		    },
	
		    // lipsum: function(n, html, min, max) {
		    // },
	
		    cycler: function() {
		        return cycler(Array.prototype.slice.call(arguments));
		    },
	
		    joiner: function(sep) {
		        return joiner(sep);
		    }
		};
	
		module.exports = globals;
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Loader = __webpack_require__(11);
	
		var PrecompiledLoader = Loader.extend({
		    init: function(compiledTemplates) {
		        this.precompiled = compiledTemplates || {};
		    },
	
		    getSource: function(name) {
		        if (this.precompiled[name]) {
		            return {
		                src: { type: 'code',
		                       obj: this.precompiled[name] },
		                path: name
		            };
		        }
		        return null;
		    }
		});
	
		module.exports = PrecompiledLoader;
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var path = __webpack_require__(1);
		var Obj = __webpack_require__(6);
		var lib = __webpack_require__(2);
	
		var Loader = Obj.extend({
		    on: function(name, func) {
		        this.listeners = this.listeners || {};
		        this.listeners[name] = this.listeners[name] || [];
		        this.listeners[name].push(func);
		    },
	
		    emit: function(name /*, arg1, arg2, ...*/) {
		        var args = Array.prototype.slice.call(arguments, 1);
	
		        if(this.listeners && this.listeners[name]) {
		            lib.each(this.listeners[name], function(listener) {
		                listener.apply(null, args);
		            });
		        }
		    },
	
		    resolve: function(from, to) {
		        return path.resolve(path.dirname(from), to);
		    },
	
		    isRelative: function(filename) {
		        return (filename.indexOf('./') === 0 || filename.indexOf('../') === 0);
		    }
		});
	
		module.exports = Loader;
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		function installCompat() {
		  'use strict';
	
		  // This must be called like `nunjucks.installCompat` so that `this`
		  // references the nunjucks instance
		  var runtime = this.runtime; // jshint ignore:line
		  var lib = this.lib; // jshint ignore:line
	
		  var orig_contextOrFrameLookup = runtime.contextOrFrameLookup;
		  runtime.contextOrFrameLookup = function(context, frame, key) {
		    var val = orig_contextOrFrameLookup.apply(this, arguments);
		    if (val === undefined) {
		      switch (key) {
		      case 'True':
		        return true;
		      case 'False':
		        return false;
		      case 'None':
		        return null;
		      }
		    }
	
		    return val;
		  };
	
		  var orig_memberLookup = runtime.memberLookup;
		  var ARRAY_MEMBERS = {
		    pop: function(index) {
		      if (index === undefined) {
		        return this.pop();
		      }
		      if (index >= this.length || index < 0) {
		        throw new Error('KeyError');
		      }
		      return this.splice(index, 1);
		    },
		    remove: function(element) {
		      for (var i = 0; i < this.length; i++) {
		        if (this[i] === element) {
		          return this.splice(i, 1);
		        }
		      }
		      throw new Error('ValueError');
		    },
		    count: function(element) {
		      var count = 0;
		      for (var i = 0; i < this.length; i++) {
		        if (this[i] === element) {
		          count++;
		        }
		      }
		      return count;
		    },
		    index: function(element) {
		      var i;
		      if ((i = this.indexOf(element)) === -1) {
		        throw new Error('ValueError');
		      }
		      return i;
		    },
		    find: function(element) {
		      return this.indexOf(element);
		    },
		    insert: function(index, elem) {
		      return this.splice(index, 0, elem);
		    }
		  };
		  var OBJECT_MEMBERS = {
		    items: function() {
		      var ret = [];
		      for(var k in this) {
		        ret.push([k, this[k]]);
		      }
		      return ret;
		    },
		    values: function() {
		      var ret = [];
		      for(var k in this) {
		        ret.push(this[k]);
		      }
		      return ret;
		    },
		    keys: function() {
		      var ret = [];
		      for(var k in this) {
		        ret.push(k);
		      }
		      return ret;
		    },
		    get: function(key, def) {
		      var output = this[key];
		      if (output === undefined) {
		        output = def;
		      }
		      return output;
		    },
		    has_key: function(key) {
		      return this.hasOwnProperty(key);
		    },
		    pop: function(key, def) {
		      var output = this[key];
		      if (output === undefined && def !== undefined) {
		        output = def;
		      } else if (output === undefined) {
		        throw new Error('KeyError');
		      } else {
		        delete this[key];
		      }
		      return output;
		    },
		    popitem: function() {
		      for (var k in this) {
		        // Return the first object pair.
		        var val = this[k];
		        delete this[k];
		        return [k, val];
		      }
		      throw new Error('KeyError');
		    },
		    setdefault: function(key, def) {
		      if (key in this) {
		        return this[key];
		      }
		      if (def === undefined) {
		        def = null;
		      }
		      return this[key] = def;
		    },
		    update: function(kwargs) {
		      for (var k in kwargs) {
		        this[k] = kwargs[k];
		      }
		      return null;  // Always returns None
		    }
		  };
		  OBJECT_MEMBERS.iteritems = OBJECT_MEMBERS.items;
		  OBJECT_MEMBERS.itervalues = OBJECT_MEMBERS.values;
		  OBJECT_MEMBERS.iterkeys = OBJECT_MEMBERS.keys;
		  runtime.memberLookup = function(obj, val, autoescape) { // jshint ignore:line
		    obj = obj || {};
	
		    // If the object is an object, return any of the methods that Python would
		    // otherwise provide.
		    if (lib.isArray(obj) && ARRAY_MEMBERS.hasOwnProperty(val)) {
		      return function() {return ARRAY_MEMBERS[val].apply(obj, arguments);};
		    }
	
		    if (lib.isObject(obj) && OBJECT_MEMBERS.hasOwnProperty(val)) {
		      return function() {return OBJECT_MEMBERS[val].apply(obj, arguments);};
		    }
	
		    return orig_memberLookup.apply(this, arguments);
		  };
		}
	
		module.exports = installCompat;
	
	
	/***/ }
	/******/ ]);
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = nunjucks;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(4);
	
	module.exports = function (env) {
	
	    env.addGlobal('static', function (file) {
	        return '/static/' + file;
	    }, true);
	
	    env.addGlobal('hasMod', function (mods, mod) {
	        return _.indexOf(mods, mod) != -1;
	    });
	};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = function (nunjucks, env, obj, dependencies){
	
	    var oldRoot = obj.root;
	    obj.root = function( env, context, frame, runtime, cb ) {
	        var oldGetTemplate = env.getTemplate;
	
	        // The parentName param was added to nunjucks 1.3.x
	        env.getTemplate = function (name, ec, parentName, cb) {
	            if( typeof ec === "function" ) {
	                cb = ec;
	                ec = false;
	            }
	            var _require = function (name) {
	                try {
	                    // add a reference to the already resolved dependency here
	                    return dependencies[name];
	                }
	                catch (e) {
	                    if ( frame.get( "_require" ) ) return frame.get( "_require" )( name )
	                }
	            };
	
	            var tmpl = _require( name );
	            frame.set( "_require", _require );
	            if( ec ) tmpl.compile();
	            cb( null, tmpl );
	        };
	
	
	        oldRoot (env, context, frame, runtime, function (err, res) {
	            env.getTemplate = oldGetTemplate;
	            cb( err, res );
	        });
	    };
	
	    var src = {
	        obj: obj,
	        type: 'code'
	    };
	
	    return new nunjucks.Template(src, env);
	
	};

/***/ }),
/* 29 */
5,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Slider.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	["slides", "options"], 
	[], 
	function (l_slides, l_options, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("slides", l_slides);
	frame.set("options", l_options);
	var t_2 = "";t_2 += "<div class=\"Slider ";
	frame = frame.push();
	var t_5 = runtime.memberLookup((l_options),"modifiers");
	if(t_5) {var t_4 = t_5.length;
	for(var t_3=0; t_3 < t_5.length; t_3++) {
	var t_6 = t_5[t_3];
	frame.set("m", t_6);
	frame.set("loop.index", t_3 + 1);
	frame.set("loop.index0", t_3);
	frame.set("loop.revindex", t_4 - t_3);
	frame.set("loop.revindex0", t_4 - t_3 - 1);
	frame.set("loop.first", t_3 === 0);
	frame.set("loop.last", t_3 === t_4 - 1);
	frame.set("loop.length", t_4);
	t_2 += "Slider--";
	t_2 += runtime.suppressValue(t_6, env.opts.autoescape);
	;
	}
	}
	frame = frame.pop();
	t_2 += "\">\n        ";
	if(env.getFilter("length").call(context, l_slides)) {
	t_2 += "\n            <div class=\"Slider-contents\">\n                ";
	frame = frame.push();
	var t_9 = l_slides;
	if(t_9) {var t_8 = t_9.length;
	for(var t_7=0; t_7 < t_9.length; t_7++) {
	var t_10 = t_9[t_7];
	frame.set("s", t_10);
	frame.set("loop.index", t_7 + 1);
	frame.set("loop.index0", t_7);
	frame.set("loop.revindex", t_8 - t_7);
	frame.set("loop.revindex0", t_8 - t_7 - 1);
	frame.set("loop.first", t_7 === 0);
	frame.set("loop.last", t_7 === t_8 - 1);
	frame.set("loop.length", t_8);
	t_2 += "\n                    <div class=\"Slider-slide\" data-order=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
	t_2 += "\">\n                        ";
	t_2 += "\n                        ";
	if(runtime.memberLookup((l_options),"frame")) {
	t_2 += "\n                            <div class=\"Frame Frame--simple\"></div>\n                        ";
	;
	}
	t_2 += "\n\n                        ";
	if(runtime.memberLookup((t_10),"title")) {
	t_2 += "\n                            <a class=\"Slider-link u-Heading\" href=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((t_10),"url"), env.opts.autoescape);
	t_2 += "\">\n                                <span class=\"Slider-linkContents\">\n                                    <span class=\"Slider-titleContainer\">\n                                        <span class=\"Slider-title\">";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_10),"title")), env.opts.autoescape);
	t_2 += "</span>\n                                    </span>\n                                    <span class=\"Slider-linkMessage\">";
	t_2 += runtime.suppressValue((lineno = 17, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Подробнее"])), env.opts.autoescape);
	t_2 += "</span>\n                                </span>\n                            </a>\n                        ";
	;
	}
	t_2 += "\n\n                        <div class=\"Slider-overlay\"></div>\n\n                        ";
	t_2 += "\n                        ";
	t_2 += "\n                        <div class=\"Slider-img u-Preload u-Cover\">\n                            <img src=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_10),"img")),"main"), env.opts.autoescape);
	t_2 += "\" srcset=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_10),"img")),"main_2x"), env.opts.autoescape);
	t_2 += " 2x\"\n                                 alt=\"";
	if(runtime.memberLookup((t_10),"title")) {
	t_2 += runtime.suppressValue(runtime.memberLookup((t_10),"title"), env.opts.autoescape);
	;
	}
	t_2 += "\">\n                        </div>\n                    </div>\n                ";
	;
	}
	}
	frame = frame.pop();
	t_2 += "\n            </div>\n\n            <div class=\"Slider-counter\">\n            <span class=\"Slider-currentCounter\">\n                <span class=\"Slider-numberValue\">01</span>\n            </span>\n                <span>of</span>\n                <span class=\"Slider-numberTotal\">";
	t_2 += runtime.suppressValue("%02d" % runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"length"), env.opts.autoescape);
	t_2 += "</span>\n            </div>\n\n            <button class=\"Slider-btn Slider-btn--prev u-Btn\">\n                ";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Slider/Slider-prev.svg")), env.opts.autoescape);
	t_2 += "\n            </button>\n\n            <button class=\"Slider-btn Slider-btn--next u-Btn\">\n                ";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Slider/Slider-next.svg")), env.opts.autoescape);
	t_2 += "\n            </button>\n        ";
	;
	}
	t_2 += "\n    </div>";
	t_2 += runtime.suppressValue((lineno = 50, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("Slider");
	context.setVariable("Slider", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Slider.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 31 */
5,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/Slider/Slider.jinja"] = __webpack_require__( 30 );
	dependencies["front/components/Footer/Footer.jinja"] = __webpack_require__( 33 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["IndexPage.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/Slider/Slider.jinja", false, "IndexPage.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("Slider", t_1);
	output += "<div class=\"IndexPage\">\n    ";
	output += runtime.suppressValue((lineno = 3, colno = 23, runtime.callWrap(runtime.memberLookup((t_1),"Slider"), "Slider[\"Slider\"]", context, [runtime.contextOrFrameLookup(context, frame, "projects"),{"modifiers": ["fullHeight"],"frame": 1},runtime.makeKeywordArgs({"caller": (function (){var macro_t_4 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_5 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_5);
	});
	return macro_t_4;})()})])), env.opts.autoescape);
	output += "\n\n    ";
	env.getTemplate("front/components/Footer/Footer.jinja", false, "IndexPage.jinja", function(t_8,t_6) {
	if(t_8) { cb(t_8); return; }
	t_6.render(context.getVariables(), frame, function(t_9,t_7) {
	if(t_9) { cb(t_9); return; }
	output += t_7
	output += "\n</div>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})})})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["IndexPage.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Footer.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	output += "<footer class=\"Footer\">\n    <div class=\"Footer-col\">\n        <div class=\"Footer-primary\">\n            <a href=\"";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"addressLink"), env.opts.autoescape);
	output += "\" target=\"_blank\">\n                ";
	output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"address")), env.opts.autoescape);
	output += "\n            </a>\n        </div>\n        <div class=\"Footer-secondary\">\n            <p>© 2015 OFFCON Architecture, Planning and Design</p>\n\n            <p> Designed in collaboration with Code and Theory</p>\n        </div>\n    </div>\n    <div class=\"Footer-col\">\n        <div class=\"Footer-primary\">\n            <a href=\"mailto:";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"email"), env.opts.autoescape);
	output += "\">";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"email"), env.opts.autoescape);
	output += "</a>\n            <a href=\"tel:";
	output += runtime.suppressValue(env.getFilter("replace").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"phone")," ",""), env.opts.autoescape);
	output += "\">";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"phone"), env.opts.autoescape);
	output += "</a>\n        </div>\n        <div class=\"Footer-secondary\">\n            Design by <a href=\"https://whiterussianstudio.com\" target=\"_blank\">WRS</a><br/>\n            Developed by <a href=\"https://astroshock.com/\" target=\"_blank\">Astroshock</a>\n        </div>\n    </div>\n    <div class=\"Footer-col socialIconsCol\">\n        <div class=\"Footer-primary socialIconsContainer\">\n            <a class=\"socialIcon linkedin\" href=\"";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"linkedinLink"), env.opts.autoescape);
	output += "\" target=\"_blank\">\n                <svg viewBox=\"0 0 72 72\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"\n                          d=\"M8 72H64C68.4183 72 72 68.4183 72 64V8C72 3.58172 68.4183 0 64 0H8C3.58172 0 0 3.58172 0 8V64C0 68.4183 3.58172 72 8 72Z\"/>\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"\n                          d=\"M62 62H51.3156V43.8021C51.3156 38.8128 49.4198 36.0245 45.4707 36.0245C41.1746 36.0245 38.9301 38.9261 38.9301 43.8021V62H28.6333V27.3333H38.9301V32.0029C38.9301 32.0029 42.026 26.2742 49.3826 26.2742C56.7357 26.2742 62 30.7645 62 40.0512V62ZM16.3493 22.794C12.8421 22.794 10 19.9297 10 16.397C10 12.8644 12.8421 10 16.3493 10C19.8566 10 22.697 12.8644 22.697 16.397C22.697 19.9297 19.8566 22.794 16.3493 22.794ZM11.0326 62H21.7694V27.3333H11.0326V62Z\"/>\n                </svg>\n            </a>\n        </div>\n    </div>\n</footer>\n";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Footer.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _imagesloadedImagesloadedPkgdMinJs = __webpack_require__(14);
	
	var _imagesloadedImagesloadedPkgdMinJs2 = _interopRequireDefault(_imagesloadedImagesloadedPkgdMinJs);
	
	var _frontComponentsPageViewPageViewJs = __webpack_require__(15);
	
	var _frontComponentsPageViewPageViewJs2 = _interopRequireDefault(_frontComponentsPageViewPageViewJs);
	
	var _frontComponentsHeroHeroJs = __webpack_require__(35);
	
	var _frontComponentsHeroHeroJs2 = _interopRequireDefault(_frontComponentsHeroHeroJs);
	
	var _frontComponentsVideoVideoJs = __webpack_require__(37);
	
	var _frontComponentsVideoVideoJs2 = _interopRequireDefault(_frontComponentsVideoVideoJs);
	
	var _frontComponentsQuoteQuoteJs = __webpack_require__(40);
	
	var _frontComponentsQuoteQuoteJs2 = _interopRequireDefault(_frontComponentsQuoteQuoteJs);
	
	var _frontComponentsProjectListProjectListJs = __webpack_require__(43);
	
	var _frontComponentsProjectListProjectListJs2 = _interopRequireDefault(_frontComponentsProjectListProjectListJs);
	
	__webpack_require__(51);
	
	var _ProjectListPageJinja = __webpack_require__(52);
	
	var _ProjectListPageJinja2 = _interopRequireDefault(_ProjectListPageJinja);
	
	var ProjectListPage = _frontComponentsPageViewPageViewJs2['default'].extend({
	    el: '.ProjectListPage',
	
	    type: 'ProjectList',
	
	    template: _ProjectListPageJinja2['default'],
	
	    apiUrl: '/api/pages/work/',
	
	    initialize: function initialize(options) {
	        _underscoreUnderscore2['default'].bindAll(this, '_scrollListener', 'animateHeader');
	
	        this.state = new _backboneBackbone2['default'].Model({ inside: false });
	        this.scrollListener = _underscoreUnderscore2['default'].throttle(this._scrollListener, 100);
	
	        _frontComponentsPageViewPageViewJs2['default'].prototype.initialize.call(this, options);
	    },
	
	    _scrollListener: function _scrollListener() {
	        var scrollTop = app.els.$window.scrollTop();
	
	        if (scrollTop / app.els.$window.height() > 0.3) {
	            if (!this.state.get('inside')) {
	                this.state.set('inside', true);
	            }
	        } else {
	            if (this.state.get('inside')) {
	                this.state.set('inside', false);
	            }
	        }
	    },
	
	    animateHeader: function animateHeader(state) {
	        if (state.get('inside')) {
	            app.views.nav.minimize();
	            app.views.langs.deactivate();
	            this.quote.$el.hide();
	            this.hero.deactivateArrow();
	        } else {
	            app.views.nav.maximize();
	            app.views.langs.activate();
	            this.quote.$el.show();
	            this.hero.activateArrow();
	        }
	    },
	
	    playIn: function playIn() {
	        var _this = this;
	
	        this.quote.playIn().then(function () {
	            return _this.video.playIn();
	        }).then(function () {
	            app.views.nav.activate({ fixed: true });
	            app.views.cookie.activate();
	            _this.hero.activateFrame();
	            app.views.logo.activate({ delay: 500 });
	            _this.hero.activateArrow();
	            return app.views.langs.activate({
	                delay: 500,
	                fixed: true
	            });
	        }).then(function () {
	            app.els.$body.removeClass('u-NoOverflow');
	
	            _this.listenTo(_this.state, 'change:inside', _this.animateHeader);
	            app.els.$window.on('scroll', _this.scrollListener);
	        });
	    },
	
	    playOut: function playOut() {
	        var _this2 = this;
	
	        app.views.langs.deactivate();
	        app.views.logo.deactivate();
	        return Promise.resolve(this.video.playOut()).then(function () {
	            _this2.quote.playOut();
	            return app.views.nav.deactivate();
	        });
	    },
	
	    prepare: function prepare() {
	        var _this3 = this;
	
	        this.$el[0].style.display = 'block';
	
	        this.$quote = this.$('.Quote');
	        this.$video = this.$('.Video');
	
	        this.hero = this.views.hero = new _frontComponentsHeroHeroJs2['default']({
	            el: this.$('.Hero')
	        });
	
	        this.quote = this.views.quote = new _frontComponentsQuoteQuoteJs2['default']({
	            el: this.$quote
	        });
	
	        this.video = this.views.video = new _frontComponentsVideoVideoJs2['default']({
	            el: this.$video
	        });
	
	        this.projectList = this.views.projectList = new _frontComponentsProjectListProjectListJs2['default']({
	            el: this.$('.ProjectList')
	        });
	
	        $.Velocity.hook(this.$quote, 'opacity', '0');
	        $.Velocity.hook(this.$video, 'opacity', '0');
	
	        this.hero.$arrow.addClass('isNotActive isNotTransitioned');
	        this.hero.$frame.addClass('isNotActive');
	
	        return this.preloadImages().then(function () {
	            return _this3.video.activate();
	        }).then(function () {
	            return _this3.promise;
	        }).then(function () {
	            app.els.$window.scrollTop(0);
	            return app.loader.deactivate();
	        });
	    },
	
	    cleanUp: function cleanUp() {
	        app.els.$window.off('scroll', this.scrollListener);
	        app.els.$body.addClass('u-NoOverflow');
	        this.close();
	        return app.loader.activate();
	    }
	});
	
	exports['default'] = ProjectListPage;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(36);
	
	var Hero = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    events: {
	        'click .Hero-btn': 'scrollDown'
	    },
	
	    initialize: function initialize() {
	        this.$frame = this.$('.Frame');
	
	        this.$arrow = this.$('.Hero-btn');
	        this.$title = this.$('.Hero-title');
	        this.$img = this.$('.Hero-img');
	
	        this._arrowShownBinded = this._arrowshown.bind(this);
	    },
	
	    activateFrame: function activateFrame() {
	        var _this = this;
	
	        return new Promise(function (resolve) {
	            setTimeout(function () {
	                _this.$frame.addClass('isActive');
	
	                resolve();
	            }, 250);
	        });
	    },
	
	    activateArrow: function activateArrow() {
	        this.$arrow[0].addEventListener('transitionend', this._arrowShownBinded);
	        this.$arrow[0].addEventListener('webkitTransitionEnd', this._arrowShownBinded);
	
	        this.$arrow.removeClass('isNotActive isNotTransitioned');
	    },
	
	    deactivateArrow: function deactivateArrow() {
	        this.$arrow.addClass('isNotActive');
	    },
	
	    _arrowshown: function _arrowshown() {
	        this.$arrow.addClass('isActive');
	    },
	
	    activateTitle: function activateTitle(options) {
	        var self = this;
	
	        return $.Velocity.animate(this.$title[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500,
	            complete: function complete() {
	                self.$title.removeClass('isNotActive');
	            }
	        }, options));
	    },
	
	    deactivateTitle: function deactivateTitle(options) {
	        return $.Velocity.animate(this.$title[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({ duration: 1000 }, options));
	    },
	
	    activateImage: function activateImage(options) {
	        return $.Velocity.animate(this.$img[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({ duration: 1500 }, options));
	    },
	
	    deactivateImage: function deactivateImage(options) {
	        return $.Velocity.animate(this.$img[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({ duration: 500 }, options));
	    },
	
	    scrollDown: function scrollDown(options) {
	        this.deactivateArrow();
	
	        app.els.$htmlBody.velocity('scroll', _underscoreUnderscore2['default'].extend({
	            offset: app.els.$window.height(),
	            duration: 800,
	            easing: 'easeInQuad'
	        }, options));
	    }
	});
	
	exports['default'] = Hero;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 36 */
5,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontUtilsUtilsJs = __webpack_require__(22);
	
	var _frontUtilsUtilsJs2 = _interopRequireDefault(_frontUtilsUtilsJs);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(38);
	
	var _VideoJinja = __webpack_require__(39);
	
	var _VideoJinja2 = _interopRequireDefault(_VideoJinja);
	
	var Video = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    initialize: function initialize() {
	        _underscoreUnderscore2['default'].bindAll(this, '_visibilityHandler', 'activateVideo', 'activateImage', 'playInImage', 'playOutImage', 'playInVideo', 'playOutVideo');
	
	        this.state = {};
	
	        if (app.settings.isTablet) {
	            this.playIn = this.playInImage;
	            this.playOut = this.playOutImage;
	            this.activate = this.activateImage;
	
	            this.$img = this.$('.Video-img');
	        } else {
	            this.playIn = this.playInVideo;
	            this.playOut = this.playOutVideo;
	            this.activate = this.activateVideo;
	
	            this.$video = this.$('video');
	            this.video = this.$video[0];
	
	            this.state.playing = false;
	
	            // TODO: Останавливать видео, если его не видно во вьюпорте
	            this.visibilityHandler = _underscoreUnderscore2['default'].throttle(this._visibilityHandler, 500);
	
	            app.els.$window.on('scroll', this.visibilityHandler);
	
	            this.$video.on('canplaythrough', this.startVideo);
	        }
	    },
	
	    _visibilityHandler: function _visibilityHandler() {
	        if (this.elementInViewport(this.$video)) {
	            if (!this.state.playing) {
	                this.video.play();
	                this.state.playing = true;
	            }
	        } else {
	            if (this.state.playing) {
	                this.video.pause();
	                this.state.playing = false;
	            }
	        }
	    },
	
	    elementInViewport: function elementInViewport(el) {
	        if (typeof jQuery === "function" && el instanceof jQuery) {
	            el = el[0];
	        }
	
	        var rect = el.getBoundingClientRect();
	
	        return rect.bottom > 0 && rect.right > 0 && rect.left < (window.innerWidth || document.documentElement.clientWidth) && rect.top < (window.innerHeight || document.documentElement.clientHeight);
	    },
	
	    playInVideo: function playInVideo(options) {
	        this.video.currentTime = 0;
	        this.video.play();
	
	        $(window).on('resize scroll', this.visibilityHandler);
	
	        return $.Velocity.animate(this.$el[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500
	        }, options));
	    },
	
	    playOutVideo: function playOutVideo(options) {
	        $(window).off('resize scroll', this.visibilityHandler);
	
	        return $.Velocity.animate(this.$el[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500
	        }, options));
	    },
	
	    playInImage: function playInImage(options) {
	        return $.Velocity.animate(this.$el[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500
	        }, options));
	    },
	
	    playOutImage: function playOutImage(options) {
	        return $.Velocity.animate(this.$el[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500
	        }, options));
	    },
	
	    activateImage: function activateImage() {
	        return new Promise(function (resolve, reject) {
	            resolve();
	        });
	    },
	
	    activateVideo: function activateVideo() {
	        var _this = this;
	
	        return new Promise(function (resolve, reject) {
	            _this.$video.on('canplaythrough', function () {
	                _this.$video.off('canplaythrough');
	
	                resolve();
	            });
	
	            if (_this.video.readyState > 3) {
	                _this.$video.off('canplaythrough');
	
	                resolve();
	            }
	        });
	    }
	});
	
	exports['default'] = Video;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 38 */
5,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Video.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	[], 
	["title", "image", "is_tablet"], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("title", kwargs.hasOwnProperty("title") ? kwargs["title"] : "video");
	frame.set("image", kwargs.hasOwnProperty("image") ? kwargs["image"] : "");
	frame.set("is_tablet", kwargs.hasOwnProperty("is_tablet") ? kwargs["is_tablet"] : runtime.contextOrFrameLookup(context, frame, "False"));
	var t_2 = "";t_2 += "<div class=\"Video\">\n        ";
	if(runtime.contextOrFrameLookup(context, frame, "is_tablet")) {
	t_2 += "\n            <div class=\"Video-img u-Cover u-Preload\">\n                <img src=\"";
	t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "image"), env.opts.autoescape);
	t_2 += "\" alt=\"";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "title")), env.opts.autoescape);
	t_2 += "\">\n            </div>\n        ";
	;
	}
	else {
	t_2 += "\n            <video class=\"Video-content\" preload=\"auto\" loop=\"loop\">\n                <source src=\"/static/video/";
	t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
	t_2 += ".mp4\" type=\"video/mp4\"/>\n                <source src=\"/static/video/";
	t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
	t_2 += ".webm\" type=\"video/webm\"/>\n            </video>\n        ";
	;
	}
	t_2 += "\n    </div>";
	t_2 += runtime.suppressValue((lineno = 12, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("Video");
	context.setVariable("Video", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Video.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(41);
	
	var _QuoteJinja = __webpack_require__(42);
	
	var _QuoteJinja2 = _interopRequireDefault(_QuoteJinja);
	
	var Quote = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    initialize: function initialize() {},
	
	    playIn: function playIn(options) {
	        this.$el.velocity('stop', true);
	
	        return $.Velocity.animate(this.$el[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500,
	            display: 'block'
	        }, options));
	    },
	
	    playOut: function playOut(options) {
	        this.$el.velocity('stop', true);
	
	        return $.Velocity.animate(this.$el[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500,
	            display: 'none'
	        }, options));
	    }
	});
	
	exports['default'] = Quote;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 41 */
5,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Quote.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	output += "<blockquote class=\"Quote u-Heading\">\n    ";
	output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quote")),"text")), env.opts.autoescape);
	output += "\n    <cite class=\"Quote-cite\">";
	output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quote")),"author")), env.opts.autoescape);
	output += "</cite>\n</blockquote>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Quote.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _imagesloadedImagesloadedPkgdMinJs = __webpack_require__(14);
	
	var _imagesloadedImagesloadedPkgdMinJs2 = _interopRequireDefault(_imagesloadedImagesloadedPkgdMinJs);
	
	var _frontComponentsProjectItemProjectItem = __webpack_require__(44);
	
	var _frontComponentsProjectItemProjectItem2 = _interopRequireDefault(_frontComponentsProjectItemProjectItem);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(48);
	
	var _ProjectListJinja = __webpack_require__(49);
	
	var _ProjectListJinja2 = _interopRequireDefault(_ProjectListJinja);
	
	var ProjectList = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    apiUrl: '/api/projects/',
	
	    events: {
	        'click .ProjectList-btn': 'loadMore'
	    },
	
	    initialize: function initialize() {
	        this.state = {
	            offset: 0,
	            limit: 9
	        };
	
	        this.$load = this.$('.ProjectList-btn');
	        this.$list = this.$('.ProjectList-list');
	
	        this.views = _underscoreUnderscore2['default'].map(this.$el.find('.ProjectItem'), function (el) {
	            return new _frontComponentsProjectItemProjectItem2['default']({
	                el: $(el)
	            });
	        });
	    },
	
	    add: function add(projects) {
	        var _this = this;
	
	        _underscoreUnderscore2['default'].each(projects, function (item) {
	            var view = new _frontComponentsProjectItemProjectItem2['default']({
	                model: item
	            });
	
	            _this.$list.append(view.render().el);
	
	            _this.views.push(view);
	        });
	    },
	
	    loadMore: function loadMore() {
	        var _this2 = this;
	
	        this.$load.find('.BtnLoad').addClass('isLoading');
	        var oldH = this.$list.outerHeight();
	        $.Velocity.hook(this.$list, 'height', oldH + 'px');
	
	        this.getData().then(function (data) {
	            _this2.add(data.projects);
	
	            $.Velocity.hook(_this2.$list, 'height', 'auto');
	            var newH = _this2.$list.outerHeight();
	            $.Velocity.hook(_this2.$list, 'height', oldH + 'px');
	
	            var $els = $('.ProjectItem.isNotActive');
	            var $imgs = $els.find('img');
	
	            (0, _imagesloadedImagesloadedPkgdMinJs2['default'])($imgs, function () {
	                _this2.$load.find('.BtnLoad').removeClass('isLoading');
	                $.Velocity.animate(_this2.$list[0], { height: newH }, { duration: 1500 });
	                $.Velocity.animate(_this2.$load[0], { opacity: 0 });
	
	                setTimeout(function () {
	                    $els.removeClass('isNotActive');
	
	                    if (data.hasMore) {
	                        $.Velocity.hook(_this2.$load, 'opacity', 1);
	                    }
	                }, 500);
	            });
	        });
	    },
	
	    getData: function getData() {
	        return Promise.resolve($.getJSON(this.apiUrl, {
	            lang: app.data.lang,
	            offset: this.state.offset + this.state.limit,
	            limit: this.state.limit
	        }).then(function (data) {
	            return data;
	        }).fail(function () {
	            console.log('Ошибка при загрузке данных.');
	        }));
	    }
	});
	
	exports['default'] = ProjectList;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(45);
	
	var _ProjectItemCallJinja = __webpack_require__(46);
	
	var _ProjectItemCallJinja2 = _interopRequireDefault(_ProjectItemCallJinja);
	
	var PARENT_FRAME_SHIFT = 2;
	var FRAME_SHIFT_X = 46 + PARENT_FRAME_SHIFT;
	var FRAME_SHIFT_Y = 35 + PARENT_FRAME_SHIFT;
	
	var ProjectItem = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    template: _ProjectItemCallJinja2['default'],
	
	    events: {
	        //'click .ProjectItem-link': 'navigate'
	    },
	
	    render: function render() {
	        var $html = $(this.template.render({ p: this.model }));
	        app.els.$content.append($html);
	        this.setElement($html);
	
	        this.$el.addClass('isNotActive');
	
	        return this;
	    },
	
	    initialize: function initialize(options) {
	        _underscoreUnderscore2['default'].bindAll(this, 'activateElement');
	    },
	
	    navigate: function navigate(e) {
	        e.preventDefault();
	        var url = $(e.target).closest('a').attr('href');
	
	        this.activateElement().then(function () {
	            app.router.navigate(url, { trigger: 'true' });
	        });
	    },
	
	    activateElement: function activateElement() {
	        var $loader = $(app.loader.loader);
	        var $copy = this.$el.clone();
	
	        var elPosition = this.$el.offset();
	        var elX = elPosition.left;
	        var elY = elPosition.top;
	
	        var newX = elX;
	        var newY = elY - app.els.$window.scrollTop();
	
	        $copy.css({ top: newY, left: newX, width: this.$el.width() });
	
	        $copy = $copy.appendTo($loader);
	        var $img = $copy.find('.ProjectItem-imgContainer');
	
	        $loader.addClass('Loader--projectItem');
	        $.Velocity.hook($loader[0], 'display', 'block');
	
	        app.views.nav.deactivate({ duration: 500 });
	        return $.Velocity.animate(app.router.view.el, { opacity: 0 }, { duration: 500, easing: 'easeInQuad' }).then(function () {
	            app.els.$body.addClass('u-NoOverflow');
	
	            $.Velocity.hook($copy[0], 'transformOriginX', $img.outerWidth() / 2 + 'px');
	            $.Velocity.hook($copy[0], 'transformOriginY', $img.outerHeight() / 2 + 'px');
	
	            return $.Velocity.animate($copy[0], {
	                translateX: app.els.$window.width() / 2 - (newX + $img.outerWidth() / 2) + FRAME_SHIFT_X / 2 + 'px',
	                translateY: app.els.$window.height() / 2 - (newY + $img.outerHeight() / 2) + FRAME_SHIFT_Y / 2 + 'px'
	            }, {
	                duration: 600,
	                easing: 'easeInOutCubic',
	                complete: function complete() {
	                    $copy.addClass('isLoading');
	                }
	            });
	        });
	    }
	});
	
	exports['default'] = ProjectItem;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 45 */
5,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/ProjectItem/ProjectItem.jinja"] = __webpack_require__( 47 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectItemCall.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/ProjectItem/ProjectItem.jinja", false, "ProjectItemCall.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("ProjectItem", t_1);
	output += runtime.suppressValue((lineno = 2, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"ProjectItem"), "ProjectItem[\"ProjectIte\"]", context, [runtime.contextOrFrameLookup(context, frame, "p"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_4 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_5 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_5);
	});
	return macro_t_4;})()})])), env.opts.autoescape);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectItemCall.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectItem.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	["p"], 
	["options"], 
	function (l_p, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("p", l_p);
	frame.set("options", kwargs.hasOwnProperty("options") ? kwargs["options"] : {});
	var t_2 = "";t_2 += "<li class=\"ProjectItem ";
	frame = frame.push();
	var t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "options")),"modifiers");
	if(t_5) {var t_4 = t_5.length;
	for(var t_3=0; t_3 < t_5.length; t_3++) {
	var t_6 = t_5[t_3];
	frame.set("m", t_6);
	frame.set("loop.index", t_3 + 1);
	frame.set("loop.index0", t_3);
	frame.set("loop.revindex", t_4 - t_3);
	frame.set("loop.revindex0", t_4 - t_3 - 1);
	frame.set("loop.first", t_3 === 0);
	frame.set("loop.last", t_3 === t_4 - 1);
	frame.set("loop.length", t_4);
	t_2 += "ProjectItem--";
	t_2 += runtime.suppressValue(t_6, env.opts.autoescape);
	;
	}
	}
	frame = frame.pop();
	t_2 += "\">\n        <a href=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"url"), env.opts.autoescape);
	t_2 += "\" class=\"ProjectItem-link\">\n            <span class=\"ProjectItem-imgContainer\">\n                <img src=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_p),"img")),"tn"), env.opts.autoescape);
	t_2 += "\" srcset=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_p),"img")),"tn_2x"), env.opts.autoescape);
	t_2 += " 2x\" alt=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"title"), env.opts.autoescape);
	t_2 += "\" class=\"ProjectItem-img\">\n                <span class=\"Frame\">\n                    <span class=\"Frame-side Frame-side--right\"></span>\n                    <span class=\"Frame-side Frame-side--bottom\"></span>\n                </span>\n            </span>\n\n            <span class=\"ProjectItem-fake\">\n                ";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_p),"title")), env.opts.autoescape);
	t_2 += "\n            </span>\n\n            <span class=\"ProjectItem-text\">\n                <span class=\"ProjectItem-title\">";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_p),"title")), env.opts.autoescape);
	t_2 += "</span>\n                <span class=\"ProjectItem-intro\">";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_p),"authors")), env.opts.autoescape);
	t_2 += "</span>\n            </span>\n        </a>\n    </li>\n    ";
	t_2 += runtime.suppressValue((lineno = 21, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("ProjectItem");
	context.setVariable("ProjectItem", macro_t_1);
	output += "\n";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectItem.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 48 */
5,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/BtnLoad/BtnLoad.jinja"] = __webpack_require__( 50 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectList.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/BtnLoad/BtnLoad.jinja", false, "ProjectList.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("BtnLoad", t_1);
	var macro_t_4 = runtime.makeMacro(
	["hasMore"], 
	[], 
	function (l_hasMore, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("hasMore", l_hasMore);
	var t_5 = "";t_5 += "<div class=\"ProjectList\">\n        <ul class=\"ProjectList-list\">\n            ";
	t_5 += runtime.suppressValue((lineno = 5, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	t_5 += "\n        </ul>\n\n        ";
	if(l_hasMore) {
	t_5 += "\n            <div class=\"ProjectList-btn\">\n                ";
	t_5 += runtime.suppressValue((lineno = 10, colno = 37, runtime.callWrap(runtime.memberLookup((t_1),"BtnLoad"), "BtnLoad[\"BtnLoad\"]", context, [runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_7 = "";t_7 += runtime.suppressValue((lineno = 10, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["загрузить еще"])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_7);
	});
	return macro_t_6;})()})])), env.opts.autoescape);
	t_5 += "\n            </div>\n        ";
	;
	}
	t_5 += "\n    </div>";
	;
	frame = frame.pop();
	return new runtime.SafeString(t_5);
	});
	context.addExport("ProjectList");
	context.setVariable("ProjectList", macro_t_4);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectList.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["BtnLoad.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_2 = "";t_2 += "<button class=\"BtnLoad u-Btn\">";
	t_2 += runtime.suppressValue((lineno = 1, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	t_2 += "</button>\n";
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("BtnLoad");
	context.setVariable("BtnLoad", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["BtnLoad.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 51 */
5,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/ProjectList/ProjectList.jinja"] = __webpack_require__( 49 );
	dependencies["front/components/ProjectItem/ProjectItem.jinja"] = __webpack_require__( 47 );
	dependencies["front/components/Video/Video.jinja"] = __webpack_require__( 39 );
	dependencies["front/components/Frame/Frame.jinja"] = __webpack_require__( 25 );
	dependencies["front/components/Quote/Quote.jinja"] = __webpack_require__( 42 );
	dependencies["front/components/Footer/Footer.jinja"] = __webpack_require__( 33 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectListPage.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/ProjectList/ProjectList.jinja", false, "ProjectListPage.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("ProjectList", t_1);
	env.getTemplate("front/components/ProjectItem/ProjectItem.jinja", false, "ProjectListPage.jinja", function(t_5,t_4) {
	if(t_5) { cb(t_5); return; }
	t_4.getExported(function(t_6,t_4) {
	if(t_6) { cb(t_6); return; }
	context.setVariable("ProjectItem", t_4);
	env.getTemplate("front/components/Video/Video.jinja", false, "ProjectListPage.jinja", function(t_8,t_7) {
	if(t_8) { cb(t_8); return; }
	t_7.getExported(function(t_9,t_7) {
	if(t_9) { cb(t_9); return; }
	context.setVariable("Video", t_7);
	output += "<div class=\"ProjectListPage\">\n    <div class=\"Hero\">\n        ";
	env.getTemplate("front/components/Frame/Frame.jinja", false, "ProjectListPage.jinja", function(t_12,t_10) {
	if(t_12) { cb(t_12); return; }
	t_10.render(context.getVariables(), frame, function(t_13,t_11) {
	if(t_13) { cb(t_13); return; }
	output += t_11
	output += "\n        ";
	output += runtime.suppressValue((lineno = 7, colno = 25, runtime.callWrap(runtime.memberLookup((t_7),"Video"), "Video[\"Video\"]", context, ["work_v2",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"img")),"main"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"is_tablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_15 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_15);
	});
	return macro_t_14;})()})])), env.opts.autoescape);
	output += "\n        ";
	env.getTemplate("front/components/Quote/Quote.jinja", false, "ProjectListPage.jinja", function(t_18,t_16) {
	if(t_18) { cb(t_18); return; }
	t_16.render(context.getVariables(), frame, function(t_19,t_17) {
	if(t_19) { cb(t_19); return; }
	output += t_17
	output += "\n\n        <button class=\"Hero-btn u-Btn\">\n            ";
	output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Hero/Hero-btn.svg")), env.opts.autoescape);
	output += "\n        </button>\n    </div>\n\n    <div class=\"ProjectListPage-projectList\">\n        ";
	output += runtime.suppressValue((lineno = 16, colno = 37, runtime.callWrap(runtime.memberLookup((t_1),"ProjectList"), "ProjectList[\"ProjectLis\"]", context, [runtime.contextOrFrameLookup(context, frame, "hasMore"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_21 = "";t_21 += "\n            ";
	frame = frame.push();
	var t_24 = runtime.contextOrFrameLookup(context, frame, "projects");
	if(t_24) {var t_23 = t_24.length;
	for(var t_22=0; t_22 < t_24.length; t_22++) {
	var t_25 = t_24[t_22];
	frame.set("p", t_25);
	frame.set("loop.index", t_22 + 1);
	frame.set("loop.index0", t_22);
	frame.set("loop.revindex", t_23 - t_22);
	frame.set("loop.revindex0", t_23 - t_22 - 1);
	frame.set("loop.first", t_22 === 0);
	frame.set("loop.last", t_22 === t_23 - 1);
	frame.set("loop.length", t_23);
	t_21 += "\n                ";
	t_21 += runtime.suppressValue((lineno = 18, colno = 45, runtime.callWrap(runtime.memberLookup((t_4),"ProjectItem"), "ProjectItem[\"ProjectIte\"]", context, [t_25,runtime.makeKeywordArgs({"caller": (function (){var macro_t_26 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_27 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_27);
	});
	return macro_t_26;})()})])), env.opts.autoescape);
	t_21 += "\n            ";
	;
	}
	}
	frame = frame.pop();
	t_21 += "\n        ";
	;
	frame = frame.pop();
	return new runtime.SafeString(t_21);
	});
	return macro_t_20;})()})])), env.opts.autoescape);
	output += "\n    </div>\n\n    ";
	env.getTemplate("front/components/Footer/Footer.jinja", false, "ProjectListPage.jinja", function(t_30,t_28) {
	if(t_30) { cb(t_30); return; }
	t_28.render(context.getVariables(), frame, function(t_31,t_29) {
	if(t_31) { cb(t_31); return; }
	output += t_29
	output += "\n</div>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})})})})})})})})})})})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectListPage.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsPageViewPageViewJs = __webpack_require__(15);
	
	var _frontComponentsPageViewPageViewJs2 = _interopRequireDefault(_frontComponentsPageViewPageViewJs);
	
	var _frontComponentsHeroHeroJs = __webpack_require__(35);
	
	var _frontComponentsHeroHeroJs2 = _interopRequireDefault(_frontComponentsHeroHeroJs);
	
	var _frontComponentsPageTitlePageTitleJs = __webpack_require__(54);
	
	var _frontComponentsPageTitlePageTitleJs2 = _interopRequireDefault(_frontComponentsPageTitlePageTitleJs);
	
	var _frontComponentsBtnCloseBtnCloseJs = __webpack_require__(56);
	
	var _frontComponentsBtnCloseBtnCloseJs2 = _interopRequireDefault(_frontComponentsBtnCloseBtnCloseJs);
	
	var _frontComponentsProjectSideProjectSideJs = __webpack_require__(59);
	
	var _frontComponentsProjectSideProjectSideJs2 = _interopRequireDefault(_frontComponentsProjectSideProjectSideJs);
	
	var _frontComponentsProjectProjectJs = __webpack_require__(65);
	
	var _frontComponentsProjectProjectJs2 = _interopRequireDefault(_frontComponentsProjectProjectJs);
	
	var _frontComponentsIntroTextIntroText = __webpack_require__(70);
	
	var _frontComponentsIntroTextIntroText2 = _interopRequireDefault(_frontComponentsIntroTextIntroText);
	
	__webpack_require__(73);
	
	var _ProjectPageJinja = __webpack_require__(74);
	
	var _ProjectPageJinja2 = _interopRequireDefault(_ProjectPageJinja);
	
	var ProjectPage = _frontComponentsPageViewPageViewJs2["default"].extend({
	    el: '.ProjectPage',
	
	    type: 'Project',
	
	    template: _ProjectPageJinja2["default"],
	
	    initialize: function initialize(options) {
	        this.options = options || {};
	
	        _underscoreUnderscore2["default"].bindAll(this, '_scrollListener', 'animateHeader');
	
	        this.modelId = options.arguments;
	        this.apiUrl = '/api/pages/work/' + this.modelId + '/';
	        this.state = new _backboneBackbone2["default"].Model({ inside: false });
	        this.scrollListener = _underscoreUnderscore2["default"].throttle(this._scrollListener, 100);
	        app.els.$body.addClass('ProjectPageBodyClass');
	
	        _frontComponentsPageViewPageViewJs2["default"].prototype.initialize.call(this, options);
	    },
	
	    _scrollListener: function _scrollListener() {
	        var scrollTop = app.els.$window.scrollTop();
	
	        if (scrollTop / app.els.$window.height() > 0.3) {
	            if (!this.state.get('inside')) {
	                this.state.set('inside', true);
	            }
	        } else {
	            if (this.state.get('inside')) {
	                this.state.set('inside', false);
	            }
	        }
	    },
	
	    animateHeader: function animateHeader(state) {
	        if (state.get('inside')) {
	            app.views.nav.minimize();
	            app.views.langs.deactivate();
	            this.pageTitle.$el.hide();
	            // this.pageTitle.$el.hide();
	            this.hero.deactivateArrow();
	        } else {
	            app.views.nav.maximize();
	            app.views.langs.activate();
	            // this.pageTitle.$el.show();
	            this.pageTitle.$el.show();
	            this.hero.activateArrow();
	        }
	    },
	
	    playIn: function playIn() {
	        var _this = this;
	
	        this.pageTitle.playIn().then(function () {
	            return _this.hero.activateImage();
	        }).then(function () {
	            app.views.nav.activate({ fixed: true });
	            app.views.cookie.activate();
	            _this.hero.activateFrame();
	            app.views.logo.activate({ delay: 500 });
	            _this.hero.activateArrow();
	            _this.projectSide.btnSide.playIn();
	            _this.btnClose.playIn();
	            return app.views.langs.activate({
	                delay: 500,
	                fixed: true
	            });
	        })
	        //.then(() => {
	        //
	        //})
	        .then(function () {
	            app.els.$body.removeClass('u-NoOverflow');
	
	            _this.project.refreshSliders();
	
	            _this.listenTo(_this.state, 'change:inside', _this.animateHeader);
	            app.els.$window.on('scroll', _this.scrollListener);
	        });
	    },
	
	    playOut: function playOut() {
	        var _this2 = this;
	
	        app.views.langs.deactivate();
	        app.views.logo.deactivate();
	        return Promise.resolve(this.hero.deactivateImage()).then(function () {
	            app.els.$body.removeClass('ProjectPageBodyClass');
	            _this2.pageTitle.playOut();
	            return app.views.nav.deactivate();
	        });
	    },
	
	    prepare: function prepare() {
	        var _this3 = this;
	
	        this.$el[0].style.display = 'block';
	
	        this.pageTitle = this.views.pageTitle = new _frontComponentsPageTitlePageTitleJs2["default"]({
	            el: this.$('.PageTitle')
	        });
	
	        this.hero = this.views.hero = new _frontComponentsHeroHeroJs2["default"]({
	            el: this.$('.Hero')
	        });
	
	        this.btnClose = this.views.btnClose = new _frontComponentsBtnCloseBtnCloseJs2["default"]({
	            el: this.$('.Project-close').find('.BtnClose')
	        });
	
	        this.project = this.views.project = new _frontComponentsProjectProjectJs2["default"]({
	            el: this.$('.Project')
	        });
	
	        //this.parallax = this.views.parallax = new Parallax({
	        //    el: this.$('.Parallax')
	        //})
	
	        this.projectSide = this.views.projectSide = new _frontComponentsProjectSideProjectSideJs2["default"]({
	            data: app.data.projects
	        });
	
	        this.introText = new _frontComponentsIntroTextIntroText2["default"]();
	
	        $.Velocity.hook(this.pageTitle.$el, 'opacity', '0');
	        $.Velocity.hook(this.hero.$img, 'opacity', '0');
	
	        this.hero.$arrow.addClass('isNotActive isNotTransitioned');
	        this.hero.$frame.addClass('isNotActive');
	
	        return this.preloadImages().then(function () {
	            return _this3.promise;
	        }).then(function () {
	            app.els.$window.scrollTop(0);
	            return app.loader.deactivate();
	        });
	    },
	
	    cleanUp: function cleanUp() {
	        app.els.$body.addClass('u-NoOverflow');
	        this.close();
	        return app.loader.activate();
	    }
	});
	
	exports["default"] = ProjectPage;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(55);
	
	var PageTitle = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    playIn: function playIn(options) {
	        this.$el.velocity('stop', true);
	
	        return $.Velocity.animate(this.$el[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500,
	            display: 'block',
	            easing: 'ease-in'
	        }, options));
	    },
	
	    playOut: function playOut(options) {
	        this.$el.velocity('stop', true);
	
	        return $.Velocity.animate(this.$el[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500,
	            display: 'none',
	            easing: 'ease-in'
	        }, options));
	    }
	});
	
	exports['default'] = PageTitle;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 55 */
5,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(57);
	
	var _BtnCloseJinja = __webpack_require__(58);
	
	var _BtnCloseJinja2 = _interopRequireDefault(_BtnCloseJinja);
	
	var BtnClose = _backboneBackbone2['default'].View.extend({
	    initialize: function initialize() {
	        this.$el.addClass('isNotHoverable');
	
	        this.$leftLine = this.$('.BtnClose-left');
	        this.$rightLine = this.$('.BtnClose-right');
	
	        $.Velocity.hook(this.$el, 'opacity', 0);
	        $.Velocity.hook(this.$leftLine, 'translateX', '-14px');
	        $.Velocity.hook(this.$rightLine, 'translateX', '14px');
	    },
	
	    playIn: function playIn(options) {
	        var _this = this;
	
	        $.Velocity.hook(this.$el, 'display', 'block');
	
	        $.Velocity.animate(this.$el[0], {
	            opacity: 1
	        }, _underscoreUnderscore2['default'].extend({
	            duration: 600
	        }));
	
	        return $.Velocity.animate([this.$leftLine[0], this.$rightLine[0]], {
	            translateX: 0,
	            translateZ: 0
	        }, _underscoreUnderscore2['default'].extend({
	            duration: 600
	        }, options)).then(function () {
	            _this.$el.removeClass('isNotHoverable');
	        });
	    },
	
	    playOut: function playOut(options) {
	        var _this2 = this;
	
	        var self = this;
	
	        $.Velocity.animate(this.$el[0], {
	            opacity: 0
	        }, _underscoreUnderscore2['default'].extend({
	            duration: 600
	        }));
	
	        $.Velocity.animate(this.$rightLine[0], {
	            translateX: [14, 0],
	            translateZ: 0
	        }, _underscoreUnderscore2['default'].extend({
	            begin: function begin() {
	                $.Velocity.hook(self.$rightLine, 'translateX', '20px');
	                self.$el.addClass('isNotHoverable');
	            },
	            duration: 600
	        }, options));
	
	        return $.Velocity.animate(this.$leftLine[0], {
	            translateX: [-14, 0],
	            translateZ: 0
	        }, _underscoreUnderscore2['default'].extend({
	            duration: 600,
	            complete: function complete() {
	                $.Velocity.hook(self.$el, 'display', 'none');
	            }
	        }, options)).then(function () {
	            _this2.$el.addClass('isNotHoverable');
	        });
	    }
	});
	
	exports['default'] = BtnClose;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 57 */
5,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["BtnClose.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	[], 
	["tag", "link"], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("tag", kwargs.hasOwnProperty("tag") ? kwargs["tag"] : "button");
	frame.set("link", kwargs.hasOwnProperty("link") ? kwargs["link"] : "");
	var t_2 = "";t_2 += "<";
	t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tag"), env.opts.autoescape);
	t_2 += " class=\"BtnClose u-Btn\" ";
	if(runtime.contextOrFrameLookup(context, frame, "link")) {
	t_2 += "href=\"";
	t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "link"), env.opts.autoescape);
	t_2 += "\"";
	;
	}
	t_2 += ">\n        ";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/BtnClose/BtnClose.svg")), env.opts.autoescape);
	t_2 += "\n    </";
	t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tag"), env.opts.autoescape);
	t_2 += ">";
	t_2 += runtime.suppressValue((lineno = 3, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("BtnClose");
	context.setVariable("BtnClose", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["BtnClose.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(60);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	var _frontComponentsBtnSideBtnSideJs = __webpack_require__(61);
	
	var _frontComponentsBtnSideBtnSideJs2 = _interopRequireDefault(_frontComponentsBtnSideBtnSideJs);
	
	var _frontComponentsBtnCloseBtnCloseJs = __webpack_require__(56);
	
	var _frontComponentsBtnCloseBtnCloseJs2 = _interopRequireDefault(_frontComponentsBtnCloseBtnCloseJs);
	
	__webpack_require__(64);
	
	// TODO: Доделать правку скролла в Firefox
	var ProjectSide = _frontComponentsBaseViewBaseViewJs2["default"].extend({
	    el: '.ProjectSide',
	
	    events: {
	        'click .BtnSide': 'toggle',
	        'click .BtnClose': 'toggle',
	        'mouseenter .ProjectSide-link': 'hoverOn',
	        'mouseleave .ProjectSide-list': 'hoverOff'
	    },
	
	    initialize: function initialize(options) {
	        _underscoreUnderscore2["default"].bindAll(this, '_scrollListener');
	
	        this.views = {};
	
	        this.state = new _backboneBackbone2["default"].Model({
	            opened: false,
	            inside: false
	        });
	
	        this.data = options.data;
	
	        this.$listContainer = this.$('.ProjectSide-listContainer');
	        this.$list = this.$('.ProjectSide-list');
	        this.$preview = this.$('.ProjectSide-preview');
	        this.$btnClose = this.$('.BtnClose');
	
	        this.$projectSide = $('.Project-grid');
	
	        $.Velocity.hook(this.$preview, 'display', 'none');
	        $.Velocity.hook(this.$btnClose, 'display', 'none');
	        $.Velocity.hook(this.$listContainer, 'display', 'none');
	        $.Velocity.hook(this.$listContainer, 'opacity', '0');
	        $.Velocity.hook(this.$listContainer, 'translateX', '0');
	
	        this.btnSide = this.views.btnSide = new _frontComponentsBtnSideBtnSideJs2["default"]();
	        this.btnClose = this.views.btnClose = new _frontComponentsBtnCloseBtnCloseJs2["default"]({
	            el: this.$('.BtnClose')
	        });
	
	        this.scrollListener = _underscoreUnderscore2["default"].throttle(this._scrollListener, 100);
	
	        app.els.$window.on('scroll', this.scrollListener);
	        this.listenTo(this.state, 'change:inside', this.toggleBtnSide);
	    },
	
	    _scrollListener: function _scrollListener() {
	        var scrollTop = app.els.$window.scrollTop();
	
	        if (scrollTop + app.els.$window.height() > this.$projectSide.offset().top + this.$projectSide.height()) {
	            this.state.set('inside', false);
	        } else {
	            this.state.set('inside', true);
	        }
	    },
	
	    hoverOn: function hoverOn(e) {
	        var img = undefined;
	        var id = $(e.target).data('id');
	        var project = _underscoreUnderscore2["default"].findWhere(this.data, { id: id });
	
	        if (app.isRetina) {
	            img = project.img.tn_2x;
	        } else {
	            img = project.img.tn;
	        }
	
	        this.$preview.css('background-image', "url(" + img + ")");
	    },
	
	    hoverOff: function hoverOff() {
	        this.$preview.css('background-image', '');
	    },
	
	    toggle: function toggle() {
	        if (!this.state.get('opened')) {
	            this.state.set('opened', true);
	            this.open();
	        } else {
	            this.state.set('opened', false);
	            this.close();
	        }
	    },
	
	    open: function open() {
	        app.els.$body.addClass('u-NoOverflow');
	
	        app.vent.trigger('ProjectSide-isOpening');
	
	        this.width = this.$listContainer.outerWidth();
	
	        this.scroll = baron({
	            scroller: '.ProjectSide-list'
	        });
	
	        var duration = this.btnSide.activateSide();
	        this.btnClose.playIn({
	            delay: duration / 2
	        });
	
	        $.Velocity.hook(this.$preview, 'display', 'block');
	
	        $.Velocity.animate(this.$listContainer[0], {
	            opacity: 1,
	            translateX: '100px'
	        }, {
	            display: 'block',
	            delay: duration / 4,
	            easing: 'easeOutQuad',
	            duration: 600
	        });
	    },
	
	    toggleBtnSide: function toggleBtnSide(state) {
	        if (state.get('inside')) {
	            this.btnSide.$el.fadeIn(100);
	        } else {
	            this.btnSide.$el.fadeOut(100);
	        }
	    },
	
	    close: function close() {
	        var _this = this;
	
	        //let duration = this.btnSide.activateSide()
	        //this.btnClose.playIn({
	        //    delay: duration / 2
	        //})
	
	        this.btnClose.playOut();
	        this.btnSide.deactivateSide().then(function () {
	            app.vent.trigger('ProjectSide-isClosing');
	
	            return $.Velocity.animate(_this.$listContainer[0], {
	                opacity: 0,
	                translateX: '0px'
	            }, {
	                display: 'none',
	                easing: 'easeOutQuad',
	                duration: 600
	            }).then(function () {
	                $.Velocity.hook(_this.$preview, 'display', 'none');
	                _this.scroll.dispose();
	                app.els.$body.removeClass('u-NoOverflow');
	            });
	        });
	    }
	});
	
	exports["default"] = ProjectSide;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	!function(t,i,s){"use strict";function e(i,e){var r=0;for((i.length===s||i===t)&&(i=[i]);i[r];)e.call(this,i[r],r),r++}function r(i){var s,e,o;i=i||{},o=i.$||o||t.jQuery,s=this instanceof o,s?i.root=e=this:e=o(i.root||i.scroller);var n=new r.fn.constructor(e,i,o);return n.autoUpdate&&n.autoUpdate(),n}function o(){return(new Date).getTime()}function n(s,r,o){s._eventHandlers=s._eventHandlers||[{element:s.scroller,handler:function(t){s.scroll(t)},type:"scroll"},{element:s.root,handler:function(){s.update()},type:"transitionend animationend"},{element:s.scroller,handler:function(){s.update()},type:"keyup"},{element:s.bar,handler:function(t){t.preventDefault(),s.selection(),s.drag.now=1,s.draggingCls&&i(s.bar).addClass(s.draggingCls)},type:"touchstart mousedown"},{element:document,handler:function(){s.selection(1),s.drag.now=0,s.draggingCls&&i(s.bar).removeClass(s.draggingCls)},type:"mouseup blur touchend"},{element:document,handler:function(t){2!=t.button&&s._pos0(t)},type:"touchstart mousedown"},{element:document,handler:function(t){s.drag.now&&s.drag(t)},type:"mousemove touchmove"},{element:t,handler:function(){s.update()},type:"resize"},{element:s.root,handler:function(){s.update()},type:"sizeChange"}],e(s._eventHandlers,function(t){t.element&&r(t.element,t.type,t.handler,o)})}function l(t,i,s,e){var r="data-baron-"+i+"-id";if("on"==s)t.setAttribute(r,e);else{if("off"!=s)return t.getAttribute(r);t.removeAttribute(r)}}function a(t){l(t.root,t.direction)&&console.log("Error! Baron for this node already initialized",t.root);var i=new g.prototype.constructor(t);return n(i,t.event,"on"),l(i.root,t.direction,"on",d.length),d.push(i),i.update(),i}function c(t){var i={};t=t||{};for(var s in t)t.hasOwnProperty(s)&&(i[s]=t[s]);return i}function h(t){var i=c(t);i.direction=i.direction||"v";var s=t.event||function(t,s,e,r){i.$(t)[r||"on"](s,e)};return i.event=function(t,i,r,o){e(t,function(t){s(t,i,r,o)})},i}function u(t){if(this.events&&this.events[t])for(var i=0;i<this.events[t].length;i++){var s=Array.prototype.slice.call(arguments,1);this.events[t][i].apply(this,s)}}if(t){var f=r,p=["left","top","right","bottom","width","height"],d=[],v={v:{x:"Y",pos:p[1],oppos:p[3],crossPos:p[0],crossOpPos:p[2],size:p[5],crossSize:p[4],crossMinSize:"min-"+p[4],crossMaxSize:"max-"+p[4],client:"clientHeight",crossClient:"clientWidth",crossScroll:"scrollWidth",offset:"offsetHeight",crossOffset:"offsetWidth",offsetPos:"offsetTop",scroll:"scrollTop",scrollSize:"scrollHeight"},h:{x:"X",pos:p[0],oppos:p[2],crossPos:p[1],crossOpPos:p[3],size:p[4],crossSize:p[5],crossMinSize:"min-"+p[5],crossMaxSize:"max-"+p[5],client:"clientWidth",crossClient:"clientHeight",crossScroll:"scrollHeight",offset:"offsetWidth",crossOffset:"offsetHeight",offsetPos:"offsetLeft",scroll:"scrollLeft",scrollSize:"scrollWidth"}};r._instances=d,r.fn={constructor:function(t,i,r){var o=h(i);o.$=r,this.length=0,e.call(this,t,function(t,e){var r=l(t,o.direction),n=+r;if(n==n&&r!=s&&d[n]&&!i)this[e]=d[n];else{var h=c(o);o.root&&o.scroller?(h.scroller=o.$(o.scroller,t),h.scroller.length||(h.scroller=t)):h.scroller=t,h.root=t,this[e]=a(h)}this.length=e+1}),this.params=o},dispose:function(){var t=this.params;e(this,function(i){i.dispose(t)}),this.params=null},update:function(){for(var t=0;this[t];)this[t].update.apply(this[t],arguments),t++},baron:function(t){return t.root=[],t.scroller=this.params.scroller,e.call(this,this,function(i){t.root.push(i.root)}),t.direction="v"==this.params.direction?"h":"v",t._chain=!0,r(t)}};var g={};g.prototype={_debounce:function(t,i){var e,r,n=this,l=function(){if(n._disposed)return clearTimeout(e),e=n=null,s;var a=o()-r;i>a&&a>=0?e=setTimeout(l,i-a):(e=null,t())};return function(){r=o(),e||(e=setTimeout(l,i))}},constructor:function(t){function i(t,i){return h(t,i)[0]}function e(t){var i=this.barMinSize||20;t>0&&i>t&&(t=i),this.bar&&h(this.bar).css(this.origin.size,parseInt(t,10)+"px")}function r(t){if(this.bar){var i=h(this.bar).css(this.origin.pos),s=+t+"px";s&&s!=i&&h(this.bar).css(this.origin.pos,s)}}function n(){return d[this.origin.client]-this.barTopLimit-this.bar[this.origin.offset]}function l(t){return t*n.call(this)+this.barTopLimit}function a(t){return(t-this.barTopLimit)/n.call(this)}function c(){return!1}var h,f,p,d,g,m,b,C,y,w,z;return w=y=o(),h=this.$=t.$,this.event=t.event,this.events={},this.root=t.root,this.scroller=i(t.scroller),this.bar=i(t.bar,this.root),d=this.track=i(t.track,this.root),!this.track&&this.bar&&(d=this.bar.parentNode),this.clipper=this.scroller.parentNode,this.direction=t.direction,this.origin=v[this.direction],this.barOnCls=t.barOnCls||"_baron",this.scrollingCls=t.scrollingCls,this.draggingCls=t.draggingCls,this.barTopLimit=0,C=1e3*t.pause||0,t.pause&&console.warn('Baronjs: "pause" param will be removed in 0.8+ version'),this.cursor=function(t){return t["client"+this.origin.x]||(((t.originalEvent||t).touches||{})[0]||{})["page"+this.origin.x]},this.pos=function(t){var i="page"+this.origin.x+"Offset",e=this.scroller[i]?i:this.origin.scroll;return t!==s&&(this.scroller[e]=t),this.scroller[e]},this.rpos=function(t){var i,s=this.scroller[this.origin.scrollSize]-this.scroller[this.origin.client];return i=t?this.pos(t*s):this.pos(),i/(s||1)},this.barOn=function(t){this.barOnCls&&(t||this.scroller[this.origin.client]>=this.scroller[this.origin.scrollSize]?h(this.root).hasClass(this.barOnCls)&&h(this.root).removeClass(this.barOnCls):h(this.root).hasClass(this.barOnCls)||h(this.root).addClass(this.barOnCls))},this._pos0=function(t){p=this.cursor(t)-f},this.drag=function(t){var i=a.call(this,this.cursor(t)-p),s=this.scroller[this.origin.scrollSize]-this.scroller[this.origin.client];this.scroller[this.origin.scroll]=i*s},this.selection=function(t){this.event(document,"selectpos selectstart",c,t?"off":"on")},this.resize=function(){function t(){var t,s,e=i.scroller[i.origin.crossOffset],r=i.scroller[i.origin.crossClient];if(r>0&&0===e&&(e=r+17),e)if(i.barOn(),r=i.scroller[i.origin.crossClient],"v"==i.direction){var n=e-r;t=h(i.clipper).css(i.origin.crossSize),s=i.clipper[i.origin.crossClient]+n+"px",t!=s&&i._setCrossSizes(i.scroller,s)}else t=h(i.clipper).css(i.origin.crossSize),s=r+"px",t!=s&&i._setCrossSizes(i.clipper,s);Array.prototype.unshift.call(arguments,"resize"),u.apply(i,arguments),w=o()}var i=this,s=0;o()-w<C&&(clearTimeout(g),s=C),s?g=setTimeout(t,s):t()},this.updatePositions=function(){var t,i=this;i.bar&&(t=(d[i.origin.client]-i.barTopLimit)*i.scroller[i.origin.client]/i.scroller[i.origin.scrollSize],parseInt(z,10)!=parseInt(t,10)&&(e.call(i,t),z=t),f=l.call(i,i.rpos()),r.call(i,f)),Array.prototype.unshift.call(arguments,"scroll"),u.apply(i,arguments),y=o()},this.scroll=function(){var t=0,i=this;o()-y<C&&(clearTimeout(m),t=C),t?m=setTimeout(function(){i.updatePositions()},t):i.updatePositions(),i.scrollingCls&&(b||this.$(this.scroller).addClass(this.scrollingCls),clearTimeout(b),b=setTimeout(function(){i.$(i.scroller).removeClass(i.scrollingCls),b=s},300))},this._setCrossSizes=function(t,i){var s={};s[this.origin.crossSize]=i,s[this.origin.crossMinSize]=i,s[this.origin.crossMaxSize]=i,this.$(t).css(s)},this},update:function(t){return u.call(this,"upd",t),this.resize(1),this.updatePositions(),this},dispose:function(t){n(this,this.event,"off"),l(this.root,t.direction,"off"),"v"==t.direction?this._setCrossSizes(this.scroller,""):this._setCrossSizes(this.clipper,""),this.barOn(!0),u.call(this,"dispose"),this._disposed=!0},on:function(t,i,s){for(var e=t.split(" "),r=0;r<e.length;r++)"init"==e[r]?i.call(this,s):(this.events[e[r]]=this.events[e[r]]||[],this.events[e[r]].push(function(t){i.call(this,t||s)}))}},r.fn.constructor.prototype=r.fn,g.prototype.constructor.prototype=g.prototype,r.noConflict=function(){return t.baron=f,r},r.version="0.7.16",i&&i.fn&&(i.fn.baron=r),t.baron=r,"undefined"!=typeof module&&(module.exports=r.noConflict())}}(window,window.$),function(t,s){var e=function(t){function e(t,i,e){var r=1==e?"pos":"oppos";l<(a.minView||0)&&(i=s),this.$(n[t]).css(this.origin.pos,"").css(this.origin.oppos,"").removeClass(a.outside),i!==s&&(i+="px",this.$(n[t]).css(this.origin[r],i).addClass(a.outside))}function r(t){try{i=document.createEvent("WheelEvent"),i.initWebKitWheelEvent(t.originalEvent.wheelDeltaX,t.originalEvent.wheelDeltaY),f.dispatchEvent(i),t.preventDefault()}catch(t){}}function o(t){var i;for(var s in t)a[s]=t[s];if(n=this.$(a.elements,this.scroller)){l=this.scroller[this.origin.client];for(var e=0;e<n.length;e++)i={},i[this.origin.size]=n[e][this.origin.offset],n[e].parentNode!==this.scroller&&this.$(n[e].parentNode).css(i),i={},i[this.origin.crossSize]=n[e].parentNode[this.origin.crossClient],this.$(n[e]).css(i),l-=n[e][this.origin.offset],u[e]=n[e].parentNode[this.origin.offsetPos],c[e]=c[e-1]||0,h[e]=h[e-1]||Math.min(u[e],0),n[e-1]&&(c[e]+=n[e-1][this.origin.offset],h[e]+=n[e-1][this.origin.offset]),(0!=e||0!=u[e])&&(this.event(n[e],"mousewheel",r,"off"),this.event(n[e],"mousewheel",r));a.limiter&&n[0]&&(this.track&&this.track!=this.scroller?(i={},i[this.origin.pos]=n[0].parentNode[this.origin.offset],this.$(this.track).css(i)):this.barTopLimit=n[0].parentNode[this.origin.offset],this.scroll()),a.limiter===!1&&(this.barTopLimit=0)}var o={element:n,handler:function(){for(var t,i=d(this)[0].parentNode,s=i.offsetTop,e=0;e<n.length;e++)n[e]===this&&(t=e);var r=s-c[t];a.scroll?a.scroll({x1:v.scroller.scrollTop,x2:r}):v.scroller.scrollTop=r},type:"click"};a.clickable&&(this._eventHandlers.push(o),p(o.element,o.type,o.handler,"on"))}var n,l,a={outside:"",inside:"",before:"",after:"",past:"",future:"",radius:0,minView:0},c=[],h=[],u=[],f=this.scroller,p=this.event,d=this.$,v=this;this.on("init",o,t);var g=[],m=[];this.on("init scroll",function(){var t,i,r;if(n){for(var o,f=0;f<n.length;f++)t=0,u[f]-this.pos()<h[f]+a.radius?(t=1,i=c[f]):u[f]-this.pos()>h[f]+l-a.radius?(t=2,i=this.scroller[this.origin.client]-n[f][this.origin.offset]-c[f]-l):(t=3,i=s),r=!1,(u[f]-this.pos()<h[f]||u[f]-this.pos()>h[f]+l)&&(r=!0),(t!=g[f]||r!=m[f])&&(e.call(this,f,i,t),g[f]=t,m[f]=r,o=!0);if(o)for(f=0;f<n.length;f++)1==g[f]&&a.past&&this.$(n[f]).addClass(a.past).removeClass(a.future),2==g[f]&&a.future&&this.$(n[f]).addClass(a.future).removeClass(a.past),3==g[f]?((a.future||a.past)&&this.$(n[f]).removeClass(a.past).removeClass(a.future),a.inside&&this.$(n[f]).addClass(a.inside)):a.inside&&this.$(n[f]).removeClass(a.inside),g[f]!=g[f+1]&&1==g[f]&&a.before?this.$(n[f]).addClass(a.before).removeClass(a.after):g[f]!=g[f-1]&&2==g[f]&&a.after?this.$(n[f]).addClass(a.after).removeClass(a.before):this.$(n[f]).removeClass(a.before).removeClass(a.after),a.grad&&(m[f]?this.$(n[f]).addClass(a.grad):this.$(n[f]).removeClass(a.grad))}}),this.on("resize upd",function(t){o.call(this,t&&t.fix)})};baron.fn.fix=function(t){for(var i=0;this[i];)e.call(this[i],t),i++;return this}}(window),function(t){var i=t.MutationObserver||t.WebKitMutationObserver||t.MozMutationObserver||null,s=function(){function t(){o.root[o.origin.offset]?e():s()}function s(){r||(r=setInterval(function(){o.root[o.origin.offset]&&(e(),o.update())},300))}function e(){clearInterval(r),r=null}var r,o=this,n=o._debounce(function(){o.update()},300);this._observer=new i(function(){t(),o.update(),n()}),this.on("init",function(){o._observer.observe(o.root,{childList:!0,subtree:!0,characterData:!0}),t()}),this.on("dispose",function(){o._observer.disconnect(),e(),delete o._observer})};baron.fn.autoUpdate=function(t){if(!i)return this;for(var e=0;this[e];)s.call(this[e],t),e++;return this}}(window),function(t,i){var s=function(t){var i,s,e,r,o,n=this;r=t.screen||.9,t.forward&&(i=this.$(t.forward,this.clipper),o={element:i,handler:function(){var i=n.pos()-t.delta||30;n.pos(i)},type:"click"},this._eventHandlers.push(o),this.event(o.element,o.type,o.handler,"on")),t.backward&&(s=this.$(t.backward,this.clipper),o={element:s,handler:function(){var i=n.pos()+t.delta||30;n.pos(i)},type:"click"},this._eventHandlers.push(o),this.event(o.element,o.type,o.handler,"on")),t.track&&(e=t.track===!0?this.track:this.$(t.track,this.clipper)[0],e&&(o={element:e,handler:function(t){var i=t["offset"+n.origin.x],s=n.bar[n.origin.offsetPos],e=0;s>i?e=-1:i>s+n.bar[n.origin.offset]&&(e=1);var o=n.pos()+e*r*n.scroller[n.origin.client];n.pos(o)},type:"mousedown"},this._eventHandlers.push(o),this.event(o.element,o.type,o.handler,"on")))};baron.fn.controls=function(t){for(var i=0;this[i];)s.call(this[i],t),i++;return this}}(window),function(t,i){var s=function(t){function i(){return m.scroller[m.origin.scroll]+m.scroller[m.origin.offset]}function s(){return m.scroller[m.origin.scrollSize]}function e(){return m.scroller[m.origin.client]}function r(t,i){var s=5e-4*t;return Math.floor(i-s*(t+550))}function o(t){h=t,t?(n(),l=setInterval(n,200)):clearInterval(l)}function n(){var n,l,h={},z=i(),$=s(),S=1==b;if(l=0,b>0&&(l=40),n=r(y,l),z>=$-y&&b>-1?S&&(y+=n):y=0,0>y&&(y=0),h[f]=y+"px",e()<=s()){m.$(u).css(h);for(var _=0;_<v.length;_++)m.$(v[_].self).css(v[_].property,Math.min(y/p*100,100)+"%")}g&&y&&m.$(m.root).addClass(g),0==y&&t.onCollapse&&t.onCollapse(),b=0,a=setTimeout(function(){b=-1},w),d&&y>p&&!c&&(d(),c=!0),0==y?C++:C=0,C>1&&(o(!1),c=!1,g&&m.$(m.root).removeClass(g))}var l,a,c,h,u=this.$(t.block),f=t.size||this.origin.size,p=t.limit||80,d=t.onExpand,v=t.elements||[],g=t.inProgress||"",m=this,b=0,C=0,y=0,w=t.waiting||500;this.on("init",function(){o(!0)}),this.on("dispose",function(){o(!1)}),this.event(this.scroller,"mousewheel DOMMouseScroll",function(t){var e=t.wheelDelta<0||t.originalEvent&&t.originalEvent.wheelDelta<0||t.detail>0;e&&(b=1,clearTimeout(a),!h&&i()>=s()&&o(!0))})};baron.fn.pull=function(t){for(var i=0;this[i];)s.call(this[i],t),i++;return this}}(window);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(62);
	
	var _BtnSideJinja = __webpack_require__(63);
	
	var _BtnSideJinja2 = _interopRequireDefault(_BtnSideJinja);
	
	var STROKE_OFFSET = 26;
	var BOTTOM_OFFSET = 50;
	
	var BtnSide = _backboneBackbone2['default'].View.extend({
	    el: '.BtnSide',
	
	    initialize: function initialize() {
	        this.$el.addClass('isNotHoverable');
	
	        this.$circles = this.$('.BtnSide-circle');
	
	        this.$circleLeftTop = this.$circles.filter('.BtnSide-circle--leftTop');
	        this.$circleRightTop = this.$circles.filter('.BtnSide-circle--rightTop');
	        this.$circleLeftBottom = this.$circles.filter('.BtnSide-circle--leftBottom');
	        this.$circleRightBottom = this.$circles.filter('.BtnSide-circle--rightBottom');
	
	        $.Velocity.hook(this.$circles, 'opacity', 0);
	        $.Velocity.hook(this.$circleLeftTop, 'stroke-dashoffset', STROKE_OFFSET);
	        $.Velocity.hook(this.$circleRightTop, 'stroke-dashoffset', STROKE_OFFSET);
	        $.Velocity.hook(this.$circleLeftBottom, 'stroke-dashoffset', STROKE_OFFSET);
	        $.Velocity.hook(this.$circleRightBottom, 'stroke-dashoffset', STROKE_OFFSET);
	    },
	
	    activateSide: function activateSide() {
	        var duration = 1000;
	
	        $.Velocity.hook(this.$el[0], 'opacity', 1);
	        $.Velocity.hook(this.$el[0], 'translateY', 0);
	
	        $.Velocity.animate(this.$el[0], {
	            display: 'none',
	            opacity: [0, 'easeInQuad'],
	            translateY: [-(app.els.$window.height() / 2 - BOTTOM_OFFSET - this.$el.outerHeight() / 2) + 'px', 'easeOutCubic']
	        }, {
	            duration: duration
	        });
	
	        return duration;
	    },
	
	    deactivateSide: function deactivateSide() {
	        return $.Velocity.animate(this.$el[0], {
	            display: 'block',
	            opacity: [1, 'easeOutQuad'],
	            translateY: [0, 'easeOutQuad']
	        }, {
	            duration: 1000
	        });
	    },
	
	    playIn: function playIn() {
	        var _this = this;
	
	        $.Velocity.animate(this.$circleLeftTop[0], {
	            opacity: 1,
	            'stroke-dashoffset': 0
	        }, {
	            duration: 800,
	            easing: 'linear'
	        });
	
	        $.Velocity.animate(this.$circleRightBottom[0], {
	            opacity: 1,
	            'stroke-dashoffset': 0
	        }, {
	            duration: 800,
	            easing: 'linear'
	        });
	
	        $.Velocity.animate(this.$circleRightTop[0], {
	            opacity: 1,
	            'stroke-dashoffset': 0
	        }, {
	            duration: 800,
	            easing: 'linear',
	            delay: 400
	        });
	
	        $.Velocity.animate(this.$circleLeftBottom[0], {
	            opacity: 1,
	            'stroke-dashoffset': 0
	        }, {
	            duration: 800,
	            easing: 'linear',
	            delay: 600
	        }).then(function () {
	            _this.$el.removeClass('isNotHoverable');
	        });
	    },
	
	    playOut: function playOut() {}
	});
	
	exports['default'] = BtnSide;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 62 */
5,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["BtnSide.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	output += "<button class=\"BtnSide u-Btn\">\n    ";
	output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/BtnSide/BtnSide.svg")), env.opts.autoescape);
	output += "\n</button>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["BtnSide.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 64 */
5,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	var _frontComponentsSliderSliderJs = __webpack_require__(17);
	
	var _frontComponentsSliderSliderJs2 = _interopRequireDefault(_frontComponentsSliderSliderJs);
	
	__webpack_require__(66);
	
	var _ProjectBottomJinja = __webpack_require__(67);
	
	var _ProjectBottomJinja2 = _interopRequireDefault(_ProjectBottomJinja);
	
	var Project = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    events: {
	        'click .Project-button': 'onOrderProjectClick'
	    },
	    initialize: function initialize() {
	        var _this = this;
	
	        _underscoreUnderscore2['default'].bindAll(this, 'openSlide', 'closeSlide', 'onOrderProjectClick');
	
	        this.views = [];
	
	        _underscoreUnderscore2['default'].each(this.$('.Slider'), function (el) {
	            var $el = $(el);
	
	            if ($el.find('.Slider-slide').length > 1) {
	                _this.views.push(new _frontComponentsSliderSliderJs2['default']({
	                    el: $el,
	                    type: 'project'
	                }));
	            }
	        });
	
	        this.$overlay = this.$('.Project-overlay');
	        this.$top = this.$('.Project-top');
	        this.$bottom = this.$('.Project-bottom');
	
	        app.vent.on('ProjectSide-isOpening', this.openSlide);
	        app.vent.on('ProjectSide-isClosing', this.closeSlide);
	    },
	
	    onOrderProjectClick: function onOrderProjectClick() {
	        app.views.applicationPopup.activate();
	    },
	
	    openSlide: function openSlide() {
	        $.Velocity.animate(this.$overlay[0], { opacity: [0.8, 0] }, { display: 'block' });
	
	        $.Velocity.animate([this.$top[0], this.$bottom[0]], {
	            translateX: [350, 0],
	            translateZ: 0
	        }, {
	            duration: 500,
	            easing: 'easeOutQuad'
	        });
	    },
	
	    closeSlide: function closeSlide() {
	        $.Velocity.animate(this.$overlay[0], { opacity: [0, 0.8] }, { display: 'none' });
	
	        $.Velocity.animate([this.$top[0], this.$bottom[0]], {
	            translateX: [0, 350],
	            translateZ: 0
	        }, {
	            duration: 500,
	            easing: 'easeOutQuad'
	        });
	    },
	
	    refreshSliders: function refreshSliders() {
	        _underscoreUnderscore2['default'].each(this.views, function (view) {
	            view.refresh();
	        });
	    }
	});
	
	exports['default'] = Project;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 66 */
5,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/ProjectList/ProjectList.jinja"] = __webpack_require__( 49 );
	dependencies["front/components/ProjectItem/ProjectItem.jinja"] = __webpack_require__( 47 );
	dependencies["front/components/Project/ProjectImage.jinja"] = __webpack_require__( 68 );
	dependencies["front/components/Project/ProjectGallery.jinja"] = __webpack_require__( 69 );
	dependencies["front/components/Footer/Footer.jinja"] = __webpack_require__( 33 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectBottom.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/ProjectList/ProjectList.jinja", false, "ProjectBottom.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("ProjectList", t_1);
	env.getTemplate("front/components/ProjectItem/ProjectItem.jinja", false, "ProjectBottom.jinja", function(t_5,t_4) {
	if(t_5) { cb(t_5); return; }
	t_4.getExported(function(t_6,t_4) {
	if(t_6) { cb(t_6); return; }
	context.setVariable("ProjectItem", t_4);
	env.getTemplate("front/components/Project/ProjectImage.jinja", false, "ProjectBottom.jinja", function(t_8,t_7) {
	if(t_8) { cb(t_8); return; }
	t_7.getExported(function(t_9,t_7) {
	if(t_9) { cb(t_9); return; }
	context.setVariable("ProjectImage", t_7);
	env.getTemplate("front/components/Project/ProjectGallery.jinja", false, "ProjectBottom.jinja", function(t_11,t_10) {
	if(t_11) { cb(t_11); return; }
	t_10.getExported(function(t_12,t_10) {
	if(t_12) { cb(t_12); return; }
	context.setVariable("ProjectGallery", t_10);
	var macro_t_13 = runtime.makeMacro(
	["project"], 
	[], 
	function (l_project, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("project", l_project);
	var t_14 = "";t_14 += "<div class=\"Project-bottom\">\n        <div class=\"Project-grid\">\n            ";
	frame = frame.push();
	var t_17 = runtime.memberLookup((l_project),"media");
	if(t_17) {var t_16 = t_17.length;
	for(var t_15=0; t_15 < t_17.length; t_15++) {
	var t_18 = t_17[t_15];
	frame.set("m", t_18);
	frame.set("loop.index", t_15 + 1);
	frame.set("loop.index0", t_15);
	frame.set("loop.revindex", t_16 - t_15);
	frame.set("loop.revindex0", t_16 - t_15 - 1);
	frame.set("loop.first", t_15 === 0);
	frame.set("loop.last", t_15 === t_16 - 1);
	frame.set("loop.length", t_16);
	t_14 += "\n                ";
	if(runtime.memberLookup((t_18),"itemType") == "image") {
	t_14 += "\n                    ";
	t_14 += runtime.suppressValue((lineno = 11, colno = 51, runtime.callWrap(runtime.memberLookup((t_7),"ProjectImage"), "ProjectImage[\"ProjectIma\"]", context, [runtime.memberLookup((t_18),"item"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_19 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_20 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_20);
	});
	return macro_t_19;})()})])), env.opts.autoescape);
	t_14 += "\n                ";
	;
	}
	else {
	if(runtime.memberLookup((t_18),"itemType") == "gallery") {
	t_14 += "\n                    ";
	t_14 += runtime.suppressValue((lineno = 13, colno = 55, runtime.callWrap(runtime.memberLookup((t_10),"ProjectGallery"), "ProjectGallery[\"ProjectGal\"]", context, [runtime.memberLookup((t_18),"item"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_22 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_22);
	});
	return macro_t_21;})()})])), env.opts.autoescape);
	t_14 += "\n                ";
	;
	}
	;
	}
	t_14 += "\n            ";
	;
	}
	}
	frame = frame.pop();
	t_14 += "\n\n        </div>\n        <div class=\"u-CommonButtonWrapper\">\n            <button class=\"u-CommonButton Project-button\">";
	t_14 += runtime.suppressValue((lineno = 19, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Заказать проект"])), env.opts.autoescape);
	t_14 += "</button>\n        </div>\n\n        ";
	if(env.getFilter("length").call(context, runtime.memberLookup((l_project),"relatedProjects"))) {
	t_14 += "\n            <div class=\"Project-relevant\">\n                <h2 class=\"Project-subHeader u-Heading-2\">";
	t_14 += runtime.suppressValue((lineno = 24, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Релевантные проекты"])), env.opts.autoescape);
	t_14 += "</h2>\n\n                <div class=\"Project-projectList\">\n                    ";
	t_14 += runtime.suppressValue((lineno = 27, colno = 49, runtime.callWrap(runtime.memberLookup((t_1),"ProjectList"), "ProjectList[\"ProjectLis\"]", context, [runtime.makeKeywordArgs({"caller": (function (){var macro_t_23 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_24 = "";t_24 += "\n                        ";
	frame = frame.push();
	var t_27 = runtime.memberLookup((l_project),"relatedProjects");
	if(t_27) {var t_26 = t_27.length;
	for(var t_25=0; t_25 < t_27.length; t_25++) {
	var t_28 = t_27[t_25];
	frame.set("r", t_28);
	frame.set("loop.index", t_25 + 1);
	frame.set("loop.index0", t_25);
	frame.set("loop.revindex", t_26 - t_25);
	frame.set("loop.revindex0", t_26 - t_25 - 1);
	frame.set("loop.first", t_25 === 0);
	frame.set("loop.last", t_25 === t_26 - 1);
	frame.set("loop.length", t_26);
	t_24 += "\n                            ";
	t_24 += runtime.suppressValue((lineno = 29, colno = 57, runtime.callWrap(runtime.memberLookup((t_4),"ProjectItem"), "ProjectItem[\"ProjectIte\"]", context, [t_28,{"modifiers": ["project"]},runtime.makeKeywordArgs({"caller": (function (){var macro_t_29 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_30 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_30);
	});
	return macro_t_29;})()})])), env.opts.autoescape);
	t_24 += "\n                        ";
	;
	}
	}
	frame = frame.pop();
	t_24 += "\n                    ";
	;
	frame = frame.pop();
	return new runtime.SafeString(t_24);
	});
	return macro_t_23;})()})])), env.opts.autoescape);
	t_14 += "\n                </div>\n            </div>\n        ";
	;
	}
	t_14 += "\n\n        ";
	env.getTemplate("front/components/Footer/Footer.jinja", false, "ProjectBottom.jinja", function(t_33,t_31) {
	if(t_33) { cb(t_33); return; }
	t_31.render(context.getVariables(), frame, function(t_34,t_32) {
	if(t_34) { cb(t_34); return; }
	t_14 += t_32
	t_14 += "\n    </div>\n    ";
	t_14 += runtime.suppressValue((lineno = 38, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	t_14 += "\n";
	})});
	frame = frame.pop();
	return new runtime.SafeString(t_14);
	});
	context.addExport("ProjectBottom");
	context.setVariable("ProjectBottom", macro_t_13);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})})})})})})})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectBottom.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectImage.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	["image"], 
	[], 
	function (l_image, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("image", l_image);
	var t_2 = "";t_2 += "<div class=\"Project-img Project-img--";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_image),"size"), env.opts.autoescape);
	t_2 += "\">\n        <div class=\"Project-imgPadding\">\n            <div class=\"Project-imgInner u-Preload u-Cover\">\n                <img src=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_image),"img")),"main"), env.opts.autoescape);
	t_2 += "\"\n                     srcset=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_image),"img")),"main_2x"), env.opts.autoescape);
	t_2 += " 2x\"\n                     alt=\"Изображение проекта\">\n            </div>\n        </div>\n    </div>\n    ";
	t_2 += runtime.suppressValue((lineno = 10, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	t_2 += "\n";
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("ProjectImage");
	context.setVariable("ProjectImage", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectImage.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/Slider/Slider.jinja"] = __webpack_require__( 30 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectGallery.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/Slider/Slider.jinja", false, "ProjectGallery.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("Slider", t_1);
	var macro_t_4 = runtime.makeMacro(
	["gallery"], 
	[], 
	function (l_gallery, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("gallery", l_gallery);
	var t_5 = "";t_5 += "<div class=\"Project-slider\">\n        ";
	t_5 += runtime.suppressValue((lineno = 5, colno = 27, runtime.callWrap(runtime.memberLookup((t_1),"Slider"), "Slider[\"Slider\"]", context, [runtime.memberLookup((l_gallery),"galleryItems"),{"modifiers": ["project"]},runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_7 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_7);
	});
	return macro_t_6;})()})])), env.opts.autoescape);
	t_5 += "\n    </div>\n    ";
	t_5 += runtime.suppressValue((lineno = 7, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	t_5 += "\n";
	;
	frame = frame.pop();
	return new runtime.SafeString(t_5);
	});
	context.addExport("ProjectGallery");
	context.setVariable("ProjectGallery", macro_t_4);
	output += "\n\n";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectGallery.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(71);
	
	var _IntroTextJinja = __webpack_require__(72);
	
	var _IntroTextJinja2 = _interopRequireDefault(_IntroTextJinja);
	
	var IntroText = _backboneBackbone2['default'].View.extend({
	    el: '.IntroText',
	    events: {
	        'click .IntroText-more, .IntroText-less': 'toggleMore'
	    },
	    initialize: function initialize() {
	        _underscoreUnderscore2['default'].bindAll(this, 'toggleMore');
	
	        this.$introMoreButton = this.$('.IntroText-more');
	        this.$introLessButton = this.$('.IntroText-less');
	        this.$introTextExtended = this.$('.IntroText-moreText');
	        this.$htmlBody = $('html, body');
	    },
	    toggleMore: function toggleMore() {
	        var _this = this;
	
	        var isExpanded = this.$introMoreButton.hasClass('isHidden');
	
	        this.$('.IntroText-moreText').slideToggle(300, 'swing', function () {
	            if (!isExpanded) {
	                _this.$introLessButton.removeClass('isHidden');
	
	                return;
	            }
	
	            _this.$introMoreButton.removeClass('isHidden');
	        });
	
	        if (!isExpanded) {
	            this.$introMoreButton.addClass('isHidden');
	
	            return;
	        }
	
	        this.$introLessButton.addClass('isHidden');
	
	        var expandedTextHeight = this.$introTextExtended.outerHeight();
	        var windowScroll = this.$htmlBody.scrollTop();
	        var scrollPosition = windowScroll - expandedTextHeight;
	
	        this.$htmlBody.animate({
	            scrollTop: scrollPosition
	        }, 200);
	    }
	});
	
	exports['default'] = IntroText;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 71 */
5,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["IntroText.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	["introText"], 
	[], 
	function (l_introText, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("introText", l_introText);
	var t_2 = "";t_2 += "<div class=\"IntroText\">\n        <div class=\"IntroText-col IntroText-col--summary\">\n            <div class=\"IntroText-summary\">\n                ";
	if(runtime.memberLookup((l_introText),"authors")) {
	t_2 += "\n                    ";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_introText),"authors")), env.opts.autoescape);
	t_2 += "\n                ";
	;
	}
	t_2 += "\n\n                ";
	if(runtime.memberLookup((l_introText),"notes")) {
	t_2 += "\n                    ";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_introText),"notes")), env.opts.autoescape);
	t_2 += "\n                ";
	;
	}
	t_2 += "\n            </div>\n        </div>\n        <div class=\"IntroText-col IntroText-col--text\">\n            ";
	if(runtime.memberLookup((l_introText),"text")) {
	t_2 += "\n                <div class=\"IntroText-text\">";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_introText),"text")), env.opts.autoescape);
	t_2 += "</div>\n\n                ";
	if(runtime.memberLookup((l_introText),"textExtended")) {
	t_2 += "\n                    <div class=\"IntroText-more\">";
	t_2 += runtime.suppressValue((lineno = 18, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Узнать больше"])), env.opts.autoescape);
	t_2 += "</div>\n                    <div class=\"IntroText-moreText IntroText-text\" style=\"display: none\">\n                        <div class=\"IntroText-moreTextInner\">\n                            ";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_introText),"textExtended")), env.opts.autoescape);
	t_2 += "\n                        </div>\n                        <div class=\"IntroText-less\">";
	t_2 += runtime.suppressValue((lineno = 23, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Скрыть текст"])), env.opts.autoescape);
	t_2 += "</div>\n                    </div>\n                ";
	;
	}
	t_2 += "\n            ";
	;
	}
	t_2 += "\n        </div>\n    </div>";
	t_2 += runtime.suppressValue((lineno = 28, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("IntroText");
	context.setVariable("IntroText", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["IntroText.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 73 */
5,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/Project/ProjectBottom.jinja"] = __webpack_require__( 67 );
	dependencies["front/components/ProjectSide/ProjectSide.jinja"] = __webpack_require__( 75 );
	dependencies["front/components/IntroText/IntroText.jinja"] = __webpack_require__( 72 );
	dependencies["front/components/BtnClose/BtnClose.jinja"] = __webpack_require__( 58 );
	dependencies["front/components/Frame/Frame.jinja"] = __webpack_require__( 25 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectPage.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/Project/ProjectBottom.jinja", false, "ProjectPage.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("ProjectBottom", t_1);
	env.getTemplate("front/components/ProjectSide/ProjectSide.jinja", false, "ProjectPage.jinja", function(t_5,t_4) {
	if(t_5) { cb(t_5); return; }
	t_4.getExported(function(t_6,t_4) {
	if(t_6) { cb(t_6); return; }
	context.setVariable("ProjectSide", t_4);
	env.getTemplate("front/components/IntroText/IntroText.jinja", false, "ProjectPage.jinja", function(t_8,t_7) {
	if(t_8) { cb(t_8); return; }
	t_7.getExported(function(t_9,t_7) {
	if(t_9) { cb(t_9); return; }
	context.setVariable("IntroText", t_7);
	env.getTemplate("front/components/BtnClose/BtnClose.jinja", false, "ProjectPage.jinja", function(t_11,t_10) {
	if(t_11) { cb(t_11); return; }
	t_10.getExported(function(t_12,t_10) {
	if(t_12) { cb(t_12); return; }
	context.setVariable("BtnClose", t_10);
	output += "<div class=\"ProjectPage\">\n    <div class=\"PageTitle\">\n        <h1 class=\"PageTitle-content u-Heading\">";
	output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "project")),"title")), env.opts.autoescape);
	output += "</h1>\n    </div>\n\n    <article class=\"Project\">\n";
	output += "\n";
	output += "\n                <div class=\"Hero\">\n                    ";
	env.getTemplate("front/components/Frame/Frame.jinja", false, "ProjectPage.jinja", function(t_15,t_13) {
	if(t_15) { cb(t_15); return; }
	t_13.render(context.getVariables(), frame, function(t_16,t_14) {
	if(t_16) { cb(t_16); return; }
	output += t_14
	output += "\n\n                    <div class=\"Hero-img u-Preload u-Cover\">\n                        <img src=\"";
	output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "project")),"img")),"main"), env.opts.autoescape);
	output += "\" srcset=\"";
	output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "project")),"img")),"main_2x"), env.opts.autoescape);
	output += " 2x\"\n                             alt=\"";
	output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "project")),"title")), env.opts.autoescape);
	output += "\">\n                    </div>\n\n                    <button class=\"Hero-btn u-Btn\">\n                        ";
	output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Hero/Hero-btn.svg")), env.opts.autoescape);
	output += "\n                    </button>\n                </div>\n\n                <div class=\"Project-top\">\n                    ";
	output += runtime.suppressValue((lineno = 27, colno = 45, runtime.callWrap(runtime.memberLookup((t_7),"IntroText"), "IntroText[\"IntroText\"]", context, [runtime.contextOrFrameLookup(context, frame, "project"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_17 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_18 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_18);
	});
	return macro_t_17;})()})])), env.opts.autoescape);
	output += "\n                </div>\n";
	output += "\n\n";
	output += "\n                ";
	output += runtime.suppressValue((lineno = 32, colno = 49, runtime.callWrap(runtime.memberLookup((t_1),"ProjectBottom"), "ProjectBottom[\"ProjectBot\"]", context, [runtime.contextOrFrameLookup(context, frame, "project"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_19 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_20 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_20);
	});
	return macro_t_19;})()})])), env.opts.autoescape);
	output += "\n";
	output += "\n";
	output += "\n        <div class=\"Project-overlay\"></div>\n\n        <div class=\"Project-close\">\n            ";
	output += runtime.suppressValue((lineno = 38, colno = 35, runtime.callWrap(runtime.memberLookup((t_10),"BtnClose"), "BtnClose[\"BtnClose\"]", context, ["a",(lineno = 38, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["offcon:project-list"])),runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_22 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_22);
	});
	return macro_t_21;})()})])), env.opts.autoescape);
	output += "\n        </div>\n    </article>\n\n    ";
	output += runtime.suppressValue((lineno = 42, colno = 33, runtime.callWrap(runtime.memberLookup((t_4),"ProjectSide"), "ProjectSide[\"ProjectSid\"]", context, [runtime.contextOrFrameLookup(context, frame, "projects"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_23 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_24 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_24);
	});
	return macro_t_23;})()})])), env.opts.autoescape);
	output += "\n</div>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})})})})})})})})})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectPage.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/BtnClose/BtnClose.jinja"] = __webpack_require__( 58 );
	dependencies["front/components/BtnSide/BtnSide.jinja"] = __webpack_require__( 63 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectSide.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/BtnClose/BtnClose.jinja", false, "ProjectSide.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("BtnClose", t_1);
	var macro_t_4 = runtime.makeMacro(
	["projects"], 
	[], 
	function (l_projects, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("projects", l_projects);
	var t_5 = "";t_5 += "<div class=\"ProjectSide\">\n        <div class=\"ProjectSide-listContainer\">\n            <ul class=\"ProjectSide-list\">\n                ";
	frame = frame.push();
	var t_8 = l_projects;
	if(t_8) {var t_7 = t_8.length;
	for(var t_6=0; t_6 < t_8.length; t_6++) {
	var t_9 = t_8[t_6];
	frame.set("p", t_9);
	frame.set("loop.index", t_6 + 1);
	frame.set("loop.index0", t_6);
	frame.set("loop.revindex", t_7 - t_6);
	frame.set("loop.revindex0", t_7 - t_6 - 1);
	frame.set("loop.first", t_6 === 0);
	frame.set("loop.last", t_6 === t_7 - 1);
	frame.set("loop.length", t_7);
	t_5 += "\n                    <li class=\"ProjectSide-item\">\n                        <a class=\"ProjectSide-link\" href=\"";
	t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"url"), env.opts.autoescape);
	t_5 += "\" data-id=\"";
	t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"id"), env.opts.autoescape);
	t_5 += "\">";
	t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"title")), env.opts.autoescape);
	t_5 += "</a>\n                    </li>\n                ";
	;
	}
	}
	frame = frame.pop();
	t_5 += "\n            </ul>\n        </div>\n\n        <div class=\"ProjectSide-preview u-Cover\"></div>\n\n        ";
	t_5 += runtime.suppressValue((lineno = 16, colno = 31, runtime.callWrap(runtime.memberLookup((t_1),"BtnClose"), "BtnClose[\"BtnClose\"]", context, [runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_11 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_11);
	});
	return macro_t_10;})()})])), env.opts.autoescape);
	t_5 += "\n\n        <div class=\"ProjectSide-btnSide\">\n            ";
	env.getTemplate("front/components/BtnSide/BtnSide.jinja", false, "ProjectSide.jinja", function(t_14,t_12) {
	if(t_14) { cb(t_14); return; }
	t_12.render(context.getVariables(), frame, function(t_15,t_13) {
	if(t_15) { cb(t_15); return; }
	t_5 += t_13
	t_5 += "\n        </div>\n    </div>\n    ";
	t_5 += runtime.suppressValue((lineno = 22, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	})});
	frame = frame.pop();
	return new runtime.SafeString(t_5);
	});
	context.addExport("ProjectSide");
	context.setVariable("ProjectSide", macro_t_4);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ProjectSide.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsPageViewPageViewJs = __webpack_require__(15);
	
	var _frontComponentsPageViewPageViewJs2 = _interopRequireDefault(_frontComponentsPageViewPageViewJs);
	
	var _frontComponentsContactsContactsJs = __webpack_require__(77);
	
	var _frontComponentsContactsContactsJs2 = _interopRequireDefault(_frontComponentsContactsContactsJs);
	
	var _frontComponentsHeroHeroJs = __webpack_require__(35);
	
	var _frontComponentsHeroHeroJs2 = _interopRequireDefault(_frontComponentsHeroHeroJs);
	
	var _frontComponentsVideoVideoJs = __webpack_require__(37);
	
	var _frontComponentsVideoVideoJs2 = _interopRequireDefault(_frontComponentsVideoVideoJs);
	
	__webpack_require__(81);
	
	var _ContactsPageJinja = __webpack_require__(82);
	
	var _ContactsPageJinja2 = _interopRequireDefault(_ContactsPageJinja);
	
	var ContactsPage = _frontComponentsPageViewPageViewJs2['default'].extend({
	    el: '.ContactsPage',
	
	    type: 'Contacts',
	
	    template: _ContactsPageJinja2['default'],
	
	    apiUrl: '/api/pages/contacts/',
	
	    playIn: function playIn() {
	        var _this = this;
	
	        this.contacts.activateTitle().then(function () {
	            return _this.video.playIn();
	        }).then(function () {
	            app.views.nav.activate();
	            app.views.cookie.activate();
	            _this.hero.activateFrame();
	            app.views.logo.activate({ delay: 500 });
	            return app.views.langs.activate({ delay: 500 });
	        }).then(function () {
	            _this.contacts.activateInfo();
	            app.els.$body.removeClass('u-NoOverflow');
	        });
	    },
	
	    playOut: function playOut() {
	        var _this2 = this;
	
	        app.views.langs.deactivate();
	        app.views.logo.deactivate();
	        this.contacts.deactivateInfo();
	
	        return Promise.resolve(this.slider.deactivateImage()).then(function () {
	            _this2.slider.deactivateTitle();
	            return app.views.nav.deactivate();
	        });
	    },
	
	    prepare: function prepare() {
	        var _this3 = this;
	
	        this.$el[0].style.display = 'block';
	
	        this.$video = this.$('.Video');
	
	        this.contacts = this.views.contacts = new _frontComponentsContactsContactsJs2['default']();
	
	        this.hero = this.views.hero = new _frontComponentsHeroHeroJs2['default']({
	            el: this.$('.Hero')
	        });
	
	        this.video = this.views.video = new _frontComponentsVideoVideoJs2['default']({
	            el: this.$video
	        });
	
	        $.Velocity.hook(this.$video, 'opacity', '0');
	        $.Velocity.hook(this.contacts.$title, 'opacity', '0');
	        $.Velocity.hook(this.contacts.$footer, 'opacity', '0');
	        $.Velocity.hook(this.contacts.$list, 'opacity', '0');
	
	        return this.preloadImages().then(function () {
	            _this3.video.activate();
	        }).then(function () {
	            return _this3.promise;
	        }).then(function () {
	            app.els.$window.scrollTop(0);
	            return app.loader.deactivate();
	        });
	    },
	
	    cleanUp: function cleanUp() {
	        app.els.$body.addClass('u-NoOverflow');
	        this.close();
	        return app.loader.activate();
	    }
	});
	
	exports['default'] = ContactsPage;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(78);
	
	var _ContactsJinja = __webpack_require__(79);
	
	var _ContactsJinja2 = _interopRequireDefault(_ContactsJinja);
	
	var Contacts = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    el: '.Contacts',
	
	    initialize: function initialize() {
	        this.$title = this.$('.Contacts-address');
	        this.$footer = this.$('.Contacts-footer');
	        this.$list = this.$('.Contacts-list');
	    },
	
	    activateTitle: function activateTitle(options) {
	        var self = this;
	
	        return $.Velocity.animate(this.$title[0], { opacity: 1 }, _underscoreUnderscore2['default'].extend({
	            duration: 1500,
	            complete: function complete() {
	                self.$title.removeClass('isNotActive');
	            }
	        }, options));
	    },
	
	    deactivateTitle: function deactivateTitle(options) {
	        return $.Velocity.animate(this.$title[0], { opacity: 0 }, _underscoreUnderscore2['default'].extend({ duration: 1000 }, options));
	    },
	
	    activateInfo: function activateInfo(options) {
	        return $.Velocity.animate([this.$footer[0], this.$list[0]], { opacity: 1 }, _underscoreUnderscore2['default'].extend({ duration: 800 }, options));
	    },
	
	    deactivateInfo: function deactivateInfo(options) {
	        return $.Velocity.animate([this.$footer[0], this.$list[0]], { opacity: 0 }, _underscoreUnderscore2['default'].extend({ duration: 800 }, options));
	    }
	});
	
	exports['default'] = Contacts;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 78 */
5,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/HeaderLink/HeaderLink.jinja"] = __webpack_require__( 80 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Contacts.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/HeaderLink/HeaderLink.jinja", false, "Contacts.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("HeaderLink", t_1);
	output += "<div class=\"Contacts\">\n    <div class=\"Contacts-address\">\n        ";
	output += runtime.suppressValue((lineno = 4, colno = 35, runtime.callWrap(runtime.memberLookup((t_1),"HeaderLink"), "HeaderLink[\"HeaderLink\"]", context, ["<p>OFFCON</p>" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"address"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"addressLink"),(lineno = 4, colno = 95, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Посмотреть на карте"])),runtime.makeKeywordArgs({"caller": (function (){var macro_t_4 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_5 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_5);
	});
	return macro_t_4;})()})])), env.opts.autoescape);
	output += "\n    </div>\n\n    <ul class=\"Contacts-list\">\n        <a class=\"Contacts-link u-Link\" href=\"tel:";
	output += runtime.suppressValue(env.getFilter("replace").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"phone")," ",""), env.opts.autoescape);
	output += "\"><span>";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"phone"), env.opts.autoescape);
	output += "</span></a>\n        <a class=\"Contacts-link u-Link\" href=\"mailto:";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"email"), env.opts.autoescape);
	output += "\"><span>";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"email"), env.opts.autoescape);
	output += "</span></a>\n        <a class=\"Contacts-link u-Link\" href=\"";
	output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"linkedinLink"), env.opts.autoescape);
	output += "\" target=\"_blank\"><span>Linkedin</span></a>\n    </ul>\n\n    <footer class=\"Contacts-footer\">\n        <p>© 2015 OFFCON Architecture, Planning and Design</p>\n\n        <p>Designed in collaboration with Code and Theory</p>\n\n        <p>\n            Design by <a href=\"https://whiterussianstudio.com\" target=\"_blank\">WRS</a>,\n            Developed by <a href=\"https://astroshock.com/\" target=\"_blank\">Astroshock</a>\n        </p>\n    </footer>\n</div>\n";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Contacts.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["HeaderLink.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	["title"], 
	["link", "linkMessage"], 
	function (l_title, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("title", l_title);
	frame.set("link", kwargs.hasOwnProperty("link") ? kwargs["link"] : "");
	frame.set("linkMessage", kwargs.hasOwnProperty("linkMessage") ? kwargs["linkMessage"] : "Подробнее");
	var t_2 = "";t_2 += "<a class=\"HeaderLink u-Heading\" href=\"";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "link")), env.opts.autoescape);
	t_2 += "\" target=\"_blank\">\n        <span class=\"HeaderLink-linkContents\">\n            <span class=\"HeaderLink-titleContainer\">\n                <span class=\"HeaderLink-title\">";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, l_title), env.opts.autoescape);
	t_2 += "</span>\n            </span>\n            <span class=\"HeaderLink-linkMessage\">";
	t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "linkMessage"), env.opts.autoescape);
	t_2 += "</span>\n        </span>\n    </a>";
	t_2 += runtime.suppressValue((lineno = 8, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("HeaderLink");
	context.setVariable("HeaderLink", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["HeaderLink.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 81 */
5,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/Video/Video.jinja"] = __webpack_require__( 39 );
	dependencies["front/components/Frame/Frame.jinja"] = __webpack_require__( 25 );
	dependencies["front/components/Contacts/Contacts.jinja"] = __webpack_require__( 79 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ContactsPage.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/Video/Video.jinja", false, "ContactsPage.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("Video", t_1);
	output += "<div class=\"ContactsPage\">\n    <div class=\"Hero\">\n        ";
	env.getTemplate("front/components/Frame/Frame.jinja", false, "ContactsPage.jinja", function(t_6,t_4) {
	if(t_6) { cb(t_6); return; }
	t_4.render(context.getVariables(), frame, function(t_7,t_5) {
	if(t_7) { cb(t_7); return; }
	output += t_5
	output += "\n        ";
	output += runtime.suppressValue((lineno = 5, colno = 25, runtime.callWrap(runtime.memberLookup((t_1),"Video"), "Video[\"Video\"]", context, ["contacts_v2",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"img")),"main"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"is_tablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_9 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_9);
	});
	return macro_t_8;})()})])), env.opts.autoescape);
	output += "\n        ";
	env.getTemplate("front/components/Contacts/Contacts.jinja", false, "ContactsPage.jinja", function(t_12,t_10) {
	if(t_12) { cb(t_12); return; }
	t_10.render(context.getVariables(), frame, function(t_13,t_11) {
	if(t_13) { cb(t_13); return; }
	output += t_11
	output += "\n    </div>\n</div>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})})})})})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["ContactsPage.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsPageViewPageViewJs = __webpack_require__(15);
	
	var _frontComponentsPageViewPageViewJs2 = _interopRequireDefault(_frontComponentsPageViewPageViewJs);
	
	var _frontComponentsAboutAboutJs = __webpack_require__(84);
	
	var _frontComponentsAboutAboutJs2 = _interopRequireDefault(_frontComponentsAboutAboutJs);
	
	var _frontComponentsHeroHeroJs = __webpack_require__(35);
	
	var _frontComponentsHeroHeroJs2 = _interopRequireDefault(_frontComponentsHeroHeroJs);
	
	var _frontComponentsVideoVideoJs = __webpack_require__(37);
	
	var _frontComponentsVideoVideoJs2 = _interopRequireDefault(_frontComponentsVideoVideoJs);
	
	var _frontComponentsPageTitlePageTitleJs = __webpack_require__(54);
	
	var _frontComponentsPageTitlePageTitleJs2 = _interopRequireDefault(_frontComponentsPageTitlePageTitleJs);
	
	__webpack_require__(100);
	
	var _AboutPageJinja = __webpack_require__(101);
	
	var _AboutPageJinja2 = _interopRequireDefault(_AboutPageJinja);
	
	var AboutPage = _frontComponentsPageViewPageViewJs2['default'].extend({
	    el: '.AboutPage',
	
	    type: 'About',
	
	    template: _AboutPageJinja2['default'],
	
	    apiUrl: '/api/pages/about/',
	
	    initialize: function initialize(options) {
	        _underscoreUnderscore2['default'].bindAll(this, '_scrollListener', 'animateHeader');
	
	        this.state = new _backboneBackbone2['default'].Model({ inside: false });
	        this.scrollListener = _underscoreUnderscore2['default'].throttle(this._scrollListener, 100);
	
	        _frontComponentsPageViewPageViewJs2['default'].prototype.initialize.call(this, options);
	    },
	
	    _scrollListener: function _scrollListener() {
	        var scrollTop = app.els.$window.scrollTop();
	
	        if (scrollTop / app.els.$window.height() > 0.3) {
	            if (!this.state.get('inside')) {
	                this.state.set('inside', true);
	            }
	        } else {
	            if (this.state.get('inside')) {
	                this.state.set('inside', false);
	            }
	        }
	    },
	
	    animateHeader: function animateHeader(state) {
	        if (state.get('inside')) {
	            app.views.nav.minimize();
	            app.views.langs.deactivate();
	            this.pageTitle.$el.hide();
	            this.hero.deactivateArrow();
	        } else {
	            app.views.nav.maximize();
	            app.views.langs.activate();
	            this.pageTitle.$el.show();
	            this.hero.activateArrow();
	        }
	    },
	
	    playIn: function playIn() {
	        var _this = this;
	
	        this.pageTitle.playIn().then(function () {
	            return _this.video.playIn();
	        }).then(function () {
	            app.views.nav.activate({ fixed: true });
	            app.views.cookie.activate();
	            _this.hero.activateFrame();
	            app.views.logo.activate({ delay: 500 });
	            _this.hero.activateArrow();
	            return app.views.langs.activate({ delay: 500 });
	        }).then(function () {
	            app.els.$body.removeClass('u-NoOverflow');
	
	            _this.listenTo(_this.state, 'change:inside', _this.animateHeader);
	            app.els.$window.on('scroll', _this.scrollListener);
	        });
	    },
	
	    playOut: function playOut() {
	        var _this2 = this;
	
	        app.views.langs.deactivate();
	        app.views.logo.deactivate();
	
	        return Promise.resolve(this.hero.deactivateImage()).then(function () {
	            _this2.pageTitle.playOut();
	            return app.views.nav.deactivate();
	        });
	    },
	
	    prepare: function prepare() {
	        var _this3 = this;
	
	        this.$el[0].style.display = 'block';
	
	        this.$video = this.$('.Video');
	
	        this.about = this.views.about = new _frontComponentsAboutAboutJs2['default']();
	
	        this.pageTitle = this.views.pageTitle = new _frontComponentsPageTitlePageTitleJs2['default']({
	            el: this.$('.PageTitle')
	        });
	
	        this.hero = this.views.hero = new _frontComponentsHeroHeroJs2['default']({
	            el: this.$('.Hero')
	        });
	
	        this.video = this.views.video = new _frontComponentsVideoVideoJs2['default']({
	            el: this.$video
	        });
	
	        $.Velocity.hook(this.$video, 'opacity', '0');
	        $.Velocity.hook(this.pageTitle.$el, 'opacity', '0');
	        $.Velocity.hook(this.hero.$img, 'opacity', '0');
	
	        this.hero.$arrow.addClass('isNotActive isNotTransitioned');
	        this.hero.$frame.addClass('isNotActive');
	
	        return this.preloadImages().then(function () {
	            //return this.video.activate()
	        }).then(function () {
	            return _this3.promise;
	        }).then(function () {
	            app.els.$window.scrollTop(0);
	            return app.loader.deactivate();
	        });
	    },
	
	    cleanUp: function cleanUp() {
	        app.els.$window.off('scroll', this.scrollListener);
	        app.els.$body.addClass('u-NoOverflow');
	        this.close();
	        return app.loader.activate();
	    }
	});
	
	exports['default'] = AboutPage;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	var _frontComponentsFeatureListFeatureListJs = __webpack_require__(85);
	
	var _frontComponentsFeatureListFeatureListJs2 = _interopRequireDefault(_frontComponentsFeatureListFeatureListJs);
	
	var _frontComponentsPersonListPersonListJs = __webpack_require__(91);
	
	var _frontComponentsPersonListPersonListJs2 = _interopRequireDefault(_frontComponentsPersonListPersonListJs);
	
	__webpack_require__(97);
	
	var _AboutJinja = __webpack_require__(98);
	
	var _AboutJinja2 = _interopRequireDefault(_AboutJinja);
	
	var About = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    el: '.About',
	    events: {
	        'click .About-button': 'onOrderProjectClick'
	    },
	    initialize: function initialize() {
	        this.views = {};
	
	        this.featureList = this.views.featureList = new _frontComponentsFeatureListFeatureListJs2['default']();
	        this.personList = this.views.personList = new _frontComponentsPersonListPersonListJs2['default']();
	    },
	    onOrderProjectClick: function onOrderProjectClick() {
	        app.views.applicationPopup.activate();
	    }
	});
	
	exports['default'] = About;
	module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsFeatureFeatureJs = __webpack_require__(86);
	
	var _frontComponentsFeatureFeatureJs2 = _interopRequireDefault(_frontComponentsFeatureFeatureJs);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(89);
	
	var _FeatureListJinja = __webpack_require__(90);
	
	var _FeatureListJinja2 = _interopRequireDefault(_FeatureListJinja);
	
	var FeatureList = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    el: '.FeatureList',
	
	    initialize: function initialize() {
	        var _this = this;
	
	        this.views = _underscoreUnderscore2['default'].map(this.$el.find('.Feature'), function (el) {
	            return new _frontComponentsFeatureFeatureJs2['default']({
	                el: $(el),
	                parent: _this
	            });
	        });
	
	        this.state = new _backboneBackbone2['default'].Model({
	            activeFeature: null
	        });
	
	        this.on('Feature-toggled', this.toggle);
	    },
	
	    toggle: function toggle(newFeature) {
	        var activeFeature = this.state.get('activeFeature');
	
	        if (activeFeature) {
	            activeFeature.deactivate();
	        }
	
	        if (activeFeature !== newFeature) {
	            this.state.set('activeFeature', newFeature);
	            newFeature.activate();
	        } else {
	            this.state.set('activeFeature', null);
	        }
	    }
	});
	
	exports['default'] = FeatureList;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(87);
	
	var _FeatureJinja = __webpack_require__(88);
	
	var _FeatureJinja2 = _interopRequireDefault(_FeatureJinja);
	
	var Feature = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    events: {
	        'click .Feature-header': 'toggle'
	    },
	
	    initialize: function initialize(options) {
	        this.parent = options.parent;
	
	        this.$text = this.$('.Feature-text');
	        this.$icon = this.$('.Feature-icon');
	    },
	
	    toggle: function toggle() {
	        this.parent.trigger('Feature-toggled', this);
	    },
	
	    activate: function activate() {
	        this.$el.velocity('stop', true);
	        this.$text.velocity('stop', true);
	        this.$icon.velocity('stop', true);
	
	        this.$text.css({ visibility: 'hidden', display: 'block' });
	
	        this.textH = this.$text.outerHeight();
	
	        $.Velocity.animate(this.$el[0], {
	            'margin-bottom': [this.textH, 0]
	        }, {
	            duration: 800,
	            easing: 'linear'
	        });
	
	        $.Velocity.animate(this.$icon[0], {
	            rotateZ: ['90deg', '0deg']
	        }, {
	            duration: 800,
	            easing: 'linear'
	        });
	
	        return $.Velocity.animate(this.$text[0], {
	            opacity: [1, 0]
	        }, {
	            visibility: 'visible',
	            delay: 500,
	            duration: 400,
	            easing: 'linear'
	        });
	    },
	
	    deactivate: function deactivate() {
	        this.$el.velocity('stop', true);
	        this.$text.velocity('stop', true);
	        this.$icon.velocity('stop', true);
	
	        $.Velocity.animate(this.$icon[0], {
	            rotateZ: ['0deg', '90deg']
	        }, {
	            duration: 800,
	            easing: 'linear'
	        });
	
	        $.Velocity.animate(this.$text[0], {
	            opacity: [0, 1]
	        }, {
	            display: 'none',
	            duration: 400,
	            easing: 'linear'
	        });
	
	        return $.Velocity.animate(this.$el[0], {
	            'margin-bottom': [0, this.textH]
	        }, {
	            duration: 800,
	            easing: 'linear'
	        });
	    }
	});
	
	exports['default'] = Feature;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 87 */
5,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Feature.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	["f"], 
	[], 
	function (l_f, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("f", l_f);
	var t_2 = "";t_2 += "<li class=\"Feature ";
	if(!runtime.memberLookup((l_f),"text")) {
	t_2 += "Feature--isNotActive";
	;
	}
	t_2 += "\">\n        <a class=\"Feature-header\">\n            <span class=\"Feature-icon\">\n                ";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Feature/Feature.svg")), env.opts.autoescape);
	t_2 += "\n            </span>\n            <div class=\"Feature-title\">";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_f),"title")), env.opts.autoescape);
	t_2 += "</div>\n        </a>\n\n        <div class=\"Feature-text\">";
	t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_f),"text")), env.opts.autoescape);
	t_2 += "</div>\n    </li>";
	t_2 += runtime.suppressValue((lineno = 10, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("Feature");
	context.setVariable("Feature", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Feature.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 89 */
5,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/Feature/Feature.jinja"] = __webpack_require__( 88 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["FeatureList.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/Feature/Feature.jinja", false, "FeatureList.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("Feature", t_1);
	var macro_t_4 = runtime.makeMacro(
	["features"], 
	[], 
	function (l_features, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("features", l_features);
	var t_5 = "";t_5 += "<ul class=\"FeatureList\">\n        ";
	frame = frame.push();
	var t_8 = l_features;
	if(t_8) {var t_7 = t_8.length;
	for(var t_6=0; t_6 < t_8.length; t_6++) {
	var t_9 = t_8[t_6];
	frame.set("f", t_9);
	frame.set("loop.index", t_6 + 1);
	frame.set("loop.index0", t_6);
	frame.set("loop.revindex", t_7 - t_6);
	frame.set("loop.revindex0", t_7 - t_6 - 1);
	frame.set("loop.first", t_6 === 0);
	frame.set("loop.last", t_6 === t_7 - 1);
	frame.set("loop.length", t_7);
	t_5 += "\n            ";
	t_5 += runtime.suppressValue((lineno = 5, colno = 33, runtime.callWrap(runtime.memberLookup((t_1),"Feature"), "Feature[\"Feature\"]", context, [t_9,runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_11 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_11);
	});
	return macro_t_10;})()})])), env.opts.autoescape);
	t_5 += "\n        ";
	;
	}
	}
	frame = frame.pop();
	t_5 += "\n    </ul>";
	t_5 += runtime.suppressValue((lineno = 7, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_5);
	});
	context.addExport("FeatureList");
	context.setVariable("FeatureList", macro_t_4);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["FeatureList.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsPersonPersonJs = __webpack_require__(92);
	
	var _frontComponentsPersonPersonJs2 = _interopRequireDefault(_frontComponentsPersonPersonJs);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(95);
	
	var _PersonListJinja = __webpack_require__(96);
	
	var _PersonListJinja2 = _interopRequireDefault(_PersonListJinja);
	
	var PersonList = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    el: '.PersonList',
	
	    initialize: function initialize() {
	        this.views = _underscoreUnderscore2['default'].map(this.$el.find('.Person'), function (el) {
	            return new _frontComponentsPersonPersonJs2['default']({
	                el: $(el)
	            });
	        });
	    }
	});
	
	exports['default'] = PersonList;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(93);
	
	var _PersonJinja = __webpack_require__(94);
	
	var _PersonJinja2 = _interopRequireDefault(_PersonJinja);
	
	var Person = _backboneBackbone2['default'].View.extend({
	    events: {
	        'mouseenter': 'hoverOn',
	        'mouseleave': 'hoverOff'
	    },
	
	    initialize: function initialize() {
	        _underscoreUnderscore2['default'].bindAll(this, 'restartVideo', 'reverse');
	
	        this.$video = this.$('video');
	        this.video = this.$video[0];
	    },
	
	    hoverOn: function hoverOn() {
	        if (this.hoverOffInterval) {
	            clearInterval(this.hoverOffInterval);
	        }
	
	        this.video.play();
	        this.$video.on('ended', this.restartVideo);
	    },
	
	    hoverOff: function hoverOff() {
	        this.video.pause();
	        this.hoverOffInterval = setInterval(this.reverse, 40);
	        this.$video.off('enwded', this.restartVideo);
	    },
	
	    reverse: function reverse() {
	        //this.video.currentTime = this.video.duration - this.video.currentTime;
	        //this.paused = false;
	        //} else {
	        //    this.video.play();
	        //    this.video.pause();
	        //    if (this.video.buffered.end(0) === this.video.duration) {
	        //        this.video = true;
	        //        this.video.currentTime = this.video.duration - this.video.currentTime
	        //    }
	        //}
	
	        this.video.currentTime -= 0.04;
	
	        if (this.video.currentTime <= 0) {
	            clearInterval(this.hoverOffInterval);
	        }
	    },
	
	    restartVideo: function restartVideo() {
	        this.video.currentTime = 0;
	        this.video.play();
	    }
	});
	
	exports['default'] = Person;
	module.exports = exports['default'];

/***/ }),
/* 93 */
5,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Person.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	["p"], 
	["isTablet"], 
	function (l_p, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("p", l_p);
	frame.set("isTablet", kwargs.hasOwnProperty("isTablet") ? kwargs["isTablet"] : runtime.contextOrFrameLookup(context, frame, "False"));
	var t_2 = "";t_2 += "<li class=\"Person\">\n        <div class=\"Person-videoContainer\">\n            ";
	if(runtime.contextOrFrameLookup(context, frame, "isTablet")) {
	t_2 += "\n                <div class=\"Person-img u-Cover u-Preload\">\n                    <img src=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_p),"img")),"mobile"), env.opts.autoescape);
	t_2 += "\" alt=\"";
	t_2 += runtime.suppressValue((lineno = 5, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Фото сотрудника"])), env.opts.autoescape);
	t_2 += " - ";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"title"), env.opts.autoescape);
	t_2 += "\">\n                </div>\n            ";
	;
	}
	else {
	t_2 += "\n                ";
	if(runtime.memberLookup((l_p),"videoMp4") || runtime.memberLookup((l_p),"videoWebm")) {
	t_2 += "\n                    <video class=\"Person-video\" preload>\n                        <source src=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"videoMp4"), env.opts.autoescape);
	t_2 += "\" type=\"video/mp4\"/>\n                        <source src=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"videoWebm"), env.opts.autoescape);
	t_2 += "\" type=\"video/webm\"/>\n                    </video>\n                ";
	;
	}
	else {
	t_2 += "\n                    <div class=\"Person-img u-Cover u-Preload\">\n                        <img src=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_p),"img")),"mobile"), env.opts.autoescape);
	t_2 += "\" alt=\"";
	t_2 += runtime.suppressValue((lineno = 15, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Фото сотрудника"])), env.opts.autoescape);
	t_2 += " - ";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"title"), env.opts.autoescape);
	t_2 += "\">\n                    </div>\n                ";
	;
	}
	t_2 += "\n            ";
	;
	}
	t_2 += "\n        </div>\n\n        <div class=\"Frame\">\n            <div class=\"Frame-side Frame-side--right\"></div>\n            <div class=\"Frame-side Frame-side--bottom\"></div>\n        </div>\n\n        <div class=\"Person-text\">\n            <div class=\"Person-title\">";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"title"), env.opts.autoescape);
	t_2 += "</div>\n            <div class=\"Person-subTitle\">";
	t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"subTitle"), env.opts.autoescape);
	t_2 += "</div>\n        </div>\n    </li>";
	t_2 += runtime.suppressValue((lineno = 30, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("Person");
	context.setVariable("Person", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Person.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 95 */
5,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/Person/Person.jinja"] = __webpack_require__( 94 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["PersonList.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/Person/Person.jinja", false, "PersonList.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("Person", t_1);
	var macro_t_4 = runtime.makeMacro(
	["persons"], 
	["isTablet"], 
	function (l_persons, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("persons", l_persons);
	frame.set("isTablet", kwargs.hasOwnProperty("isTablet") ? kwargs["isTablet"] : runtime.contextOrFrameLookup(context, frame, "False"));
	var t_5 = "";t_5 += "<ul class=\"PersonList\">\n        ";
	frame = frame.push();
	var t_8 = l_persons;
	if(t_8) {var t_7 = t_8.length;
	for(var t_6=0; t_6 < t_8.length; t_6++) {
	var t_9 = t_8[t_6];
	frame.set("p", t_9);
	frame.set("loop.index", t_6 + 1);
	frame.set("loop.index0", t_6);
	frame.set("loop.revindex", t_7 - t_6);
	frame.set("loop.revindex0", t_7 - t_6 - 1);
	frame.set("loop.first", t_6 === 0);
	frame.set("loop.last", t_6 === t_7 - 1);
	frame.set("loop.length", t_7);
	t_5 += "\n            ";
	t_5 += runtime.suppressValue((lineno = 5, colno = 31, runtime.callWrap(runtime.memberLookup((t_1),"Person"), "Person[\"Person\"]", context, [t_9,runtime.contextOrFrameLookup(context, frame, "isTablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_11 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_11);
	});
	return macro_t_10;})()})])), env.opts.autoescape);
	t_5 += "\n        ";
	;
	}
	}
	frame = frame.pop();
	t_5 += "\n    </ul>";
	t_5 += runtime.suppressValue((lineno = 7, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_5);
	});
	context.addExport("PersonList");
	context.setVariable("PersonList", macro_t_4);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["PersonList.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 97 */
5,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/IntroText/IntroText.jinja"] = __webpack_require__( 72 );
	dependencies["front/components/FeatureList/FeatureList.jinja"] = __webpack_require__( 90 );
	dependencies["front/components/PersonList/PersonList.jinja"] = __webpack_require__( 96 );
	dependencies["front/components/LogoItem/LogoItem.jinja"] = __webpack_require__( 99 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["About.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/IntroText/IntroText.jinja", false, "About.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("IntroText", t_1);
	env.getTemplate("front/components/FeatureList/FeatureList.jinja", false, "About.jinja", function(t_5,t_4) {
	if(t_5) { cb(t_5); return; }
	t_4.getExported(function(t_6,t_4) {
	if(t_6) { cb(t_6); return; }
	context.setVariable("FeatureList", t_4);
	env.getTemplate("front/components/PersonList/PersonList.jinja", false, "About.jinja", function(t_8,t_7) {
	if(t_8) { cb(t_8); return; }
	t_7.getExported(function(t_9,t_7) {
	if(t_9) { cb(t_9); return; }
	context.setVariable("PersonList", t_7);
	env.getTemplate("front/components/LogoItem/LogoItem.jinja", false, "About.jinja", function(t_11,t_10) {
	if(t_11) { cb(t_11); return; }
	t_10.getExported(function(t_12,t_10) {
	if(t_12) { cb(t_12); return; }
	context.setVariable("LogoItem", t_10);
	output += "<div class=\"About\">\n    ";
	output += runtime.suppressValue((lineno = 6, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"IntroText"), "IntroText[\"IntroText\"]", context, [runtime.contextOrFrameLookup(context, frame, "about"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_13 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_14 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_14);
	});
	return macro_t_13;})()})])), env.opts.autoescape);
	output += "\n\n    <div class=\"u-CommonButtonWrapper About-buttonWrapper\">\n        <button class=\"About-button u-CommonButton\">";
	output += runtime.suppressValue((lineno = 9, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Заказать проект"])), env.opts.autoescape);
	output += "</button>\n    </div>\n\n    ";
	output += runtime.suppressValue((lineno = 12, colno = 33, runtime.callWrap(runtime.memberLookup((t_4),"FeatureList"), "FeatureList[\"FeatureLis\"]", context, [runtime.contextOrFrameLookup(context, frame, "features"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_15 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_16 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_16);
	});
	return macro_t_15;})()})])), env.opts.autoescape);
	output += "\n\n    <ul class=\"About-personList\">\n        ";
	output += runtime.suppressValue((lineno = 15, colno = 35, runtime.callWrap(runtime.memberLookup((t_7),"PersonList"), "PersonList[\"PersonList\"]", context, [runtime.contextOrFrameLookup(context, frame, "persons"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"is_tablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_17 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_18 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_18);
	});
	return macro_t_17;})()})])), env.opts.autoescape);
	output += "\n    </ul>\n\n    <ul class=\"About-logoList\">\n        ";
	frame = frame.push();
	var t_21 = runtime.contextOrFrameLookup(context, frame, "logos");
	if(t_21) {var t_20 = t_21.length;
	for(var t_19=0; t_19 < t_21.length; t_19++) {
	var t_22 = t_21[t_19];
	frame.set("l", t_22);
	frame.set("loop.index", t_19 + 1);
	frame.set("loop.index0", t_19);
	frame.set("loop.revindex", t_20 - t_19);
	frame.set("loop.revindex0", t_20 - t_19 - 1);
	frame.set("loop.first", t_19 === 0);
	frame.set("loop.last", t_19 === t_20 - 1);
	frame.set("loop.length", t_20);
	output += "\n            ";
	output += runtime.suppressValue((lineno = 20, colno = 35, runtime.callWrap(runtime.memberLookup((t_10),"LogoItem"), "LogoItem[\"LogoItem\"]", context, [t_22,runtime.makeKeywordArgs({"caller": (function (){var macro_t_23 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_24 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_24);
	});
	return macro_t_23;})()})])), env.opts.autoescape);
	output += "\n\n            ";
	if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") % 3 == 0 && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")) {
	output += "\n                <div class=\"About-divider\"></div>\n            ";
	;
	}
	output += "\n        ";
	;
	}
	}
	frame = frame.pop();
	output += "\n    </ul>\n</div>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})})})})})})})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["About.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["LogoItem.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	var macro_t_1 = runtime.makeMacro(
	["l"], 
	[], 
	function (l_l, kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	frame.set("l", l_l);
	var t_2 = "";t_2 += "<div class=\"LogoItem\">\n        <img src=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_l),"img")),"main"), env.opts.autoescape);
	t_2 += "\"\n             srcset=\"";
	t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_l),"img")),"main_2x"), env.opts.autoescape);
	t_2 += " 2x\"\n             alt=\"Логотип\">\n    </div>";
	t_2 += runtime.suppressValue((lineno = 5, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
	;
	frame = frame.pop();
	return new runtime.SafeString(t_2);
	});
	context.addExport("LogoItem");
	context.setVariable("LogoItem", macro_t_1);
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["LogoItem.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 100 */
5,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	dependencies["front/components/Video/Video.jinja"] = __webpack_require__( 39 );
	dependencies["front/components/Frame/Frame.jinja"] = __webpack_require__( 25 );
	dependencies["front/components/About/About.jinja"] = __webpack_require__( 98 );
	dependencies["front/components/Footer/Footer.jinja"] = __webpack_require__( 33 );
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["AboutPage.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	env.getTemplate("front/components/Video/Video.jinja", false, "AboutPage.jinja", function(t_2,t_1) {
	if(t_2) { cb(t_2); return; }
	t_1.getExported(function(t_3,t_1) {
	if(t_3) { cb(t_3); return; }
	context.setVariable("Video", t_1);
	output += "<div class=\"AboutPage\">\n    <div class=\"PageTitle\">\n        <h1 class=\"PageTitle-content u-Heading\">";
	output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "about")),"title")), env.opts.autoescape);
	output += "</h1>\n    </div>\n\n    <div class=\"Hero\">\n        ";
	env.getTemplate("front/components/Frame/Frame.jinja", false, "AboutPage.jinja", function(t_6,t_4) {
	if(t_6) { cb(t_6); return; }
	t_4.render(context.getVariables(), frame, function(t_7,t_5) {
	if(t_7) { cb(t_7); return; }
	output += t_5
	output += "\n        ";
	output += runtime.suppressValue((lineno = 9, colno = 25, runtime.callWrap(runtime.memberLookup((t_1),"Video"), "Video[\"Video\"]", context, ["about_v2",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"img")),"main"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"is_tablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
	[], 
	[], 
	function (kwargs) {
	frame = frame.push();
	kwargs = kwargs || {};
	if (kwargs.hasOwnProperty("caller")) {
	frame.set("caller", kwargs.caller); }
	var t_9 = "";;
	frame = frame.pop();
	return new runtime.SafeString(t_9);
	});
	return macro_t_8;})()})])), env.opts.autoescape);
	output += "\n\n        <button class=\"Hero-btn u-Btn\">\n            ";
	output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Hero/Hero-btn.svg")), env.opts.autoescape);
	output += "\n        </button>\n    </div>\n\n    ";
	env.getTemplate("front/components/About/About.jinja", false, "AboutPage.jinja", function(t_12,t_10) {
	if(t_12) { cb(t_12); return; }
	t_10.render(context.getVariables(), frame, function(t_13,t_11) {
	if(t_13) { cb(t_13); return; }
	output += t_11
	output += "\n\n    ";
	env.getTemplate("front/components/Footer/Footer.jinja", false, "AboutPage.jinja", function(t_16,t_14) {
	if(t_16) { cb(t_16); return; }
	t_14.render(context.getVariables(), frame, function(t_17,t_15) {
	if(t_17) { cb(t_17); return; }
	output += t_15
	output += "\n</div>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	})})})})})})})});
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["AboutPage.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 102 */
5,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(104);
	
	var _ParallaxJinja = __webpack_require__(105);
	
	var _ParallaxJinja2 = _interopRequireDefault(_ParallaxJinja);
	
	var PARALLAX_START_SHIFT = 30;
	
	var Parallax = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    initialize: function initialize() {
	        _underscoreUnderscore2['default'].bindAll(this, '_parallaxHandler');
	
	        this.state = new _backboneBackbone2['default'].Model({
	            parallax: false
	        });
	
	        this.$front = this.$('.Parallax-front');
	        this.$back = this.$('.Parallax-back');
	
	        this.$front.css({
	            visibility: 'visible',
	            //top: (this.$back.outerHeight() - app.els.$window.height()) + 'px'
	            transform: 'translateY(' + (this.$back.outerHeight() - app.els.$window.height()) + 'px)'
	        });
	
	        this.parallaxHandler = _underscoreUnderscore2['default'].throttle(this._parallaxHandler, 50);
	        app.els.$window.on('scroll', this.parallaxHandler);
	    },
	
	    _parallaxHandler: function _parallaxHandler() {
	        var bottomPos = app.els.$window.height() - PARALLAX_START_SHIFT;
	        var topElement = document.elementFromPoint(app.els.$window.width() / 2, bottomPos);
	
	        if ($.contains(this.$back[0], topElement) && this.state.attributes.parallax) {
	            this.state.set('parallax', false);
	            this._disableParallax();
	        } else if ($.contains(this.$front[0], topElement) && !this.state.attributes.parallax) {
	            this.state.set('parallax', true);
	            this._enableParallax();
	        }
	    },
	
	    _enableParallax: function _enableParallax() {
	        this.$back.css({
	            position: 'fixed',
	            //top: -app.els.$window.scrollTop() + 'px'
	            transform: 'translateY(' + -app.els.$window.scrollTop() + 'px)'
	        });
	    },
	
	    _disableParallax: function _disableParallax() {
	        this.$back.css({
	            position: 'absolute',
	            //top: 0
	            transform: 'translateY(0px)'
	        });
	    },
	
	    close: function close() {
	        app.els.$window.off('scroll', this.parallaxHandler);
	        _frontComponentsBaseViewBaseViewJs2['default'].prototype.close.call(this);
	    }
	});
	
	exports['default'] = Parallax;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 104 */
5,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Parallax.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Parallax.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(107);
	
	var _BtnLoadJinja = __webpack_require__(50);
	
	var _BtnLoadJinja2 = _interopRequireDefault(_BtnLoadJinja);
	
	var BtnLoad = _backboneBackbone2['default'].View.extend({
	    initialize: function initialize() {}
	});
	
	exports['default'] = BtnLoad;
	module.exports = exports['default'];

/***/ }),
/* 107 */
5,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(109);
	
	var _HeaderLinkJinja = __webpack_require__(80);
	
	var _HeaderLinkJinja2 = _interopRequireDefault(_HeaderLinkJinja);
	
	var HeaderLink = _backboneBackbone2['default'].View.extend({
	    initialize: function initialize() {}
	});
	
	exports['default'] = HeaderLink;
	module.exports = exports['default'];

/***/ }),
/* 109 */
5,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(111);
	
	var _LogoItemJinja = __webpack_require__(99);
	
	var _LogoItemJinja2 = _interopRequireDefault(_LogoItemJinja);
	
	var LogoItem = _backboneBackbone2['default'].View.extend({
	    initialize: function initialize() {}
	});
	
	exports['default'] = LogoItem;
	module.exports = exports['default'];

/***/ }),
/* 111 */
5,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(113);
	
	var Nav = _backboneBackbone2['default'].View.extend({
	    el: '.Logo',
	
	    initialize: function initialize() {
	        _underscoreUnderscore2['default'].bindAll(this, 'activate', 'deactivate');
	
	        app.vent.on('logo.activate', this.activate);
	    },
	
	    activate: function activate(options) {
	        $.Velocity.hook(this.$el, 'opacity', '0');
	
	        this.$el[0].style.display = 'block';
	
	        return $.Velocity.animate(this.$el, {
	            opacity: [1, 'linear']
	        }, _underscoreUnderscore2['default'].extend({ duration: 500 }, options));
	    },
	
	    deactivate: function deactivate(options) {
	        $.Velocity.hook(this.$el, 'opacity', '1');
	
	        return $.Velocity.animate(this.$el, {
	            opacity: [0, 'linear']
	        }, _underscoreUnderscore2['default'].extend({ duration: 500 }, options));
	    }
	});
	
	exports['default'] = Nav;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 113 */
5,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(115);
	
	var SHIFT = 12;
	
	var Nav = _backboneBackbone2['default'].View.extend({
	    el: '.Nav',
	
	    events: {
	        'mouseenter .Nav-btn': 'hoverOn',
	        'mouseleave': 'hoverOff'
	        //'click .Nav-link': 'navigate'
	    },
	
	    initialize: function initialize() {
	        _underscoreUnderscore2['default'].bindAll(this, 'activate', 'deactivate', 'minimize', 'maximize', 'hoverOn', 'hoverOff');
	
	        this.state = new _backboneBackbone2['default'].Model({
	            minimized: false,
	            hovered: false
	        });
	        this.promise = null;
	
	        this.$items = this.$('.Nav-item');
	        this.$btn = this.$('.Nav-btn');
	        this.$list = this.$('.Nav-list');
	        this.$topLine = this.$('.Nav-line--top');
	        this.$bottomLine = this.$('.Nav-line--bottom');
	    },
	
	    navigate: function navigate(e) {
	        e.preventDefault();
	
	        var url = $(e.target).attr('href');
	        app.router.navigate(url, { trigger: 'true' });
	    },
	
	    activate: function activate(options) {
	        if (options && options.fixed) {
	            this.$el[0].style.position = 'fixed';
	        }
	
	        _underscoreUnderscore2['default'].each(this.$items, function (item, index) {
	            var index1 = index + 1;
	            var shift = SHIFT * -Math.pow(-1, index1 % 2);
	
	            $.Velocity.hook(item, 'translateX', shift + 'px');
	        });
	
	        $.Velocity.hook(this.$items, 'opacity', '0');
	
	        this.$el[0].style.display = 'block';
	        this.$list[0].style.display = 'block';
	
	        this.$items.velocity('stop', true);
	
	        return $.Velocity.animate(this.$items, {
	            opacity: [1, 'linear'],
	            translateX: [0, 'easeOutCubic']
	        }, _underscoreUnderscore2['default'].extend({ duration: 500 }, options));
	    },
	
	    deactivate: function deactivate(options) {
	        var promise;
	        var self = this;
	
	        this.$items.velocity('stop', true);
	
	        _underscoreUnderscore2['default'].each(this.$items, function (item, index) {
	            var index1 = index + 1;
	            var shift = SHIFT * -Math.pow(-1, index1 % 2);
	
	            $.Velocity.hook(item, 'translateX', 0);
	
	            promise = $.Velocity.animate(item, {
	                opacity: [0, 'linear'],
	                translateX: [shift + 'px', 'easeOutCubic']
	            }, _underscoreUnderscore2['default'].extend({
	                duration: 1000,
	                complete: function complete() {
	                    self.$list.css('display', 'none');
	                }
	            }, options));
	        });
	
	        //$.Velocity.animate(this.$btn[0], {opacity: [0, 'linear']}, _.extend({
	        //    duration: 1000,
	        //    complete() {
	        //        self.$list.css('display', 'none')
	        //    }
	        //}, options))
	
	        return promise;
	    },
	
	    maximize: function maximize(options) {
	        var _this = this;
	
	        var self = this;
	
	        $.Velocity.hook(this.$topLine[0], 'translateX', '0px');
	        $.Velocity.hook(this.$bottomLine[0], 'translateX', '0px');
	
	        this.state.set('minimized', false);
	
	        this.$topLine.velocity('stop', true);
	        this.$bottomLine.velocity('stop', true);
	
	        $.Velocity.animate(this.$topLine[0], {
	            translateX: ['100%', 'easeOutQuad']
	        }, _underscoreUnderscore2['default'].extend({
	            duration: 500,
	            display: 'none'
	        }, options));
	
	        var promise = $.Velocity.animate(this.$bottomLine[0], {
	            translateX: ['-100%', 'easeOutQuad']
	        }, _underscoreUnderscore2['default'].extend({
	            duration: 500,
	            display: 'none',
	            complete: function complete() {
	                self.$btn[0].style.display = 'none';
	                $.Velocity.hook(self.$btn, 'opacity', 0);
	            }
	        }, options));
	
	        return promise.then(function () {
	            if (_this.state.get('minimized') === true) {
	                return;
	            }
	
	            _this.activate();
	        });
	    },
	
	    minimize: function minimize(options) {
	        var _this2 = this;
	
	        $.Velocity.hook(this.$topLine[0], 'translateX', '100%');
	        $.Velocity.hook(this.$bottomLine[0], 'translateX', '-100%');
	
	        this.$btn[0].style.display = 'block';
	        $.Velocity.hook(this.$btn, 'opacity', 1);
	        this.state.set('minimized', true);
	
	        this.$topLine.velocity('stop', true);
	        this.$bottomLine.velocity('stop', true);
	
	        return this.deactivate().then(function () {
	            if (_this2.state.get('minimized') === false) {
	                return;
	            }
	
	            return $.Velocity.animate([_this2.$topLine[0], _this2.$bottomLine[0]], {
	                translateX: [0, 'easeOutQuad']
	            }, _underscoreUnderscore2['default'].extend({
	                duration: 500,
	                display: 'block'
	            }, options));
	        });
	    },
	
	    hoverOn: function hoverOn() {
	        this.state.set('hovered', true);
	        this.maximize();
	    },
	
	    hoverOff: function hoverOff() {
	        if (this.state.get('hovered')) {
	            this.state.set('hovered', false);
	            this.minimize();
	        }
	    }
	});
	
	exports['default'] = Nav;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 115 */
5,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _scrollLock = __webpack_require__(117);
	
	var _scrollLock2 = _interopRequireDefault(_scrollLock);
	
	__webpack_require__(118);
	
	var ApplicationPopup = _backboneBackbone2['default'].View.extend({
	    el: '.ApplicationPopup',
	
	    events: {
	        'click .ApplicationPopup-close button': 'onClose',
	        'input .ApplicationPopup-input': 'onInput',
	        'blur .ApplicationPopup-input': 'onBlur',
	        'click .ApplicationPopup-button': 'onSubmit',
	        'click .ApplicationPopup-overlay': 'onClose'
	    },
	
	    initialize: function initialize() {
	        _underscoreUnderscore2['default'].bindAll(this, 'activate', 'deactivate', 'onClose', 'onInput', 'onSubmit', 'onSuccess', 'onFailure', 'onBlur');
	
	        this.$popup = this.$('.ApplicationPopup-popup');
	        this.$overlay = this.$('.ApplicationPopup-overlay');
	        this.$inputs = this.$('.ApplicationPopup-input');
	        this.$button = this.$('.ApplicationPopup-button');
	        this.$loader = this.$('.ApplicationPopup-loader');
	        this.$failure = this.$('.ApplicationPopup-failure');
	        this.$success = this.$('.ApplicationPopup-success');
	
	        $("textarea").each(function () {
	            this.setAttribute("style", "overflow-y:hidden;");
	        }).on("input", function () {
	            this.style.height = 0;
	            this.style.height = this.scrollHeight + "px";
	        });
	    },
	
	    onBlur: function onBlur(event) {
	        var inputValue = event.target.value;
	        var required = event.target.required;
	
	        if (!required) {
	            return;
	        }
	
	        !inputValue && $(event.target).toggleClass('isInvalid', true);
	    },
	
	    onSuccess: function onSuccess() {
	        this.$success.css('display', 'block');
	        this.$failure.css('display', 'none');
	        this.$loader.css('display', 'none');
	        this.$button.css('display', 'none');
	        this.$button.toggleClass('isDisabled', false);
	        this.$inputs.toggleClass('isDisabled', true);
	    },
	
	    onFailure: function onFailure() {
	        this.$success.css('display', 'none');
	        this.$failure.css('display', 'block');
	        this.$loader.css('display', 'none');
	        this.$button.css('display', 'block');
	
	        this.$button.toggleClass('isDisabled', false);
	        this.$inputs.toggleClass('isDisabled', false);
	    },
	
	    onSubmit: function onSubmit(event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        var isValid = !this.$button.hasClass('isDisabled');
	
	        if (!isValid) {
	            return;
	        }
	
	        this.$success.css('display', 'none');
	        this.$failure.css('display', 'none');
	        this.$button.toggleClass('isDisabled', true);
	        this.$loader.css('display', 'block');
	        this.$inputs.toggleClass('isDisabled', true);
	
	        var data = {};
	
	        for (var i = 0; i < this.$inputs.length; i++) {
	            var input = this.$inputs[i];
	            var value = input && input.value;
	            var name = input && input.name;
	
	            data[name] = value;
	        }
	
	        $.ajax({
	            url: '/api/application/',
	            type: "POST",
	            data: JSON.stringify(data),
	            contentType: 'application/json',
	            success: this.onSuccess.bind(this),
	            error: this.onFailure.bind(this)
	        });
	    },
	
	    onInput: function onInput(event) {
	        $(event.target).toggleClass('isInvalid', false);
	        var isValid = true;
	
	        for (var i = 0; i < this.$inputs.length; i++) {
	            var input = this.$inputs[i];
	            var required = !!$(input).attr('required');
	
	            if (!required) {
	                continue;
	            }
	
	            var value = input.value;
	
	            if (value) {
	                continue;
	            }
	
	            isValid = false;
	        }
	
	        this.$button.toggleClass('isDisabled', !isValid);
	    },
	
	    onClose: function onClose() {
	        app.views.applicationPopup.deactivate();
	    },
	
	    activate: function activate(options) {
	        _scrollLock2['default'].disablePageScroll();
	
	        $.Velocity.hook(this.$popup, 'opacity', '0');
	        $.Velocity.hook(this.$popup, 'translateY', '-40%');
	        $.Velocity.hook(this.$popup, 'translateX', '-50%');
	
	        this.$el[0].style.display = 'block';
	        this.$overlay[0].style.opacity = 1;
	
	        return $.Velocity.animate(this.$popup, {
	            opacity: [1, 'linear'],
	            translateY: ['-50%', 'easeOutCubic'],
	            translateX: ['-50%', 'easeOutCubic']
	        }, _underscoreUnderscore2['default'].extend({ duration: 500 }, options));
	    },
	
	    deactivate: function deactivate(options) {
	        var self = this;
	        return $.Velocity.animate(this.$popup, {
	            opacity: [0, 'linear'],
	            translateY: ['-40%', 'easeOutCubic'],
	            translateX: ['-50%', 'easeOutCubic']
	        }, _underscoreUnderscore2['default'].extend({
	            duration: 500,
	            complete: function complete() {
	                self.$el[0].style.display = 'none';
	                self.$overlay[0].style.opacity = 0;
	                _scrollLock2['default'].enablePageScroll();
	            }
	        }, options));
	    }
	});
	
	exports['default'] = ApplicationPopup;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["scrollLock"] = factory();
		else
			root["scrollLock"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./src/tools.js
	var argumentAsArray = function argumentAsArray(argument) {
	  return Array.isArray(argument) ? argument : [argument];
	};
	var isElement = function isElement(target) {
	  return target instanceof Node;
	};
	var isElementList = function isElementList(nodeList) {
	  return nodeList instanceof NodeList;
	};
	var eachNode = function eachNode(nodeList, callback) {
	  if (nodeList && callback) {
	    nodeList = isElementList(nodeList) ? nodeList : [nodeList];
	
	    for (var i = 0; i < nodeList.length; i++) {
	      if (callback(nodeList[i], i, nodeList.length) === true) {
	        break;
	      }
	    }
	  }
	};
	var throwError = function throwError(message) {
	  return console.error("[scroll-lock] ".concat(message));
	};
	var arrayAsSelector = function arrayAsSelector(array) {
	  if (Array.isArray(array)) {
	    var selector = array.join(', ');
	    return selector;
	  }
	};
	var nodeListAsArray = function nodeListAsArray(nodeList) {
	  var nodes = [];
	  eachNode(nodeList, function (node) {
	    return nodes.push(node);
	  });
	  return nodes;
	};
	var findParentBySelector = function findParentBySelector($el, selector) {
	  var self = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var $root = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;
	
	  if (self && nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) !== -1) {
	    return $el;
	  }
	
	  while (($el = $el.parentElement) && nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) === -1) {
	    ;
	  }
	
	  return $el;
	};
	var elementHasSelector = function elementHasSelector($el, selector) {
	  var $root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
	  var has = nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) !== -1;
	  return has;
	};
	var elementHasOverflowHidden = function elementHasOverflowHidden($el) {
	  if ($el) {
	    var computedStyle = getComputedStyle($el);
	    var overflowIsHidden = computedStyle.overflow === 'hidden';
	    return overflowIsHidden;
	  }
	};
	var elementScrollTopOnStart = function elementScrollTopOnStart($el) {
	  if ($el) {
	    if (elementHasOverflowHidden($el)) {
	      return true;
	    }
	
	    var scrollTop = $el.scrollTop;
	    return scrollTop <= 0;
	  }
	};
	var elementScrollTopOnEnd = function elementScrollTopOnEnd($el) {
	  if ($el) {
	    if (elementHasOverflowHidden($el)) {
	      return true;
	    }
	
	    var scrollTop = $el.scrollTop;
	    var scrollHeight = $el.scrollHeight;
	    var scrollTopWithHeight = scrollTop + $el.offsetHeight;
	    return scrollTopWithHeight >= scrollHeight;
	  }
	};
	var elementScrollLeftOnStart = function elementScrollLeftOnStart($el) {
	  if ($el) {
	    if (elementHasOverflowHidden($el)) {
	      return true;
	    }
	
	    var scrollLeft = $el.scrollLeft;
	    return scrollLeft <= 0;
	  }
	};
	var elementScrollLeftOnEnd = function elementScrollLeftOnEnd($el) {
	  if ($el) {
	    if (elementHasOverflowHidden($el)) {
	      return true;
	    }
	
	    var scrollLeft = $el.scrollLeft;
	    var scrollWidth = $el.scrollWidth;
	    var scrollLeftWithWidth = scrollLeft + $el.offsetWidth;
	    return scrollLeftWithWidth >= scrollWidth;
	  }
	};
	var elementIsScrollableField = function elementIsScrollableField($el) {
	  var selector = 'textarea, [contenteditable="true"]';
	  return elementHasSelector($el, selector);
	};
	var elementIsInputRange = function elementIsInputRange($el) {
	  var selector = 'input[type="range"]';
	  return elementHasSelector($el, selector);
	};
	// CONCATENATED MODULE: ./src/scroll-lock.js
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disablePageScroll", function() { return disablePageScroll; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enablePageScroll", function() { return enablePageScroll; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getScrollState", function() { return getScrollState; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearQueueScrollLocks", function() { return clearQueueScrollLocks; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTargetScrollBarWidth", function() { return scroll_lock_getTargetScrollBarWidth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentTargetScrollBarWidth", function() { return scroll_lock_getCurrentTargetScrollBarWidth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPageScrollBarWidth", function() { return getPageScrollBarWidth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentPageScrollBarWidth", function() { return getCurrentPageScrollBarWidth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addScrollableTarget", function() { return scroll_lock_addScrollableTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeScrollableTarget", function() { return scroll_lock_removeScrollableTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addScrollableSelector", function() { return scroll_lock_addScrollableSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeScrollableSelector", function() { return scroll_lock_removeScrollableSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLockableTarget", function() { return scroll_lock_addLockableTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLockableSelector", function() { return scroll_lock_addLockableSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFillGapMethod", function() { return scroll_lock_setFillGapMethod; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addFillGapTarget", function() { return scroll_lock_addFillGapTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFillGapTarget", function() { return scroll_lock_removeFillGapTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addFillGapSelector", function() { return scroll_lock_addFillGapSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFillGapSelector", function() { return scroll_lock_removeFillGapSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refillGaps", function() { return refillGaps; });
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	
	var FILL_GAP_AVAILABLE_METHODS = ['padding', 'margin', 'width', 'max-width', 'none'];
	var TOUCH_DIRECTION_DETECT_OFFSET = 3;
	var state = {
	  scroll: true,
	  queue: 0,
	  scrollableSelectors: ['[data-scroll-lock-scrollable]'],
	  lockableSelectors: ['body', '[data-scroll-lock-lockable]'],
	  fillGapSelectors: ['body', '[data-scroll-lock-fill-gap]', '[data-scroll-lock-lockable]'],
	  fillGapMethod: FILL_GAP_AVAILABLE_METHODS[0],
	  //
	  startTouchY: 0,
	  startTouchX: 0
	};
	var disablePageScroll = function disablePageScroll(target) {
	  if (state.queue <= 0) {
	    state.scroll = false;
	    scroll_lock_hideLockableOverflow();
	    fillGaps();
	  }
	
	  scroll_lock_addScrollableTarget(target);
	  state.queue++;
	};
	var enablePageScroll = function enablePageScroll(target) {
	  state.queue > 0 && state.queue--;
	
	  if (state.queue <= 0) {
	    state.scroll = true;
	    scroll_lock_showLockableOverflow();
	    unfillGaps();
	  }
	
	  scroll_lock_removeScrollableTarget(target);
	};
	var getScrollState = function getScrollState() {
	  return state.scroll;
	};
	var clearQueueScrollLocks = function clearQueueScrollLocks() {
	  state.queue = 0;
	};
	var scroll_lock_getTargetScrollBarWidth = function getTargetScrollBarWidth($target) {
	  var onlyExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (isElement($target)) {
	    var currentOverflowYProperty = $target.style.overflowY;
	
	    if (onlyExists) {
	      if (!getScrollState()) {
	        $target.style.overflowY = $target.getAttribute('data-scroll-lock-saved-overflow-y-property');
	      }
	    } else {
	      $target.style.overflowY = 'scroll';
	    }
	
	    var width = scroll_lock_getCurrentTargetScrollBarWidth($target);
	    $target.style.overflowY = currentOverflowYProperty;
	    return width;
	  } else {
	    return 0;
	  }
	};
	var scroll_lock_getCurrentTargetScrollBarWidth = function getCurrentTargetScrollBarWidth($target) {
	  if (isElement($target)) {
	    if ($target === document.body) {
	      var documentWidth = document.documentElement.clientWidth;
	      var windowWidth = window.innerWidth;
	      var currentWidth = windowWidth - documentWidth;
	      return currentWidth;
	    } else {
	      var borderLeftWidthCurrentProperty = $target.style.borderLeftWidth;
	      var borderRightWidthCurrentProperty = $target.style.borderRightWidth;
	      $target.style.borderLeftWidth = '0px';
	      $target.style.borderRightWidth = '0px';
	
	      var _currentWidth = $target.offsetWidth - $target.clientWidth;
	
	      $target.style.borderLeftWidth = borderLeftWidthCurrentProperty;
	      $target.style.borderRightWidth = borderRightWidthCurrentProperty;
	      return _currentWidth;
	    }
	  } else {
	    return 0;
	  }
	};
	var getPageScrollBarWidth = function getPageScrollBarWidth() {
	  var onlyExists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  return scroll_lock_getTargetScrollBarWidth(document.body, onlyExists);
	};
	var getCurrentPageScrollBarWidth = function getCurrentPageScrollBarWidth() {
	  return scroll_lock_getCurrentTargetScrollBarWidth(document.body);
	};
	var scroll_lock_addScrollableTarget = function addScrollableTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.setAttribute('data-scroll-lock-scrollable', '');
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	  }
	};
	var scroll_lock_removeScrollableTarget = function removeScrollableTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.removeAttribute('data-scroll-lock-scrollable');
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	  }
	};
	var scroll_lock_addScrollableSelector = function addScrollableSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      state.scrollableSelectors.push(selector);
	    });
	  }
	};
	var scroll_lock_removeScrollableSelector = function removeScrollableSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      state.scrollableSelectors = state.scrollableSelectors.filter(function (sSelector) {
	        return sSelector !== selector;
	      });
	    });
	  }
	};
	var scroll_lock_addLockableTarget = function addLockableTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.setAttribute('data-scroll-lock-lockable', '');
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	
	    if (!getScrollState()) {
	      scroll_lock_hideLockableOverflow();
	    }
	  }
	};
	var scroll_lock_addLockableSelector = function addLockableSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      state.lockableSelectors.push(selector);
	    });
	
	    if (!getScrollState()) {
	      scroll_lock_hideLockableOverflow();
	    }
	
	    scroll_lock_addFillGapSelector(selector);
	  }
	};
	var scroll_lock_setFillGapMethod = function setFillGapMethod(method) {
	  if (method) {
	    if (FILL_GAP_AVAILABLE_METHODS.indexOf(method) !== -1) {
	      state.fillGapMethod = method;
	      refillGaps();
	    } else {
	      var methods = FILL_GAP_AVAILABLE_METHODS.join(', ');
	      throwError("\"".concat(method, "\" method is not available!\nAvailable fill gap methods: ").concat(methods, "."));
	    }
	  }
	};
	var scroll_lock_addFillGapTarget = function addFillGapTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.setAttribute('data-scroll-lock-fill-gap', '');
	
	          if (!state.scroll) {
	            scroll_lock_fillGapTarget($target);
	          }
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	  }
	};
	var scroll_lock_removeFillGapTarget = function removeFillGapTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.removeAttribute('data-scroll-lock-fill-gap');
	
	          if (!state.scroll) {
	            scroll_lock_unfillGapTarget($target);
	          }
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	  }
	};
	var scroll_lock_addFillGapSelector = function addFillGapSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      if (state.fillGapSelectors.indexOf(selector) === -1) {
	        state.fillGapSelectors.push(selector);
	
	        if (!state.scroll) {
	          scroll_lock_fillGapSelector(selector);
	        }
	      }
	    });
	  }
	};
	var scroll_lock_removeFillGapSelector = function removeFillGapSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      state.fillGapSelectors = state.fillGapSelectors.filter(function (fSelector) {
	        return fSelector !== selector;
	      });
	
	      if (!state.scroll) {
	        scroll_lock_unfillGapSelector(selector);
	      }
	    });
	  }
	};
	var refillGaps = function refillGaps() {
	  if (!state.scroll) {
	    fillGaps();
	  }
	};
	
	var scroll_lock_hideLockableOverflow = function hideLockableOverflow() {
	  var selector = arrayAsSelector(state.lockableSelectors);
	  scroll_lock_hideLockableOverflowSelector(selector);
	};
	
	var scroll_lock_showLockableOverflow = function showLockableOverflow() {
	  var selector = arrayAsSelector(state.lockableSelectors);
	  scroll_lock_showLockableOverflowSelector(selector);
	};
	
	var scroll_lock_hideLockableOverflowSelector = function hideLockableOverflowSelector(selector) {
	  var $targets = document.querySelectorAll(selector);
	  eachNode($targets, function ($target) {
	    scroll_lock_hideLockableOverflowTarget($target);
	  });
	};
	
	var scroll_lock_showLockableOverflowSelector = function showLockableOverflowSelector(selector) {
	  var $targets = document.querySelectorAll(selector);
	  eachNode($targets, function ($target) {
	    scroll_lock_showLockableOverflowTarget($target);
	  });
	};
	
	var scroll_lock_hideLockableOverflowTarget = function hideLockableOverflowTarget($target) {
	  if (isElement($target) && $target.getAttribute('data-scroll-lock-locked') !== 'true') {
	    var computedStyle = window.getComputedStyle($target);
	    $target.setAttribute('data-scroll-lock-saved-overflow-y-property', computedStyle.overflowY);
	    $target.setAttribute('data-scroll-lock-saved-inline-overflow-property', $target.style.overflow);
	    $target.setAttribute('data-scroll-lock-saved-inline-overflow-y-property', $target.style.overflowY);
	    $target.style.overflow = 'hidden';
	    $target.setAttribute('data-scroll-lock-locked', 'true');
	  }
	};
	
	var scroll_lock_showLockableOverflowTarget = function showLockableOverflowTarget($target) {
	  if (isElement($target) && $target.getAttribute('data-scroll-lock-locked') === 'true') {
	    $target.style.overflow = $target.getAttribute('data-scroll-lock-saved-inline-overflow-property');
	    $target.style.overflowY = $target.getAttribute('data-scroll-lock-saved-inline-overflow-y-property');
	    $target.removeAttribute('data-scroll-lock-saved-overflow-property');
	    $target.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
	    $target.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
	    $target.removeAttribute('data-scroll-lock-locked');
	  }
	};
	
	var fillGaps = function fillGaps() {
	  state.fillGapSelectors.map(function (selector) {
	    scroll_lock_fillGapSelector(selector);
	  });
	};
	
	var unfillGaps = function unfillGaps() {
	  state.fillGapSelectors.map(function (selector) {
	    scroll_lock_unfillGapSelector(selector);
	  });
	};
	
	var scroll_lock_fillGapSelector = function fillGapSelector(selector) {
	  var $targets = document.querySelectorAll(selector);
	  var isLockable = state.lockableSelectors.indexOf(selector) !== -1;
	  eachNode($targets, function ($target) {
	    scroll_lock_fillGapTarget($target, isLockable);
	  });
	};
	
	var scroll_lock_fillGapTarget = function fillGapTarget($target) {
	  var isLockable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (isElement($target)) {
	    var scrollBarWidth;
	
	    if ($target.getAttribute('data-scroll-lock-lockable') === '' || isLockable) {
	      scrollBarWidth = scroll_lock_getTargetScrollBarWidth($target, true);
	    } else {
	      var $lockableParent = findParentBySelector($target, arrayAsSelector(state.lockableSelectors));
	      scrollBarWidth = scroll_lock_getTargetScrollBarWidth($lockableParent, true);
	    }
	
	    if ($target.getAttribute('data-scroll-lock-filled-gap') === 'true') {
	      scroll_lock_unfillGapTarget($target);
	    }
	
	    var computedStyle = window.getComputedStyle($target);
	    $target.setAttribute('data-scroll-lock-filled-gap', 'true');
	    $target.setAttribute('data-scroll-lock-current-fill-gap-method', state.fillGapMethod);
	
	    if (state.fillGapMethod === 'margin') {
	      var currentMargin = parseFloat(computedStyle.marginRight);
	      $target.style.marginRight = "".concat(currentMargin + scrollBarWidth, "px");
	    } else if (state.fillGapMethod === 'width') {
	      $target.style.width = "calc(100% - ".concat(scrollBarWidth, "px)");
	    } else if (state.fillGapMethod === 'max-width') {
	      $target.style.maxWidth = "calc(100% - ".concat(scrollBarWidth, "px)");
	    } else if (state.fillGapMethod === 'padding') {
	      var currentPadding = parseFloat(computedStyle.paddingRight);
	      $target.style.paddingRight = "".concat(currentPadding + scrollBarWidth, "px");
	    }
	  }
	};
	
	var scroll_lock_unfillGapSelector = function unfillGapSelector(selector) {
	  var $targets = document.querySelectorAll(selector);
	  eachNode($targets, function ($target) {
	    scroll_lock_unfillGapTarget($target);
	  });
	};
	
	var scroll_lock_unfillGapTarget = function unfillGapTarget($target) {
	  if (isElement($target)) {
	    if ($target.getAttribute('data-scroll-lock-filled-gap') === 'true') {
	      var currentFillGapMethod = $target.getAttribute('data-scroll-lock-current-fill-gap-method');
	      $target.removeAttribute('data-scroll-lock-filled-gap');
	      $target.removeAttribute('data-scroll-lock-current-fill-gap-method');
	
	      if (currentFillGapMethod === 'margin') {
	        $target.style.marginRight = "";
	      } else if (currentFillGapMethod === 'width') {
	        $target.style.width = "";
	      } else if (currentFillGapMethod === 'max-width') {
	        $target.style.maxWidth = "";
	      } else if (currentFillGapMethod === 'padding') {
	        $target.style.paddingRight = "";
	      }
	    }
	  }
	};
	
	var onResize = function onResize(e) {
	  refillGaps();
	};
	
	var onTouchStart = function onTouchStart(e) {
	  if (!state.scroll) {
	    state.startTouchY = e.touches[0].clientY;
	    state.startTouchX = e.touches[0].clientX;
	  }
	};
	
	var scroll_lock_onTouchMove = function onTouchMove(e) {
	  if (!state.scroll) {
	    var startTouchY = state.startTouchY,
	        startTouchX = state.startTouchX;
	    var currentClientY = e.touches[0].clientY;
	    var currentClientX = e.touches[0].clientX;
	
	    if (e.touches.length < 2) {
	      var selector = arrayAsSelector(state.scrollableSelectors);
	      var direction = {
	        up: startTouchY < currentClientY,
	        down: startTouchY > currentClientY,
	        left: startTouchX < currentClientX,
	        right: startTouchX > currentClientX
	      };
	      var directionWithOffset = {
	        up: startTouchY + TOUCH_DIRECTION_DETECT_OFFSET < currentClientY,
	        down: startTouchY - TOUCH_DIRECTION_DETECT_OFFSET > currentClientY,
	        left: startTouchX + TOUCH_DIRECTION_DETECT_OFFSET < currentClientX,
	        right: startTouchX - TOUCH_DIRECTION_DETECT_OFFSET > currentClientX
	      };
	
	      var handle = function handle($el) {
	        var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if ($el) {
	          var parentScrollableEl = findParentBySelector($el, selector, false);
	
	          if (elementIsInputRange($el)) {
	            return false;
	          }
	
	          if (skip || elementIsScrollableField($el) && findParentBySelector($el, selector) || elementHasSelector($el, selector)) {
	            var prevent = false;
	
	            if (elementScrollLeftOnStart($el) && elementScrollLeftOnEnd($el)) {
	              if (direction.up && elementScrollTopOnStart($el) || direction.down && elementScrollTopOnEnd($el)) {
	                prevent = true;
	              }
	            } else if (elementScrollTopOnStart($el) && elementScrollTopOnEnd($el)) {
	              if (direction.left && elementScrollLeftOnStart($el) || direction.right && elementScrollLeftOnEnd($el)) {
	                prevent = true;
	              }
	            } else if (directionWithOffset.up && elementScrollTopOnStart($el) || directionWithOffset.down && elementScrollTopOnEnd($el) || directionWithOffset.left && elementScrollLeftOnStart($el) || directionWithOffset.right && elementScrollLeftOnEnd($el)) {
	              prevent = true;
	            }
	
	            if (prevent) {
	              if (parentScrollableEl) {
	                handle(parentScrollableEl, true);
	              } else {
	                if (e.cancelable) {
	                  e.preventDefault();
	                }
	              }
	            }
	          } else {
	            handle(parentScrollableEl);
	          }
	        } else {
	          if (e.cancelable) {
	            e.preventDefault();
	          }
	        }
	      };
	
	      handle(e.target);
	    }
	  }
	};
	
	var onTouchEnd = function onTouchEnd(e) {
	  if (!state.scroll) {
	    state.startTouchY = 0;
	    state.startTouchX = 0;
	  }
	};
	
	if (typeof window !== 'undefined') {
	  window.addEventListener('resize', onResize);
	}
	
	if (typeof document !== 'undefined') {
	  document.addEventListener('touchstart', onTouchStart);
	  document.addEventListener('touchmove', scroll_lock_onTouchMove, {
	    passive: false
	  });
	  document.addEventListener('touchend', onTouchEnd);
	}
	
	var deprecatedMethods = {
	  hide: function hide(target) {
	    throwError('"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget');
	    disablePageScroll(target);
	  },
	  show: function show(target) {
	    throwError('"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget');
	    enablePageScroll(target);
	  },
	  toggle: function toggle(target) {
	    throwError('"toggle" is deprecated! Do not use it.');
	
	    if (getScrollState()) {
	      disablePageScroll();
	    } else {
	      enablePageScroll(target);
	    }
	  },
	  getState: function getState() {
	    throwError('"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate');
	    return getScrollState();
	  },
	  getWidth: function getWidth() {
	    throwError('"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth');
	    return getPageScrollBarWidth();
	  },
	  getCurrentWidth: function getCurrentWidth() {
	    throwError('"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth');
	    return getCurrentPageScrollBarWidth();
	  },
	  setScrollableTargets: function setScrollableTargets(target) {
	    throwError('"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget');
	    scroll_lock_addScrollableTarget(target);
	  },
	  setFillGapSelectors: function setFillGapSelectors(selector) {
	    throwError('"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector');
	    scroll_lock_addFillGapSelector(selector);
	  },
	  setFillGapTargets: function setFillGapTargets(target) {
	    throwError('"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget');
	    scroll_lock_addFillGapTarget(target);
	  },
	  clearQueue: function clearQueue() {
	    throwError('"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks');
	    clearQueueScrollLocks();
	  }
	};
	
	var scrollLock = _objectSpread({
	  disablePageScroll: disablePageScroll,
	  enablePageScroll: enablePageScroll,
	  getScrollState: getScrollState,
	  clearQueueScrollLocks: clearQueueScrollLocks,
	  getTargetScrollBarWidth: scroll_lock_getTargetScrollBarWidth,
	  getCurrentTargetScrollBarWidth: scroll_lock_getCurrentTargetScrollBarWidth,
	  getPageScrollBarWidth: getPageScrollBarWidth,
	  getCurrentPageScrollBarWidth: getCurrentPageScrollBarWidth,
	  addScrollableSelector: scroll_lock_addScrollableSelector,
	  removeScrollableSelector: scroll_lock_removeScrollableSelector,
	  addScrollableTarget: scroll_lock_addScrollableTarget,
	  removeScrollableTarget: scroll_lock_removeScrollableTarget,
	  addLockableSelector: scroll_lock_addLockableSelector,
	  addLockableTarget: scroll_lock_addLockableTarget,
	  addFillGapSelector: scroll_lock_addFillGapSelector,
	  removeFillGapSelector: scroll_lock_removeFillGapSelector,
	  addFillGapTarget: scroll_lock_addFillGapTarget,
	  removeFillGapTarget: scroll_lock_removeFillGapTarget,
	  setFillGapMethod: scroll_lock_setFillGapMethod,
	  refillGaps: refillGaps,
	  _state: state
	}, deprecatedMethods);
	
	/* harmony default export */ var scroll_lock = __webpack_exports__["default"] = (scrollLock);
	
	/***/ })
	/******/ ])["default"];
	});

/***/ }),
/* 118 */
5,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	__webpack_require__(120);
	
	var _LangsJinja = __webpack_require__(121);
	
	var _LangsJinja2 = _interopRequireDefault(_LangsJinja);
	
	var Langs = _backboneBackbone2['default'].View.extend({
	    el: '.Langs',
	
	    SHIFT: 15,
	
	    initialize: function initialize() {
	        app.vent.on('langs.activate', this.activate);
	
	        this.$links = this.$('.Langs-link');
	    },
	
	    activate: function activate(options) {},
	
	    deactivate: function deactivate(options) {}
	});
	
	exports['default'] = Langs;
	module.exports = exports['default'];

/***/ }),
/* 120 */
5,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Langs.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	output += "<div class=\"Langs\">\n    ";
	var t_1;
	t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"LANGUAGE_CODE");
	frame.set("LANG", t_1, true);
	if(frame.topLevel) {
	context.setVariable("LANG", t_1);
	}
	if(frame.topLevel) {
	context.addExport("LANG", t_1);
	}
	output += "\n\n    <a ";
	if(runtime.contextOrFrameLookup(context, frame, "LANG") == "en") {
	output += "href=\"";
	output += runtime.suppressValue((lineno = 3, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "other_lang"), "other_lang", context, [runtime.contextOrFrameLookup(context, frame, "request"),"offcon"])), env.opts.autoescape);
	;
	}
	output += "\"\n       class=\"Langs-link ";
	if(runtime.contextOrFrameLookup(context, frame, "LANG") == "ru") {
	output += "isActive";
	;
	}
	output += "\">ru</a>\n\n    <a ";
	if(runtime.contextOrFrameLookup(context, frame, "LANG") == "ru") {
	output += "href=\"";
	output += runtime.suppressValue((lineno = 6, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "other_lang"), "other_lang", context, [runtime.contextOrFrameLookup(context, frame, "request"),"offcon"])), env.opts.autoescape);
	;
	}
	output += "\"\n       class=\"Langs-link ";
	if(runtime.contextOrFrameLookup(context, frame, "LANG") == "en") {
	output += "isActive";
	;
	}
	output += "\">en</a>\n</div>";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Langs.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _backboneBackbone = __webpack_require__(2);
	
	var _backboneBackbone2 = _interopRequireDefault(_backboneBackbone);
	
	var _underscoreUnderscore = __webpack_require__(4);
	
	var _underscoreUnderscore2 = _interopRequireDefault(_underscoreUnderscore);
	
	var _frontComponentsBaseViewBaseViewJs = __webpack_require__(16);
	
	var _frontComponentsBaseViewBaseViewJs2 = _interopRequireDefault(_frontComponentsBaseViewBaseViewJs);
	
	__webpack_require__(123);
	
	var _CookieJinja = __webpack_require__(124);
	
	var _CookieJinja2 = _interopRequireDefault(_CookieJinja);
	
	var Cookie = _frontComponentsBaseViewBaseViewJs2['default'].extend({
	    el: '.Cookie',
	    events: {
	        'click .Cookie-button': 'closeCookie'
	    },
	
	    initialize: function initialize(options) {
	        _underscoreUnderscore2['default'].bindAll(this, 'closeCookie', 'deactivate');
	        // this.parent = options.parent
	    },
	
	    closeCookie: function closeCookie() {
	        localStorage.setItem('offcon_cookie', 'true');
	        this.deactivate();
	    },
	
	    activate: function activate() {
	        var isCookieSet = !!localStorage.getItem('offcon_cookie');
	
	        if (isCookieSet) {
	            return;
	        }
	
	        $.Velocity.hook(this.$el, 'opacity', '0');
	        $.Velocity.hook(this.$el, 'translateY', '200px');
	        $.Velocity.hook(this.$el, 'translateX', '-50%');
	        this.$el[0].style.display = 'inline-flex';
	
	        return $.Velocity.animate(this.$el[0], {
	            opacity: [1, 'linear'],
	            translateY: [0, 'easeOutCubic'],
	            translateX: ['-50%']
	        }, _underscoreUnderscore2['default'].extend({ duration: 500, delay: 500 }));
	    },
	
	    deactivate: function deactivate() {
	        var self = this;
	        return $.Velocity.animate(this.$el[0], {
	            opacity: [0, 'linear'],
	            translateY: ['200px', 'easeOutCubic'],
	            translateX: ['-50%']
	        }, _underscoreUnderscore2['default'].extend({
	            duration: 500,
	            complete: function complete() {
	                self.$el[0].css('display', 'none');
	            }
	        }));
	    }
	});
	
	exports['default'] = Cookie;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 123 */
5,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var nunjucks = __webpack_require__(26);
	var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
	var env = new nunjucks.Environment([], { autoescape: true });
	var configure = __webpack_require__(27)(env);
	
	
	
	
	var shim = __webpack_require__(28);
	(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Cookie.jinja"] = (function() {
	function root(env, context, frame, runtime, cb) {
	var lineno = null;
	var colno = null;
	var output = "";
	try {
	var parentTemplate = null;
	output += " <div class=\"Cookie\">\n    <span>";
	output += runtime.suppressValue((lineno = 1, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Мы собираем cookie и другие данные в рамках"])), env.opts.autoescape);
	output += " <a href=\"/static/pdf/privacy-policy.pdf\" target=\"_blank\" rel=\"nofollow noopener noreferrer\">";
	output += runtime.suppressValue((lineno = 1, colno = 155, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["политики конфиденциальности"])), env.opts.autoescape);
	output += ".</a></span>\n     <button class=\"Cookie-button BtnLoad u-Btn\">";
	output += runtime.suppressValue((lineno = 2, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Согласиться"])), env.opts.autoescape);
	output += "</button>\n </div>\n";
	if(parentTemplate) {
	parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
	} else {
	cb(null, output);
	}
	;
	} catch (e) {
	  cb(runtime.handleError(e, lineno, colno));
	}
	}
	return {
	root: root
	};
	
	})();
	})();
	
	var obj = nunjucks.nunjucksPrecompiled["Cookie.jinja"]
	module.exports = shim(nunjucks, env, obj, dependencies)

/***/ })
]);


// WEBPACK FOOTER //
// app.164e6538.js